var fc = Object.defineProperty, hc = Object.defineProperties;
var vc = Object.getOwnPropertyDescriptors;
var Br = Object.getOwnPropertySymbols;
var Aa = Object.prototype.hasOwnProperty, Da = Object.prototype.propertyIsEnumerable;
var Oa = (e, t, r) => t in e ? fc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, kt = (e, t) => {
  for (var r in t || (t = {}))
    Aa.call(t, r) && Oa(e, r, t[r]);
  if (Br)
    for (var r of Br(t))
      Da.call(t, r) && Oa(e, r, t[r]);
  return e;
}, Mr = (e, t) => hc(e, vc(t));
var Jn = (e) => typeof e == "symbol" ? e : e + "", La = (e, t) => {
  var r = {};
  for (var n in e)
    Aa.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && Br)
    for (var n of Br(e))
      t.indexOf(n) < 0 && Da.call(e, n) && (r[n] = e[n]);
  return r;
};
import * as h from "react";
import ke, { useRef as ss, useDebugValue as Ba, createElement as pc, useContext as gc, useEffect as mc, useState as Jo } from "react";
import * as bc from "react-dom";
function yc(e, t) {
  for (var r = 0; r < t.length; r++) {
    const n = t[r];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const o in n)
        if (o !== "default" && !(o in e)) {
          const a = Object.getOwnPropertyDescriptor(n, o);
          a && Object.defineProperty(e, o, a.get ? a : {
            enumerable: !0,
            get: () => n[o]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
function _c(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var wo = { exports: {} }, qt = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Zn, Ma;
function ls() {
  if (Ma)
    return Zn;
  Ma = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(i).map(function(u) {
        return i[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch (u) {
      return !1;
    }
  }
  return Zn = o() ? Object.assign : function(a, i) {
    for (var s, l = n(a), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        t.call(s, d) && (l[d] = s[d]);
      if (e) {
        c = e(s);
        for (var f = 0; f < c.length; f++)
          r.call(s, c[f]) && (l[c[f]] = s[c[f]]);
      }
    }
    return l;
  }, Zn;
}
/** @license React v17.0.1
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ja;
function xc() {
  if (ja)
    return qt;
  ja = 1, ls();
  var e = ke, t = 60103;
  if (qt.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    t = r("react.element"), qt.Fragment = r("react.fragment");
  }
  var n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(s, l, c) {
    var u, d = {}, f = null, p = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (u in l)
      o.call(l, u) && !a.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: f, ref: p, props: d, _owner: n.current };
  }
  return qt.jsx = i, qt.jsxs = i, qt;
}
var eo = {};
/** @license React v17.0.1
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fa;
function Cc() {
  return Fa || (Fa = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = ke, r = ls(), n = 60103, o = 60106;
      e.Fragment = 60107;
      var a = 60108, i = 60114, s = 60109, l = 60110, c = 60112, u = 60113, d = 60120, f = 60115, p = 60116, g = 60121, b = 60122, x = 60117, m = 60129, y = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var C = Symbol.for;
        n = C("react.element"), o = C("react.portal"), e.Fragment = C("react.fragment"), a = C("react.strict_mode"), i = C("react.profiler"), s = C("react.provider"), l = C("react.context"), c = C("react.forward_ref"), u = C("react.suspense"), d = C("react.suspense_list"), f = C("react.memo"), p = C("react.lazy"), g = C("react.block"), b = C("react.server.block"), x = C("react.fundamental"), C("react.scope"), C("react.opaque.id"), m = C("react.debug_trace_mode"), C("react.offscreen"), y = C("react.legacy_hidden");
      }
      var E = typeof Symbol == "function" && Symbol.iterator, k = "@@iterator";
      function S(v) {
        if (v === null || typeof v != "object")
          return null;
        var T = E && v[E] || v[k];
        return typeof T == "function" ? T : null;
      }
      var _ = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function P(v) {
        {
          for (var T = arguments.length, N = new Array(T > 1 ? T - 1 : 0), j = 1; j < T; j++)
            N[j - 1] = arguments[j];
          D("error", v, N);
        }
      }
      function D(v, T, N) {
        {
          var j = _.ReactDebugCurrentFrame, te = j.getStackAddendum();
          te !== "" && (T += "%s", N = N.concat([te]));
          var re = N.map(function(U) {
            return "" + U;
          });
          re.unshift("Warning: " + T), Function.prototype.apply.call(console[v], console, re);
        }
      }
      var z = !1;
      function q(v) {
        return !!(typeof v == "string" || typeof v == "function" || v === e.Fragment || v === i || v === m || v === a || v === u || v === d || v === y || z || typeof v == "object" && v !== null && (v.$$typeof === p || v.$$typeof === f || v.$$typeof === s || v.$$typeof === l || v.$$typeof === c || v.$$typeof === x || v.$$typeof === g || v[0] === b));
      }
      function I(v, T, N) {
        var j = T.displayName || T.name || "";
        return v.displayName || (j !== "" ? N + "(" + j + ")" : N);
      }
      function R(v) {
        return v.displayName || "Context";
      }
      function L(v) {
        if (v == null)
          return null;
        if (typeof v.tag == "number" && P("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof v == "function")
          return v.displayName || v.name || null;
        if (typeof v == "string")
          return v;
        switch (v) {
          case e.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case i:
            return "Profiler";
          case a:
            return "StrictMode";
          case u:
            return "Suspense";
          case d:
            return "SuspenseList";
        }
        if (typeof v == "object")
          switch (v.$$typeof) {
            case l:
              var T = v;
              return R(T) + ".Consumer";
            case s:
              var N = v;
              return R(N._context) + ".Provider";
            case c:
              return I(v, v.render, "ForwardRef");
            case f:
              return L(v.type);
            case g:
              return L(v._render);
            case p: {
              var j = v, te = j._payload, re = j._init;
              try {
                return L(re(te));
              } catch (U) {
                return null;
              }
            }
          }
        return null;
      }
      var M = 0, $, G, be, Y, Q, ye, fe;
      function et() {
      }
      et.__reactDisabledLog = !0;
      function oe() {
        {
          if (M === 0) {
            $ = console.log, G = console.info, be = console.warn, Y = console.error, Q = console.group, ye = console.groupCollapsed, fe = console.groupEnd;
            var v = {
              configurable: !0,
              enumerable: !0,
              value: et,
              writable: !0
            };
            Object.defineProperties(console, {
              info: v,
              log: v,
              warn: v,
              error: v,
              group: v,
              groupCollapsed: v,
              groupEnd: v
            });
          }
          M++;
        }
      }
      function at() {
        {
          if (M--, M === 0) {
            var v = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, v, {
                value: $
              }),
              info: r({}, v, {
                value: G
              }),
              warn: r({}, v, {
                value: be
              }),
              error: r({}, v, {
                value: Y
              }),
              group: r({}, v, {
                value: Q
              }),
              groupCollapsed: r({}, v, {
                value: ye
              }),
              groupEnd: r({}, v, {
                value: fe
              })
            });
          }
          M < 0 && P("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var De = _.ReactCurrentDispatcher, Ge;
      function Ne(v, T, N) {
        {
          if (Ge === void 0)
            try {
              throw Error();
            } catch (te) {
              var j = te.stack.trim().match(/\n( *(at )?)/);
              Ge = j && j[1] || "";
            }
          return `
` + Ge + v;
        }
      }
      var Pe = !1, Fe;
      {
        var O = typeof WeakMap == "function" ? WeakMap : Map;
        Fe = new O();
      }
      function _e(v, T) {
        if (!v || Pe)
          return "";
        {
          var N = Fe.get(v);
          if (N !== void 0)
            return N;
        }
        var j;
        Pe = !0;
        var te = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var re;
        re = De.current, De.current = null, oe();
        try {
          if (T) {
            var U = function() {
              throw Error();
            };
            if (Object.defineProperty(U.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(U, []);
              } catch (ht) {
                j = ht;
              }
              Reflect.construct(v, [], U);
            } else {
              try {
                U.call();
              } catch (ht) {
                j = ht;
              }
              v.call(U.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (ht) {
              j = ht;
            }
            v();
          }
        } catch (ht) {
          if (ht && j && typeof ht.stack == "string") {
            for (var W = ht.stack.split(`
`), Ie = j.stack.split(`
`), he = W.length - 1, ve = Ie.length - 1; he >= 1 && ve >= 0 && W[he] !== Ie[ve]; )
              ve--;
            for (; he >= 1 && ve >= 0; he--, ve--)
              if (W[he] !== Ie[ve]) {
                if (he !== 1 || ve !== 1)
                  do
                    if (he--, ve--, ve < 0 || W[he] !== Ie[ve]) {
                      var ft = `
` + W[he].replace(" at new ", " at ");
                      return typeof v == "function" && Fe.set(v, ft), ft;
                    }
                  while (he >= 1 && ve >= 0);
                break;
              }
          }
        } finally {
          Pe = !1, De.current = re, at(), Error.prepareStackTrace = te;
        }
        var Ut = v ? v.displayName || v.name : "", Ia = Ut ? Ne(Ut) : "";
        return typeof v == "function" && Fe.set(v, Ia), Ia;
      }
      function He(v, T, N) {
        return _e(v, !1);
      }
      function Vt(v) {
        var T = v.prototype;
        return !!(T && T.isReactComponent);
      }
      function zt(v, T, N) {
        if (v == null)
          return "";
        if (typeof v == "function")
          return _e(v, Vt(v));
        if (typeof v == "string")
          return Ne(v);
        switch (v) {
          case u:
            return Ne("Suspense");
          case d:
            return Ne("SuspenseList");
        }
        if (typeof v == "object")
          switch (v.$$typeof) {
            case c:
              return He(v.render);
            case f:
              return zt(v.type, T, N);
            case g:
              return He(v._render);
            case p: {
              var j = v, te = j._payload, re = j._init;
              try {
                return zt(re(te), T, N);
              } catch (U) {
              }
            }
          }
        return "";
      }
      var Dr = {}, Ca = _.ReactDebugCurrentFrame;
      function Lr(v) {
        if (v) {
          var T = v._owner, N = zt(v.type, v._source, T ? T.type : null);
          Ca.setExtraStackFrame(N);
        } else
          Ca.setExtraStackFrame(null);
      }
      function Kl(v, T, N, j, te) {
        {
          var re = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var U in v)
            if (re(v, U)) {
              var W = void 0;
              try {
                if (typeof v[U] != "function") {
                  var Ie = Error((j || "React class") + ": " + N + " type `" + U + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof v[U] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Ie.name = "Invariant Violation", Ie;
                }
                W = v[U](T, U, j, N, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (he) {
                W = he;
              }
              W && !(W instanceof Error) && (Lr(te), P("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", j || "React class", N, U, typeof W), Lr(null)), W instanceof Error && !(W.message in Dr) && (Dr[W.message] = !0, Lr(te), P("Failed %s type: %s", N, W.message), Lr(null));
            }
        }
      }
      var pr = _.ReactCurrentOwner, Gn = Object.prototype.hasOwnProperty, Xl = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ea, wa, Yn;
      Yn = {};
      function Ql(v) {
        if (Gn.call(v, "ref")) {
          var T = Object.getOwnPropertyDescriptor(v, "ref").get;
          if (T && T.isReactWarning)
            return !1;
        }
        return v.ref !== void 0;
      }
      function Jl(v) {
        if (Gn.call(v, "key")) {
          var T = Object.getOwnPropertyDescriptor(v, "key").get;
          if (T && T.isReactWarning)
            return !1;
        }
        return v.key !== void 0;
      }
      function Zl(v, T) {
        if (typeof v.ref == "string" && pr.current && T && pr.current.stateNode !== T) {
          var N = L(pr.current.type);
          Yn[N] || (P('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', L(pr.current.type), v.ref), Yn[N] = !0);
        }
      }
      function ec(v, T) {
        {
          var N = function() {
            Ea || (Ea = !0, P("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", T));
          };
          N.isReactWarning = !0, Object.defineProperty(v, "key", {
            get: N,
            configurable: !0
          });
        }
      }
      function tc(v, T) {
        {
          var N = function() {
            wa || (wa = !0, P("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", T));
          };
          N.isReactWarning = !0, Object.defineProperty(v, "ref", {
            get: N,
            configurable: !0
          });
        }
      }
      var rc = function(v, T, N, j, te, re, U) {
        var W = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: v,
          key: T,
          ref: N,
          props: U,
          // Record the component responsible for creating this element.
          _owner: re
        };
        return W._store = {}, Object.defineProperty(W._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(W, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: j
        }), Object.defineProperty(W, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: te
        }), Object.freeze && (Object.freeze(W.props), Object.freeze(W)), W;
      };
      function nc(v, T, N, j, te) {
        {
          var re, U = {}, W = null, Ie = null;
          N !== void 0 && (W = "" + N), Jl(T) && (W = "" + T.key), Ql(T) && (Ie = T.ref, Zl(T, te));
          for (re in T)
            Gn.call(T, re) && !Xl.hasOwnProperty(re) && (U[re] = T[re]);
          if (v && v.defaultProps) {
            var he = v.defaultProps;
            for (re in he)
              U[re] === void 0 && (U[re] = he[re]);
          }
          if (W || Ie) {
            var ve = typeof v == "function" ? v.displayName || v.name || "Unknown" : v;
            W && ec(U, ve), Ie && tc(U, ve);
          }
          return rc(v, W, Ie, te, j, pr.current, U);
        }
      }
      var Kn = _.ReactCurrentOwner, Sa = _.ReactDebugCurrentFrame;
      function Wt(v) {
        if (v) {
          var T = v._owner, N = zt(v.type, v._source, T ? T.type : null);
          Sa.setExtraStackFrame(N);
        } else
          Sa.setExtraStackFrame(null);
      }
      var Xn;
      Xn = !1;
      function Qn(v) {
        return typeof v == "object" && v !== null && v.$$typeof === n;
      }
      function ka() {
        {
          if (Kn.current) {
            var v = L(Kn.current.type);
            if (v)
              return `

Check the render method of \`` + v + "`.";
          }
          return "";
        }
      }
      function oc(v) {
        {
          if (v !== void 0) {
            var T = v.fileName.replace(/^.*[\\\/]/, ""), N = v.lineNumber;
            return `

Check your code at ` + T + ":" + N + ".";
          }
          return "";
        }
      }
      var Ta = {};
      function ac(v) {
        {
          var T = ka();
          if (!T) {
            var N = typeof v == "string" ? v : v.displayName || v.name;
            N && (T = `

Check the top-level render call using <` + N + ">.");
          }
          return T;
        }
      }
      function Ra(v, T) {
        {
          if (!v._store || v._store.validated || v.key != null)
            return;
          v._store.validated = !0;
          var N = ac(T);
          if (Ta[N])
            return;
          Ta[N] = !0;
          var j = "";
          v && v._owner && v._owner !== Kn.current && (j = " It was passed a child from " + L(v._owner.type) + "."), Wt(v), P('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', N, j), Wt(null);
        }
      }
      function Na(v, T) {
        {
          if (typeof v != "object")
            return;
          if (Array.isArray(v))
            for (var N = 0; N < v.length; N++) {
              var j = v[N];
              Qn(j) && Ra(j, T);
            }
          else if (Qn(v))
            v._store && (v._store.validated = !0);
          else if (v) {
            var te = S(v);
            if (typeof te == "function" && te !== v.entries)
              for (var re = te.call(v), U; !(U = re.next()).done; )
                Qn(U.value) && Ra(U.value, T);
          }
        }
      }
      function ic(v) {
        {
          var T = v.type;
          if (T == null || typeof T == "string")
            return;
          var N;
          if (typeof T == "function")
            N = T.propTypes;
          else if (typeof T == "object" && (T.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          T.$$typeof === f))
            N = T.propTypes;
          else
            return;
          if (N) {
            var j = L(T);
            Kl(N, v.props, "prop", j, v);
          } else if (T.PropTypes !== void 0 && !Xn) {
            Xn = !0;
            var te = L(T);
            P("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", te || "Unknown");
          }
          typeof T.getDefaultProps == "function" && !T.getDefaultProps.isReactClassApproved && P("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function sc(v) {
        {
          for (var T = Object.keys(v.props), N = 0; N < T.length; N++) {
            var j = T[N];
            if (j !== "children" && j !== "key") {
              Wt(v), P("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", j), Wt(null);
              break;
            }
          }
          v.ref !== null && (Wt(v), P("Invalid attribute `ref` supplied to `React.Fragment`."), Wt(null));
        }
      }
      function Pa(v, T, N, j, te, re) {
        {
          var U = q(v);
          if (!U) {
            var W = "";
            (v === void 0 || typeof v == "object" && v !== null && Object.keys(v).length === 0) && (W += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Ie = oc(te);
            Ie ? W += Ie : W += ka();
            var he;
            v === null ? he = "null" : Array.isArray(v) ? he = "array" : v !== void 0 && v.$$typeof === n ? (he = "<" + (L(v.type) || "Unknown") + " />", W = " Did you accidentally export a JSX literal instead of a component?") : he = typeof v, P("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", he, W);
          }
          var ve = nc(v, T, N, te, re);
          if (ve == null)
            return ve;
          if (U) {
            var ft = T.children;
            if (ft !== void 0)
              if (j)
                if (Array.isArray(ft)) {
                  for (var Ut = 0; Ut < ft.length; Ut++)
                    Na(ft[Ut], v);
                  Object.freeze && Object.freeze(ft);
                } else
                  P("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Na(ft, v);
          }
          return v === e.Fragment ? sc(ve) : ic(ve), ve;
        }
      }
      function lc(v, T, N) {
        return Pa(v, T, N, !0);
      }
      function cc(v, T, N) {
        return Pa(v, T, N, !1);
      }
      var uc = cc, dc = lc;
      e.jsx = uc, e.jsxs = dc;
    }();
  }(eo)), eo;
}
process.env.NODE_ENV === "production" ? wo.exports = xc() : wo.exports = Cc();
var B = wo.exports;
const Ec = /* @__PURE__ */ _c(B), wc = /* @__PURE__ */ yc({
  __proto__: null,
  default: Ec
}, [B]);
var Me = function() {
  return Me = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, Me.apply(this, arguments);
};
function rr(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, o = t.length, a; n < o; n++)
      (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function Sc(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var kc = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Tc = /* @__PURE__ */ Sc(
  function(e) {
    return kc.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), se = "-ms-", br = "-moz-", K = "-webkit-", cs = "comm", Pn = "rule", Zo = "decl", Rc = "@import", us = "@keyframes", Nc = "@layer", ds = Math.abs, ea = String.fromCharCode, So = Object.assign;
function Pc(e, t) {
  return we(e, 0) ^ 45 ? (((t << 2 ^ we(e, 0)) << 2 ^ we(e, 1)) << 2 ^ we(e, 2)) << 2 ^ we(e, 3) : 0;
}
function fs(e) {
  return e.trim();
}
function vt(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function F(e, t, r) {
  return e.replace(t, r);
}
function Xr(e, t, r) {
  return e.indexOf(t, r);
}
function we(e, t) {
  return e.charCodeAt(t) | 0;
}
function nr(e, t, r) {
  return e.slice(t, r);
}
function st(e) {
  return e.length;
}
function hs(e) {
  return e.length;
}
function mr(e, t) {
  return t.push(e), e;
}
function Ic(e, t) {
  return e.map(t).join("");
}
function Ha(e, t) {
  return e.filter(function(r) {
    return !vt(r, t);
  });
}
var In = 1, or = 1, vs = 0, Xe = 0, pe = 0, ur = "";
function On(e, t, r, n, o, a, i, s) {
  return { value: e, root: t, parent: r, type: n, props: o, children: a, line: In, column: or, length: i, return: "", siblings: s };
}
function yt(e, t) {
  return So(On("", null, null, "", null, null, 0, e.siblings), e, { length: -e.length }, t);
}
function Gt(e) {
  for (; e.root; )
    e = yt(e.root, { children: [e] });
  mr(e, e.siblings);
}
function Oc() {
  return pe;
}
function Ac() {
  return pe = Xe > 0 ? we(ur, --Xe) : 0, or--, pe === 10 && (or = 1, In--), pe;
}
function nt() {
  return pe = Xe < vs ? we(ur, Xe++) : 0, or++, pe === 10 && (or = 1, In++), pe;
}
function Lt() {
  return we(ur, Xe);
}
function Qr() {
  return Xe;
}
function An(e, t) {
  return nr(ur, e, t);
}
function ko(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Dc(e) {
  return In = or = 1, vs = st(ur = e), Xe = 0, [];
}
function Lc(e) {
  return ur = "", e;
}
function to(e) {
  return fs(An(Xe - 1, To(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Bc(e) {
  for (; (pe = Lt()) && pe < 33; )
    nt();
  return ko(e) > 2 || ko(pe) > 3 ? "" : " ";
}
function Mc(e, t) {
  for (; --t && nt() && !(pe < 48 || pe > 102 || pe > 57 && pe < 65 || pe > 70 && pe < 97); )
    ;
  return An(e, Qr() + (t < 6 && Lt() == 32 && nt() == 32));
}
function To(e) {
  for (; nt(); )
    switch (pe) {
      case e:
        return Xe;
      case 34:
      case 39:
        e !== 34 && e !== 39 && To(pe);
        break;
      case 40:
        e === 41 && To(e);
        break;
      case 92:
        nt();
        break;
    }
  return Xe;
}
function jc(e, t) {
  for (; nt() && e + pe !== 57; )
    if (e + pe === 84 && Lt() === 47)
      break;
  return "/*" + An(t, Xe - 1) + "*" + ea(e === 47 ? e : nt());
}
function Fc(e) {
  for (; !ko(Lt()); )
    nt();
  return An(e, Xe);
}
function Hc(e) {
  return Lc(Jr("", null, null, null, [""], e = Dc(e), 0, [0], e));
}
function Jr(e, t, r, n, o, a, i, s, l) {
  for (var c = 0, u = 0, d = i, f = 0, p = 0, g = 0, b = 1, x = 1, m = 1, y = 0, C = "", E = o, k = a, S = n, _ = C; x; )
    switch (g = y, y = nt()) {
      case 40:
        if (g != 108 && we(_, d - 1) == 58) {
          Xr(_ += F(to(y), "&", "&\f"), "&\f", ds(c ? s[c - 1] : 0)) != -1 && (m = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        _ += to(y);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        _ += Bc(g);
        break;
      case 92:
        _ += Mc(Qr() - 1, 7);
        continue;
      case 47:
        switch (Lt()) {
          case 42:
          case 47:
            mr($c(jc(nt(), Qr()), t, r, l), l);
            break;
          default:
            _ += "/";
        }
        break;
      case 123 * b:
        s[c++] = st(_) * m;
      case 125 * b:
      case 59:
      case 0:
        switch (y) {
          case 0:
          case 125:
            x = 0;
          case 59 + u:
            m == -1 && (_ = F(_, /\f/g, "")), p > 0 && st(_) - d && mr(p > 32 ? Va(_ + ";", n, r, d - 1, l) : Va(F(_, " ", "") + ";", n, r, d - 2, l), l);
            break;
          case 59:
            _ += ";";
          default:
            if (mr(S = $a(_, t, r, c, u, o, s, C, E = [], k = [], d, a), a), y === 123)
              if (u === 0)
                Jr(_, t, S, S, E, a, d, s, k);
              else
                switch (f === 99 && we(_, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Jr(e, S, S, n && mr($a(e, S, S, 0, 0, o, s, C, o, E = [], d, k), k), o, k, d, s, n ? E : k);
                    break;
                  default:
                    Jr(_, S, S, S, [""], k, 0, s, k);
                }
        }
        c = u = p = 0, b = m = 1, C = _ = "", d = i;
        break;
      case 58:
        d = 1 + st(_), p = g;
      default:
        if (b < 1) {
          if (y == 123)
            --b;
          else if (y == 125 && b++ == 0 && Ac() == 125)
            continue;
        }
        switch (_ += ea(y), y * b) {
          case 38:
            m = u > 0 ? 1 : (_ += "\f", -1);
            break;
          case 44:
            s[c++] = (st(_) - 1) * m, m = 1;
            break;
          case 64:
            Lt() === 45 && (_ += to(nt())), f = Lt(), u = d = st(C = _ += Fc(Qr())), y++;
            break;
          case 45:
            g === 45 && st(_) == 2 && (b = 0);
        }
    }
  return a;
}
function $a(e, t, r, n, o, a, i, s, l, c, u, d) {
  for (var f = o - 1, p = o === 0 ? a : [""], g = hs(p), b = 0, x = 0, m = 0; b < n; ++b)
    for (var y = 0, C = nr(e, f + 1, f = ds(x = i[b])), E = e; y < g; ++y)
      (E = fs(x > 0 ? p[y] + " " + C : F(C, /&\f/g, p[y]))) && (l[m++] = E);
  return On(e, t, r, o === 0 ? Pn : s, l, c, u, d);
}
function $c(e, t, r, n) {
  return On(e, t, r, cs, ea(Oc()), nr(e, 2, -2), 0, n);
}
function Va(e, t, r, n, o) {
  return On(e, t, r, Zo, nr(e, 0, n), nr(e, n + 1, -1), n, o);
}
function ps(e, t, r) {
  switch (Pc(e, t)) {
    case 5103:
      return K + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return K + e + e;
    case 4789:
      return br + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return K + e + br + e + se + e + e;
    case 5936:
      switch (we(e, t + 11)) {
        case 114:
          return K + e + se + F(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return K + e + se + F(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return K + e + se + F(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
    case 6828:
    case 4268:
    case 2903:
      return K + e + se + e + e;
    case 6165:
      return K + e + se + "flex-" + e + e;
    case 5187:
      return K + e + F(e, /(\w+).+(:[^]+)/, K + "box-$1$2" + se + "flex-$1$2") + e;
    case 5443:
      return K + e + se + "flex-item-" + F(e, /flex-|-self/g, "") + (vt(e, /flex-|baseline/) ? "" : se + "grid-row-" + F(e, /flex-|-self/g, "")) + e;
    case 4675:
      return K + e + se + "flex-line-pack" + F(e, /align-content|flex-|-self/g, "") + e;
    case 5548:
      return K + e + se + F(e, "shrink", "negative") + e;
    case 5292:
      return K + e + se + F(e, "basis", "preferred-size") + e;
    case 6060:
      return K + "box-" + F(e, "-grow", "") + K + e + se + F(e, "grow", "positive") + e;
    case 4554:
      return K + F(e, /([^-])(transform)/g, "$1" + K + "$2") + e;
    case 6187:
      return F(F(F(e, /(zoom-|grab)/, K + "$1"), /(image-set)/, K + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return F(e, /(image-set\([^]*)/, K + "$1$`$1");
    case 4968:
      return F(F(e, /(.+:)(flex-)?(.*)/, K + "box-pack:$3" + se + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + K + e + e;
    case 4200:
      if (!vt(e, /flex-|baseline/))
        return se + "grid-column-align" + nr(e, t) + e;
      break;
    case 2592:
    case 3360:
      return se + F(e, "template-", "") + e;
    case 4384:
    case 3616:
      return r && r.some(function(n, o) {
        return t = o, vt(n.props, /grid-\w+-end/);
      }) ? ~Xr(e + (r = r[t].value), "span", 0) ? e : se + F(e, "-start", "") + e + se + "grid-row-span:" + (~Xr(r, "span", 0) ? vt(r, /\d+/) : +vt(r, /\d+/) - +vt(e, /\d+/)) + ";" : se + F(e, "-start", "") + e;
    case 4896:
    case 4128:
      return r && r.some(function(n) {
        return vt(n.props, /grid-\w+-start/);
      }) ? e : se + F(F(e, "-end", "-span"), "span ", "") + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return F(e, /(.+)-inline(.+)/, K + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (st(e) - 1 - t > 6)
        switch (we(e, t + 1)) {
          case 109:
            if (we(e, t + 4) !== 45)
              break;
          case 102:
            return F(e, /(.+:)(.+)-([^]+)/, "$1" + K + "$2-$3$1" + br + (we(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~Xr(e, "stretch", 0) ? ps(F(e, "stretch", "fill-available"), t, r) + e : e;
        }
      break;
    case 5152:
    case 5920:
      return F(e, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(n, o, a, i, s, l, c) {
        return se + o + ":" + a + c + (i ? se + o + "-span:" + (s ? l : +l - +a) + c : "") + e;
      });
    case 4949:
      if (we(e, t + 6) === 121)
        return F(e, ":", ":" + K) + e;
      break;
    case 6444:
      switch (we(e, we(e, 14) === 45 ? 18 : 11)) {
        case 120:
          return F(e, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + K + (we(e, 14) === 45 ? "inline-" : "") + "box$3$1" + K + "$2$3$1" + se + "$2box$3") + e;
        case 100:
          return F(e, ":", ":" + se) + e;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return F(e, "scroll-", "scroll-snap-") + e;
  }
  return e;
}
function cn(e, t) {
  for (var r = "", n = 0; n < e.length; n++)
    r += t(e[n], n, e, t) || "";
  return r;
}
function Vc(e, t, r, n) {
  switch (e.type) {
    case Nc:
      if (e.children.length)
        break;
    case Rc:
    case Zo:
      return e.return = e.return || e.value;
    case cs:
      return "";
    case us:
      return e.return = e.value + "{" + cn(e.children, n) + "}";
    case Pn:
      if (!st(e.value = e.props.join(",")))
        return "";
  }
  return st(r = cn(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function zc(e) {
  var t = hs(e);
  return function(r, n, o, a) {
    for (var i = "", s = 0; s < t; s++)
      i += e[s](r, n, o, a) || "";
    return i;
  };
}
function Wc(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function Uc(e, t, r, n) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case Zo:
        e.return = ps(e.value, e.length, r);
        return;
      case us:
        return cn([yt(e, { value: F(e.value, "@", "@" + K) })], n);
      case Pn:
        if (e.length)
          return Ic(r = e.props, function(o) {
            switch (vt(o, n = /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                Gt(yt(e, { props: [F(o, /:(read-\w+)/, ":" + br + "$1")] })), Gt(yt(e, { props: [o] })), So(e, { props: Ha(r, n) });
                break;
              case "::placeholder":
                Gt(yt(e, { props: [F(o, /:(plac\w+)/, ":" + K + "input-$1")] })), Gt(yt(e, { props: [F(o, /:(plac\w+)/, ":" + br + "$1")] })), Gt(yt(e, { props: [F(o, /:(plac\w+)/, se + "input-$1")] })), Gt(yt(e, { props: [o] })), So(e, { props: Ha(r, n) });
                break;
            }
            return "";
          });
    }
}
var qc = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, jt = typeof process != "undefined" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", gs = "active", ms = "data-styled-version", Dn = "6.1.8", ta = `/*!sc*/
`, ra = typeof window != "undefined" && "HTMLElement" in window, Gc = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process != "undefined" && process.env !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process != "undefined" && process.env !== void 0 && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), za = /invalid hook call/i, jr = /* @__PURE__ */ new Set(), Yc = function(e, t) {
  if (process.env.NODE_ENV !== "production") {
    var r = t ? ' with the id of "'.concat(t, '"') : "", n = "The component ".concat(e).concat(r, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, o = console.error;
    try {
      var a = !0;
      console.error = function(i) {
        for (var s = [], l = 1; l < arguments.length; l++)
          s[l - 1] = arguments[l];
        za.test(i) ? (a = !1, jr.delete(n)) : o.apply(void 0, rr([i], s, !1));
      }, ss(), a && !jr.has(n) && (console.warn(n), jr.add(n));
    } catch (i) {
      za.test(i.message) && jr.delete(n);
    } finally {
      console.error = o;
    }
  }
}, Ln = Object.freeze([]), ar = Object.freeze({});
function Kc(e, t, r) {
  return r === void 0 && (r = ar), e.theme !== r.theme && e.theme || t || r.theme;
}
var Ro = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), Xc = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, Qc = /(^-|-$)/g;
function Wa(e) {
  return e.replace(Xc, "-").replace(Qc, "");
}
var Jc = /(a)(d)/gi, Fr = 52, Ua = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function No(e) {
  var t, r = "";
  for (t = Math.abs(e); t > Fr; t = t / Fr | 0)
    r = Ua(t % Fr) + r;
  return (Ua(t % Fr) + r).replace(Jc, "$1-$2");
}
var ro, bs = 5381, Nt = function(e, t) {
  for (var r = t.length; r; )
    e = 33 * e ^ t.charCodeAt(--r);
  return e;
}, ys = function(e) {
  return Nt(bs, e);
};
function Zc(e) {
  return No(ys(e) >>> 0);
}
function _s(e) {
  return process.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function no(e) {
  return typeof e == "string" && (process.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var xs = typeof Symbol == "function" && Symbol.for, Cs = xs ? Symbol.for("react.memo") : 60115, eu = xs ? Symbol.for("react.forward_ref") : 60112, tu = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, ru = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, Es = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, nu = ((ro = {})[eu] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, ro[Cs] = Es, ro);
function qa(e) {
  return ("type" in (t = e) && t.type.$$typeof) === Cs ? Es : "$$typeof" in e ? nu[e.$$typeof] : tu;
  var t;
}
var ou = Object.defineProperty, au = Object.getOwnPropertyNames, Ga = Object.getOwnPropertySymbols, iu = Object.getOwnPropertyDescriptor, su = Object.getPrototypeOf, Ya = Object.prototype;
function ws(e, t, r) {
  if (typeof t != "string") {
    if (Ya) {
      var n = su(t);
      n && n !== Ya && ws(e, n, r);
    }
    var o = au(t);
    Ga && (o = o.concat(Ga(t)));
    for (var a = qa(e), i = qa(t), s = 0; s < o.length; ++s) {
      var l = o[s];
      if (!(l in ru || r && r[l] || i && l in i || a && l in a)) {
        var c = iu(t, l);
        try {
          ou(e, l, c);
        } catch (u) {
        }
      }
    }
  }
  return e;
}
function ir(e) {
  return typeof e == "function";
}
function na(e) {
  return typeof e == "object" && "styledComponentId" in e;
}
function It(e, t) {
  return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function Ka(e, t) {
  if (e.length === 0)
    return "";
  for (var r = e[0], n = 1; n < e.length; n++)
    r += t ? t + e[n] : e[n];
  return r;
}
function sr(e) {
  return e !== null && typeof e == "object" && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function Po(e, t, r) {
  if (r === void 0 && (r = !1), !r && !sr(e) && !Array.isArray(e))
    return t;
  if (Array.isArray(t))
    for (var n = 0; n < t.length; n++)
      e[n] = Po(e[n], t[n]);
  else if (sr(t))
    for (var n in t)
      e[n] = Po(e[n], t[n]);
  return e;
}
function oa(e, t) {
  Object.defineProperty(e, "toString", { value: t });
}
var lu = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function cu() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e[0], n = [], o = 1, a = e.length; o < a; o += 1)
    n.push(e[o]);
  return n.forEach(function(i) {
    r = r.replace(/%[a-z]/, i);
  }), r;
}
function dr(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(e, " for more information.").concat(t.length > 0 ? " Args: ".concat(t.join(", ")) : "")) : new Error(cu.apply(void 0, rr([lu[e]], t, !1)).trim());
}
var uu = function() {
  function e(t) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = t;
  }
  return e.prototype.indexOfGroup = function(t) {
    for (var r = 0, n = 0; n < t; n++)
      r += this.groupSizes[n];
    return r;
  }, e.prototype.insertRules = function(t, r) {
    if (t >= this.groupSizes.length) {
      for (var n = this.groupSizes, o = n.length, a = o; t >= a; )
        if ((a <<= 1) < 0)
          throw dr(16, "".concat(t));
      this.groupSizes = new Uint32Array(a), this.groupSizes.set(n), this.length = a;
      for (var i = o; i < a; i++)
        this.groupSizes[i] = 0;
    }
    for (var s = this.indexOfGroup(t + 1), l = (i = 0, r.length); i < l; i++)
      this.tag.insertRule(s, r[i]) && (this.groupSizes[t]++, s++);
  }, e.prototype.clearGroup = function(t) {
    if (t < this.length) {
      var r = this.groupSizes[t], n = this.indexOfGroup(t), o = n + r;
      this.groupSizes[t] = 0;
      for (var a = n; a < o; a++)
        this.tag.deleteRule(n);
    }
  }, e.prototype.getGroup = function(t) {
    var r = "";
    if (t >= this.length || this.groupSizes[t] === 0)
      return r;
    for (var n = this.groupSizes[t], o = this.indexOfGroup(t), a = o + n, i = o; i < a; i++)
      r += "".concat(this.tag.getRule(i)).concat(ta);
    return r;
  }, e;
}(), Zr = /* @__PURE__ */ new Map(), un = /* @__PURE__ */ new Map(), en = 1, Hr = function(e) {
  if (Zr.has(e))
    return Zr.get(e);
  for (; un.has(en); )
    en++;
  var t = en++;
  if (process.env.NODE_ENV !== "production" && ((0 | t) < 0 || t > 1073741824))
    throw dr(16, "".concat(t));
  return Zr.set(e, t), un.set(t, e), t;
}, du = function(e, t) {
  en = t + 1, Zr.set(e, t), un.set(t, e);
}, fu = "style[".concat(jt, "][").concat(ms, '="').concat(Dn, '"]'), hu = new RegExp("^".concat(jt, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), vu = function(e, t, r) {
  for (var n, o = r.split(","), a = 0, i = o.length; a < i; a++)
    (n = o[a]) && e.registerName(t, n);
}, pu = function(e, t) {
  for (var r, n = ((r = t.textContent) !== null && r !== void 0 ? r : "").split(ta), o = [], a = 0, i = n.length; a < i; a++) {
    var s = n[a].trim();
    if (s) {
      var l = s.match(hu);
      if (l) {
        var c = 0 | parseInt(l[1], 10), u = l[2];
        c !== 0 && (du(u, c), vu(e, u, l[3]), e.getTag().insertRules(c, o)), o.length = 0;
      } else
        o.push(s);
    }
  }
};
function gu() {
  return typeof __webpack_nonce__ != "undefined" ? __webpack_nonce__ : null;
}
var Ss = function(e) {
  var t = document.head, r = e || t, n = document.createElement("style"), o = function(s) {
    var l = Array.from(s.querySelectorAll("style[".concat(jt, "]")));
    return l[l.length - 1];
  }(r), a = o !== void 0 ? o.nextSibling : null;
  n.setAttribute(jt, gs), n.setAttribute(ms, Dn);
  var i = gu();
  return i && n.setAttribute("nonce", i), r.insertBefore(n, a), n;
}, mu = function() {
  function e(t) {
    this.element = Ss(t), this.element.appendChild(document.createTextNode("")), this.sheet = function(r) {
      if (r.sheet)
        return r.sheet;
      for (var n = document.styleSheets, o = 0, a = n.length; o < a; o++) {
        var i = n[o];
        if (i.ownerNode === r)
          return i;
      }
      throw dr(17);
    }(this.element), this.length = 0;
  }
  return e.prototype.insertRule = function(t, r) {
    try {
      return this.sheet.insertRule(r, t), this.length++, !0;
    } catch (n) {
      return !1;
    }
  }, e.prototype.deleteRule = function(t) {
    this.sheet.deleteRule(t), this.length--;
  }, e.prototype.getRule = function(t) {
    var r = this.sheet.cssRules[t];
    return r && r.cssText ? r.cssText : "";
  }, e;
}(), bu = function() {
  function e(t) {
    this.element = Ss(t), this.nodes = this.element.childNodes, this.length = 0;
  }
  return e.prototype.insertRule = function(t, r) {
    if (t <= this.length && t >= 0) {
      var n = document.createTextNode(r);
      return this.element.insertBefore(n, this.nodes[t] || null), this.length++, !0;
    }
    return !1;
  }, e.prototype.deleteRule = function(t) {
    this.element.removeChild(this.nodes[t]), this.length--;
  }, e.prototype.getRule = function(t) {
    return t < this.length ? this.nodes[t].textContent : "";
  }, e;
}(), yu = function() {
  function e(t) {
    this.rules = [], this.length = 0;
  }
  return e.prototype.insertRule = function(t, r) {
    return t <= this.length && (this.rules.splice(t, 0, r), this.length++, !0);
  }, e.prototype.deleteRule = function(t) {
    this.rules.splice(t, 1), this.length--;
  }, e.prototype.getRule = function(t) {
    return t < this.length ? this.rules[t] : "";
  }, e;
}(), Xa = ra, _u = { isServer: !ra, useCSSOMInjection: !Gc }, ks = function() {
  function e(t, r, n) {
    t === void 0 && (t = ar), r === void 0 && (r = {});
    var o = this;
    this.options = Me(Me({}, _u), t), this.gs = r, this.names = new Map(n), this.server = !!t.isServer, !this.server && ra && Xa && (Xa = !1, function(a) {
      for (var i = document.querySelectorAll(fu), s = 0, l = i.length; s < l; s++) {
        var c = i[s];
        c && c.getAttribute(jt) !== gs && (pu(a, c), c.parentNode && c.parentNode.removeChild(c));
      }
    }(this)), oa(this, function() {
      return function(a) {
        for (var i = a.getTag(), s = i.length, l = "", c = function(d) {
          var f = function(m) {
            return un.get(m);
          }(d);
          if (f === void 0)
            return "continue";
          var p = a.names.get(f), g = i.getGroup(d);
          if (p === void 0 || g.length === 0)
            return "continue";
          var b = "".concat(jt, ".g").concat(d, '[id="').concat(f, '"]'), x = "";
          p !== void 0 && p.forEach(function(m) {
            m.length > 0 && (x += "".concat(m, ","));
          }), l += "".concat(g).concat(b, '{content:"').concat(x, '"}').concat(ta);
        }, u = 0; u < s; u++)
          c(u);
        return l;
      }(o);
    });
  }
  return e.registerId = function(t) {
    return Hr(t);
  }, e.prototype.reconstructWithOptions = function(t, r) {
    return r === void 0 && (r = !0), new e(Me(Me({}, this.options), t), this.gs, r && this.names || void 0);
  }, e.prototype.allocateGSInstance = function(t) {
    return this.gs[t] = (this.gs[t] || 0) + 1;
  }, e.prototype.getTag = function() {
    return this.tag || (this.tag = (t = function(r) {
      var n = r.useCSSOMInjection, o = r.target;
      return r.isServer ? new yu(o) : n ? new mu(o) : new bu(o);
    }(this.options), new uu(t)));
    var t;
  }, e.prototype.hasNameForId = function(t, r) {
    return this.names.has(t) && this.names.get(t).has(r);
  }, e.prototype.registerName = function(t, r) {
    if (Hr(t), this.names.has(t))
      this.names.get(t).add(r);
    else {
      var n = /* @__PURE__ */ new Set();
      n.add(r), this.names.set(t, n);
    }
  }, e.prototype.insertRules = function(t, r, n) {
    this.registerName(t, r), this.getTag().insertRules(Hr(t), n);
  }, e.prototype.clearNames = function(t) {
    this.names.has(t) && this.names.get(t).clear();
  }, e.prototype.clearRules = function(t) {
    this.getTag().clearGroup(Hr(t)), this.clearNames(t);
  }, e.prototype.clearTag = function() {
    this.tag = void 0;
  }, e;
}(), xu = /&/g, Cu = /^\s*\/\/.*$/gm;
function Ts(e, t) {
  return e.map(function(r) {
    return r.type === "rule" && (r.value = "".concat(t, " ").concat(r.value), r.value = r.value.replaceAll(",", ",".concat(t, " ")), r.props = r.props.map(function(n) {
      return "".concat(t, " ").concat(n);
    })), Array.isArray(r.children) && r.type !== "@keyframes" && (r.children = Ts(r.children, t)), r;
  });
}
function Eu(e) {
  var t, r, n, o = e === void 0 ? ar : e, a = o.options, i = a === void 0 ? ar : a, s = o.plugins, l = s === void 0 ? Ln : s, c = function(f, p, g) {
    return g.startsWith(r) && g.endsWith(r) && g.replaceAll(r, "").length > 0 ? ".".concat(t) : f;
  }, u = l.slice();
  u.push(function(f) {
    f.type === Pn && f.value.includes("&") && (f.props[0] = f.props[0].replace(xu, r).replace(n, c));
  }), i.prefix && u.push(Uc), u.push(Vc);
  var d = function(f, p, g, b) {
    p === void 0 && (p = ""), g === void 0 && (g = ""), b === void 0 && (b = "&"), t = b, r = p, n = new RegExp("\\".concat(r, "\\b"), "g");
    var x = f.replace(Cu, ""), m = Hc(g || p ? "".concat(g, " ").concat(p, " { ").concat(x, " }") : x);
    i.namespace && (m = Ts(m, i.namespace));
    var y = [];
    return cn(m, zc(u.concat(Wc(function(C) {
      return y.push(C);
    })))), y;
  };
  return d.hash = l.length ? l.reduce(function(f, p) {
    return p.name || dr(15), Nt(f, p.name);
  }, bs).toString() : "", d;
}
var wu = new ks(), Io = Eu(), Rs = ke.createContext({ shouldForwardProp: void 0, styleSheet: wu, stylis: Io });
Rs.Consumer;
ke.createContext(void 0);
function Qa() {
  return gc(Rs);
}
var Ja = function() {
  function e(t, r) {
    var n = this;
    this.inject = function(o, a) {
      a === void 0 && (a = Io);
      var i = n.name + a.hash;
      o.hasNameForId(n.id, i) || o.insertRules(n.id, i, a(n.rules, i, "@keyframes"));
    }, this.name = t, this.id = "sc-keyframes-".concat(t), this.rules = r, oa(this, function() {
      throw dr(12, String(n.name));
    });
  }
  return e.prototype.getName = function(t) {
    return t === void 0 && (t = Io), this.name + t.hash;
  }, e;
}(), Su = function(e) {
  return e >= "A" && e <= "Z";
};
function Za(e) {
  for (var t = "", r = 0; r < e.length; r++) {
    var n = e[r];
    if (r === 1 && n === "-" && e[0] === "-")
      return e;
    Su(n) ? t += "-" + n.toLowerCase() : t += n;
  }
  return t.startsWith("ms-") ? "-" + t : t;
}
var Ns = function(e) {
  return e == null || e === !1 || e === "";
}, Ps = function(e) {
  var t, r, n = [];
  for (var o in e) {
    var a = e[o];
    e.hasOwnProperty(o) && !Ns(a) && (Array.isArray(a) && a.isCss || ir(a) ? n.push("".concat(Za(o), ":"), a, ";") : sr(a) ? n.push.apply(n, rr(rr(["".concat(o, " {")], Ps(a), !1), ["}"], !1)) : n.push("".concat(Za(o), ": ").concat((t = o, (r = a) == null || typeof r == "boolean" || r === "" ? "" : typeof r != "number" || r === 0 || t in qc || t.startsWith("--") ? String(r).trim() : "".concat(r, "px")), ";")));
  }
  return n;
};
function Bt(e, t, r, n) {
  if (Ns(e))
    return [];
  if (na(e))
    return [".".concat(e.styledComponentId)];
  if (ir(e)) {
    if (!ir(a = e) || a.prototype && a.prototype.isReactComponent || !t)
      return [e];
    var o = e(t);
    return process.env.NODE_ENV === "production" || typeof o != "object" || Array.isArray(o) || o instanceof Ja || sr(o) || o === null || console.error("".concat(_s(e), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), Bt(o, t, r, n);
  }
  var a;
  return e instanceof Ja ? r ? (e.inject(r, n), [e.getName(n)]) : [e] : sr(e) ? Ps(e) : Array.isArray(e) ? Array.prototype.concat.apply(Ln, e.map(function(i) {
    return Bt(i, t, r, n);
  })) : [e.toString()];
}
function ku(e) {
  for (var t = 0; t < e.length; t += 1) {
    var r = e[t];
    if (ir(r) && !na(r))
      return !1;
  }
  return !0;
}
var Tu = ys(Dn), Ru = function() {
  function e(t, r, n) {
    this.rules = t, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (n === void 0 || n.isStatic) && ku(t), this.componentId = r, this.baseHash = Nt(Tu, r), this.baseStyle = n, ks.registerId(r);
  }
  return e.prototype.generateAndInjectStyles = function(t, r, n) {
    var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(t, r, n) : "";
    if (this.isStatic && !n.hash)
      if (this.staticRulesId && r.hasNameForId(this.componentId, this.staticRulesId))
        o = It(o, this.staticRulesId);
      else {
        var a = Ka(Bt(this.rules, t, r, n)), i = No(Nt(this.baseHash, a) >>> 0);
        if (!r.hasNameForId(this.componentId, i)) {
          var s = n(a, ".".concat(i), void 0, this.componentId);
          r.insertRules(this.componentId, i, s);
        }
        o = It(o, i), this.staticRulesId = i;
      }
    else {
      for (var l = Nt(this.baseHash, n.hash), c = "", u = 0; u < this.rules.length; u++) {
        var d = this.rules[u];
        if (typeof d == "string")
          c += d, process.env.NODE_ENV !== "production" && (l = Nt(l, d));
        else if (d) {
          var f = Ka(Bt(d, t, r, n));
          l = Nt(l, f + u), c += f;
        }
      }
      if (c) {
        var p = No(l >>> 0);
        r.hasNameForId(this.componentId, p) || r.insertRules(this.componentId, p, n(c, ".".concat(p), void 0, this.componentId)), o = It(o, p);
      }
    }
    return o;
  }, e;
}(), Is = ke.createContext(void 0);
Is.Consumer;
var oo = {}, ei = /* @__PURE__ */ new Set();
function Nu(e, t, r) {
  var n = na(e), o = e, a = !no(e), i = t.attrs, s = i === void 0 ? Ln : i, l = t.componentId, c = l === void 0 ? function(E, k) {
    var S = typeof E != "string" ? "sc" : Wa(E);
    oo[S] = (oo[S] || 0) + 1;
    var _ = "".concat(S, "-").concat(Zc(Dn + S + oo[S]));
    return k ? "".concat(k, "-").concat(_) : _;
  }(t.displayName, t.parentComponentId) : l, u = t.displayName, d = u === void 0 ? function(E) {
    return no(E) ? "styled.".concat(E) : "Styled(".concat(_s(E), ")");
  }(e) : u, f = t.displayName && t.componentId ? "".concat(Wa(t.displayName), "-").concat(t.componentId) : t.componentId || c, p = n && o.attrs ? o.attrs.concat(s).filter(Boolean) : s, g = t.shouldForwardProp;
  if (n && o.shouldForwardProp) {
    var b = o.shouldForwardProp;
    if (t.shouldForwardProp) {
      var x = t.shouldForwardProp;
      g = function(E, k) {
        return b(E, k) && x(E, k);
      };
    } else
      g = b;
  }
  var m = new Ru(r, f, n ? o.componentStyle : void 0);
  function y(E, k) {
    return function(S, _, P) {
      var D = S.attrs, z = S.componentStyle, q = S.defaultProps, I = S.foldedComponentIds, R = S.styledComponentId, L = S.target, M = ke.useContext(Is), $ = Qa(), G = S.shouldForwardProp || $.shouldForwardProp;
      process.env.NODE_ENV !== "production" && Ba(R);
      var be = Kc(_, M, q) || ar, Y = function(at, De, Ge) {
        for (var Ne, Pe = Me(Me({}, De), { className: void 0, theme: Ge }), Fe = 0; Fe < at.length; Fe += 1) {
          var O = ir(Ne = at[Fe]) ? Ne(Pe) : Ne;
          for (var _e in O)
            Pe[_e] = _e === "className" ? It(Pe[_e], O[_e]) : _e === "style" ? Me(Me({}, Pe[_e]), O[_e]) : O[_e];
        }
        return De.className && (Pe.className = It(Pe.className, De.className)), Pe;
      }(D, _, be), Q = Y.as || L, ye = {};
      for (var fe in Y)
        Y[fe] === void 0 || fe[0] === "$" || fe === "as" || fe === "theme" && Y.theme === be || (fe === "forwardedAs" ? ye.as = Y.forwardedAs : G && !G(fe, Q) || (ye[fe] = Y[fe], G || process.env.NODE_ENV !== "development" || Tc(fe) || ei.has(fe) || !Ro.has(Q) || (ei.add(fe), console.warn('styled-components: it looks like an unknown prop "'.concat(fe, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var et = function(at, De) {
        var Ge = Qa(), Ne = at.generateAndInjectStyles(De, Ge.styleSheet, Ge.stylis);
        return process.env.NODE_ENV !== "production" && Ba(Ne), Ne;
      }(z, Y);
      process.env.NODE_ENV !== "production" && S.warnTooManyClasses && S.warnTooManyClasses(et);
      var oe = It(I, R);
      return et && (oe += " " + et), Y.className && (oe += " " + Y.className), ye[no(Q) && !Ro.has(Q) ? "class" : "className"] = oe, ye.ref = P, pc(Q, ye);
    }(C, E, k);
  }
  y.displayName = d;
  var C = ke.forwardRef(y);
  return C.attrs = p, C.componentStyle = m, C.displayName = d, C.shouldForwardProp = g, C.foldedComponentIds = n ? It(o.foldedComponentIds, o.styledComponentId) : "", C.styledComponentId = f, C.target = n ? o.target : e, Object.defineProperty(C, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(E) {
    this._foldedDefaultProps = n ? function(k) {
      for (var S = [], _ = 1; _ < arguments.length; _++)
        S[_ - 1] = arguments[_];
      for (var P = 0, D = S; P < D.length; P++)
        Po(k, D[P], !0);
      return k;
    }({}, o.defaultProps, E) : E;
  } }), process.env.NODE_ENV !== "production" && (Yc(d, f), C.warnTooManyClasses = /* @__PURE__ */ function(E, k) {
    var S = {}, _ = !1;
    return function(P) {
      if (!_ && (S[P] = !0, Object.keys(S).length >= 200)) {
        var D = k ? ' with the id of "'.concat(k, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(E).concat(D, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), _ = !0, S = {};
      }
    };
  }(d, f)), oa(C, function() {
    return ".".concat(C.styledComponentId);
  }), a && ws(C, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), C;
}
function ti(e, t) {
  for (var r = [e[0]], n = 0, o = t.length; n < o; n += 1)
    r.push(t[n], e[n + 1]);
  return r;
}
var ri = function(e) {
  return Object.assign(e, { isCss: !0 });
};
function aa(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  if (ir(e) || sr(e))
    return ri(Bt(ti(Ln, rr([e], t, !0))));
  var n = e;
  return t.length === 0 && n.length === 1 && typeof n[0] == "string" ? Bt(n) : ri(Bt(ti(n, t)));
}
function Oo(e, t, r) {
  if (r === void 0 && (r = ar), !t)
    throw dr(1, t);
  var n = function(o) {
    for (var a = [], i = 1; i < arguments.length; i++)
      a[i - 1] = arguments[i];
    return e(t, r, aa.apply(void 0, rr([o], a, !1)));
  };
  return n.attrs = function(o) {
    return Oo(e, t, Me(Me({}, r), { attrs: Array.prototype.concat(r.attrs, o).filter(Boolean) }));
  }, n.withConfig = function(o) {
    return Oo(e, t, Me(Me({}, r), o));
  }, n;
}
var Os = function(e) {
  return Oo(Nu, e);
}, V = Os;
Ro.forEach(function(e) {
  V[e] = Os(e);
});
process.env.NODE_ENV !== "production" && typeof navigator != "undefined" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var $r = "__sc-".concat(jt, "__");
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window != "undefined" && (window[$r] || (window[$r] = 0), window[$r] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[$r] += 1);
const Pu = V.h4`
    && {
      color: #3D3A3B;
      font-size: 16px;
      font-weight: 400;
      padding-block: 0 12px;
      margin-top: -4px;
    }
`, As = ({ text: e }) => /* @__PURE__ */ B.jsx(Pu, { children: e });
var ni = {}, tn = void 0;
try {
  tn = window;
} catch (e) {
}
function Ds(e, t) {
  if (typeof tn != "undefined") {
    var r = tn.__packages__ = tn.__packages__ || {};
    if (!r[e] || !ni[e]) {
      ni[e] = t;
      var n = r[e] = r[e] || [];
      n.push(t);
    }
  }
}
Ds("@fluentui/set-version", "6.0.0");
var Ao = function(e, t) {
  return Ao = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (r[o] = n[o]);
  }, Ao(e, t);
};
function dt(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Ao(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var w = function() {
  return w = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, w.apply(this, arguments);
};
function Ls(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function dn(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, o = t.length, a; n < o; n++)
      (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var gr = {
  /**
   * Avoids style injection, use getRules() to read the styles.
   */
  none: 0,
  /**
   * Inserts rules using the insertRule api.
   */
  insertNode: 1,
  /**
   * Appends rules using appendChild.
   */
  appendChild: 2
}, oi = "__stylesheet__", Iu = typeof navigator != "undefined" && /rv:11.0/.test(navigator.userAgent), Xt = {};
try {
  Xt = window || {};
} catch (e) {
}
var Yt, Qe = (
  /** @class */
  function() {
    function e(t, r) {
      var n, o, a, i, s, l;
      this._rules = [], this._preservedRules = [], this._counter = 0, this._keyToClassName = {}, this._onInsertRuleCallbacks = [], this._onResetCallbacks = [], this._classNameToArgs = {}, this._config = w({
        // If there is no document we won't have an element to inject into.
        injectionMode: typeof document == "undefined" ? gr.none : gr.insertNode,
        defaultPrefix: "css",
        namespace: void 0,
        cspSettings: void 0
      }, t), this._classNameToArgs = (n = r == null ? void 0 : r.classNameToArgs) !== null && n !== void 0 ? n : this._classNameToArgs, this._counter = (o = r == null ? void 0 : r.counter) !== null && o !== void 0 ? o : this._counter, this._keyToClassName = (i = (a = this._config.classNameCache) !== null && a !== void 0 ? a : r == null ? void 0 : r.keyToClassName) !== null && i !== void 0 ? i : this._keyToClassName, this._preservedRules = (s = r == null ? void 0 : r.preservedRules) !== null && s !== void 0 ? s : this._preservedRules, this._rules = (l = r == null ? void 0 : r.rules) !== null && l !== void 0 ? l : this._rules;
    }
    return e.getInstance = function() {
      if (Yt = Xt[oi], !Yt || Yt._lastStyleElement && Yt._lastStyleElement.ownerDocument !== document) {
        var t = (Xt == null ? void 0 : Xt.FabricConfig) || {}, r = new e(t.mergeStyles, t.serializedStylesheet);
        Yt = r, Xt[oi] = r;
      }
      return Yt;
    }, e.prototype.serialize = function() {
      return JSON.stringify({
        classNameToArgs: this._classNameToArgs,
        counter: this._counter,
        keyToClassName: this._keyToClassName,
        preservedRules: this._preservedRules,
        rules: this._rules
      });
    }, e.prototype.setConfig = function(t) {
      this._config = w(w({}, this._config), t);
    }, e.prototype.onReset = function(t) {
      var r = this;
      return this._onResetCallbacks.push(t), function() {
        r._onResetCallbacks = r._onResetCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.onInsertRule = function(t) {
      var r = this;
      return this._onInsertRuleCallbacks.push(t), function() {
        r._onInsertRuleCallbacks = r._onInsertRuleCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.getClassName = function(t) {
      var r = this._config.namespace, n = t || this._config.defaultPrefix;
      return "".concat(r ? r + "-" : "").concat(n, "-").concat(this._counter++);
    }, e.prototype.cacheClassName = function(t, r, n, o) {
      this._keyToClassName[r] = t, this._classNameToArgs[t] = {
        args: n,
        rules: o
      };
    }, e.prototype.classNameFromKey = function(t) {
      return this._keyToClassName[t];
    }, e.prototype.getClassNameCache = function() {
      return this._keyToClassName;
    }, e.prototype.argsFromClassName = function(t) {
      var r = this._classNameToArgs[t];
      return r && r.args;
    }, e.prototype.insertedRulesFromClassName = function(t) {
      var r = this._classNameToArgs[t];
      return r && r.rules;
    }, e.prototype.insertRule = function(t, r) {
      var n = this._config.injectionMode, o = n !== gr.none ? this._getStyleElement() : void 0;
      if (r && this._preservedRules.push(t), o)
        switch (n) {
          case gr.insertNode:
            var a = o.sheet;
            try {
              a.insertRule(t, a.cssRules.length);
            } catch (i) {
            }
            break;
          case gr.appendChild:
            o.appendChild(document.createTextNode(t));
            break;
        }
      else
        this._rules.push(t);
      this._config.onInsertRule && this._config.onInsertRule(t), this._onInsertRuleCallbacks.forEach(function(i) {
        return i();
      });
    }, e.prototype.getRules = function(t) {
      return (t ? this._preservedRules.join("") : "") + this._rules.join("");
    }, e.prototype.reset = function() {
      this._rules = [], this._counter = 0, this._classNameToArgs = {}, this._keyToClassName = {}, this._onResetCallbacks.forEach(function(t) {
        return t();
      });
    }, e.prototype.resetKeys = function() {
      this._keyToClassName = {};
    }, e.prototype._getStyleElement = function() {
      var t = this;
      return !this._styleElement && typeof document != "undefined" && (this._styleElement = this._createStyleElement(), Iu || window.requestAnimationFrame(function() {
        t._styleElement = void 0;
      })), this._styleElement;
    }, e.prototype._createStyleElement = function() {
      var t = document.head, r = document.createElement("style"), n = null;
      r.setAttribute("data-merge-styles", "true");
      var o = this._config.cspSettings;
      if (o && o.nonce && r.setAttribute("nonce", o.nonce), this._lastStyleElement)
        n = this._lastStyleElement.nextElementSibling;
      else {
        var a = this._findPlaceholderStyleTag();
        a ? n = a.nextElementSibling : n = t.childNodes[0];
      }
      return t.insertBefore(r, t.contains(n) ? n : null), this._lastStyleElement = r, r;
    }, e.prototype._findPlaceholderStyleTag = function() {
      var t = document.head;
      return t ? t.querySelector("style[data-merge-styles]") : null;
    }, e;
  }()
);
function Bs() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = [], n = [], o = Qe.getInstance();
  function a(i) {
    for (var s = 0, l = i; s < l.length; s++) {
      var c = l[s];
      if (c)
        if (typeof c == "string")
          if (c.indexOf(" ") >= 0)
            a(c.split(" "));
          else {
            var u = o.argsFromClassName(c);
            u ? a(u) : r.indexOf(c) === -1 && r.push(c);
          }
        else
          Array.isArray(c) ? a(c) : typeof c == "object" && n.push(c);
    }
  }
  return a(e), {
    classes: r,
    objects: n
  };
}
function Ms(e) {
  er !== e && (er = e);
}
function js() {
  return er === void 0 && (er = // eslint-disable-next-line no-restricted-globals
  typeof document != "undefined" && // eslint-disable-next-line no-restricted-globals
  !!document.documentElement && // eslint-disable-next-line no-restricted-globals
  document.documentElement.getAttribute("dir") === "rtl"), er;
}
var er;
er = js();
function Bn() {
  return {
    rtl: js()
  };
}
var ai = {};
function Ou(e, t) {
  var r = e[t];
  r.charAt(0) !== "-" && (e[t] = ai[r] = ai[r] || r.replace(/([A-Z])/g, "-$1").toLowerCase());
}
var Vr;
function Au() {
  var e;
  if (!Vr) {
    var t = typeof document != "undefined" ? document : void 0, r = typeof navigator != "undefined" ? navigator : void 0, n = (e = r == null ? void 0 : r.userAgent) === null || e === void 0 ? void 0 : e.toLowerCase();
    t ? Vr = {
      isWebkit: !!(t && "WebkitAppearance" in t.documentElement.style),
      isMoz: !!(n && n.indexOf("firefox") > -1),
      isOpera: !!(n && n.indexOf("opera") > -1),
      isMs: !!(r && (/rv:11.0/i.test(r.userAgent) || /Edge\/\d./i.test(navigator.userAgent)))
    } : Vr = {
      isWebkit: !0,
      isMoz: !0,
      isOpera: !0,
      isMs: !0
    };
  }
  return Vr;
}
var ii = {
  "user-select": 1
};
function Du(e, t) {
  var r = Au(), n = e[t];
  if (ii[n]) {
    var o = e[t + 1];
    ii[n] && (r.isWebkit && e.push("-webkit-" + n, o), r.isMoz && e.push("-moz-" + n, o), r.isMs && e.push("-ms-" + n, o), r.isOpera && e.push("-o-" + n, o));
  }
}
var Lu = [
  "column-count",
  "font-weight",
  "flex",
  "flex-grow",
  "flex-shrink",
  "fill-opacity",
  "opacity",
  "order",
  "z-index",
  "zoom"
];
function Bu(e, t) {
  var r = e[t], n = e[t + 1];
  if (typeof n == "number") {
    var o = Lu.indexOf(r) > -1, a = r.indexOf("--") > -1, i = o || a ? "" : "px";
    e[t + 1] = "".concat(n).concat(i);
  }
}
var zr, _t = "left", xt = "right", Mu = "@noflip", si = (zr = {}, zr[_t] = xt, zr[xt] = _t, zr), li = {
  "w-resize": "e-resize",
  "sw-resize": "se-resize",
  "nw-resize": "ne-resize"
};
function ju(e, t, r) {
  if (e.rtl) {
    var n = t[r];
    if (!n)
      return;
    var o = t[r + 1];
    if (typeof o == "string" && o.indexOf(Mu) >= 0)
      t[r + 1] = o.replace(/\s*(?:\/\*\s*)?\@noflip\b(?:\s*\*\/)?\s*?/g, "");
    else if (n.indexOf(_t) >= 0)
      t[r] = n.replace(_t, xt);
    else if (n.indexOf(xt) >= 0)
      t[r] = n.replace(xt, _t);
    else if (String(o).indexOf(_t) >= 0)
      t[r + 1] = o.replace(_t, xt);
    else if (String(o).indexOf(xt) >= 0)
      t[r + 1] = o.replace(xt, _t);
    else if (si[n])
      t[r] = si[n];
    else if (li[o])
      t[r + 1] = li[o];
    else
      switch (n) {
        case "margin":
        case "padding":
          t[r + 1] = Hu(o);
          break;
        case "box-shadow":
          t[r + 1] = Fu(o, 0);
          break;
      }
  }
}
function Fu(e, t) {
  var r = e.split(" "), n = parseInt(r[t], 10);
  return r[0] = r[0].replace(String(n), String(n * -1)), r.join(" ");
}
function Hu(e) {
  if (typeof e == "string") {
    var t = e.split(" ");
    if (t.length === 4)
      return "".concat(t[0], " ").concat(t[3], " ").concat(t[2], " ").concat(t[1]);
  }
  return e;
}
function $u(e) {
  for (var t = [], r = 0, n = 0, o = 0; o < e.length; o++)
    switch (e[o]) {
      case "(":
        n++;
        break;
      case ")":
        n && n--;
        break;
      case "	":
      case " ":
        n || (o > r && t.push(e.substring(r, o)), r = o + 1);
        break;
    }
  return r < e.length && t.push(e.substring(r)), t;
}
var Vu = "displayName";
function zu(e) {
  var t = e && e["&"];
  return t ? t.displayName : void 0;
}
var Fs = /\:global\((.+?)\)/g;
function Wu(e) {
  if (!Fs.test(e))
    return e;
  for (var t = [], r = /\:global\((.+?)\)/g, n = null; n = r.exec(e); )
    n[1].indexOf(",") > -1 && t.push([
      n.index,
      n.index + n[0].length,
      // Wrap each of the found selectors in :global()
      n[1].split(",").map(function(o) {
        return ":global(".concat(o.trim(), ")");
      }).join(", ")
    ]);
  return t.reverse().reduce(function(o, a) {
    var i = a[0], s = a[1], l = a[2], c = o.slice(0, i), u = o.slice(s);
    return c + l + u;
  }, e);
}
function ci(e, t) {
  return e.indexOf(":global(") >= 0 ? e.replace(Fs, "$1") : e.indexOf(":") === 0 ? t + e : e.indexOf("&") < 0 ? t + " " + e : e;
}
function ui(e, t, r, n) {
  t === void 0 && (t = { __order: [] }), r.indexOf("@") === 0 ? (r = r + "{" + e, tr([n], t, r)) : r.indexOf(",") > -1 ? Wu(r).split(",").map(function(o) {
    return o.trim();
  }).forEach(function(o) {
    return tr([n], t, ci(o, e));
  }) : tr([n], t, ci(r, e));
}
function tr(e, t, r) {
  t === void 0 && (t = { __order: [] }), r === void 0 && (r = "&");
  var n = Qe.getInstance(), o = t[r];
  o || (o = {}, t[r] = o, t.__order.push(r));
  for (var a = 0, i = e; a < i.length; a++) {
    var s = i[a];
    if (typeof s == "string") {
      var l = n.argsFromClassName(s);
      l && tr(l, t, r);
    } else if (Array.isArray(s))
      tr(s, t, r);
    else
      for (var c in s)
        if (s.hasOwnProperty(c)) {
          var u = s[c];
          if (c === "selectors") {
            var d = s.selectors;
            for (var f in d)
              d.hasOwnProperty(f) && ui(r, t, f, d[f]);
          } else
            typeof u == "object" ? u !== null && ui(r, t, c, u) : u !== void 0 && (c === "margin" || c === "padding" ? Uu(o, c, u) : o[c] = u);
        }
  }
  return t;
}
function Uu(e, t, r) {
  var n = typeof r == "string" ? $u(r) : [r];
  n.length === 0 && n.push(r), n[n.length - 1] === "!important" && (n = n.slice(0, -1).map(function(o) {
    return o + " !important";
  })), e[t + "Top"] = n[0], e[t + "Right"] = n[1] || n[0], e[t + "Bottom"] = n[2] || n[0], e[t + "Left"] = n[3] || n[1] || n[0];
}
function qu(e, t) {
  for (var r = [e.rtl ? "rtl" : "ltr"], n = !1, o = 0, a = t.__order; o < a.length; o++) {
    var i = a[o];
    r.push(i);
    var s = t[i];
    for (var l in s)
      s.hasOwnProperty(l) && s[l] !== void 0 && (n = !0, r.push(l, s[l]));
  }
  return n ? r.join("") : void 0;
}
function Hs(e, t) {
  return t <= 0 ? "" : t === 1 ? e : e + Hs(e, t - 1);
}
function ia(e, t) {
  if (!t)
    return "";
  var r = [];
  for (var n in t)
    t.hasOwnProperty(n) && n !== Vu && t[n] !== void 0 && r.push(n, t[n]);
  for (var o = 0; o < r.length; o += 2)
    Ou(r, o), Bu(r, o), ju(e, r, o), Du(r, o);
  for (var o = 1; o < r.length; o += 4)
    r.splice(o, 1, ":", r[o], ";");
  return r.join("");
}
function $s(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  var n = tr(t), o = qu(e, n);
  if (o) {
    var a = Qe.getInstance(), i = {
      className: a.classNameFromKey(o),
      key: o,
      args: t
    };
    if (!i.className) {
      i.className = a.getClassName(zu(n));
      for (var s = [], l = 0, c = n.__order; l < c.length; l++) {
        var u = c[l];
        s.push(u, ia(e, n[u]));
      }
      i.rulesToInsert = s;
    }
    return i;
  }
}
function Vs(e, t) {
  t === void 0 && (t = 1);
  var r = Qe.getInstance(), n = e.className, o = e.key, a = e.args, i = e.rulesToInsert;
  if (i) {
    for (var s = 0; s < i.length; s += 2) {
      var l = i[s + 1];
      if (l) {
        var c = i[s];
        c = c.replace(/&/g, Hs(".".concat(e.className), t));
        var u = "".concat(c, "{").concat(l, "}").concat(c.indexOf("@") === 0 ? "}" : "");
        r.insertRule(u);
      }
    }
    r.cacheClassName(n, o, a, i);
  }
}
function Gu(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  var n = $s.apply(void 0, dn([e], t, !1));
  return n ? (Vs(n, e.specificityMultiplier), n.className) : "";
}
function sa() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return Yu(e, Bn());
}
function Yu(e, t) {
  var r = e instanceof Array ? e : [e], n = Bs(r), o = n.classes, a = n.objects;
  return a.length && o.push(Gu(t || {}, a)), o.join(" ");
}
function la() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  if (e && e.length === 1 && e[0] && !e[0].subComponentStyles)
    return e[0];
  for (var r = {}, n = {}, o = 0, a = e; o < a.length; o++) {
    var i = a[o];
    if (i) {
      for (var s in i)
        if (i.hasOwnProperty(s)) {
          if (s === "subComponentStyles" && i.subComponentStyles !== void 0) {
            var l = i.subComponentStyles;
            for (var c in l)
              l.hasOwnProperty(c) && (n.hasOwnProperty(c) ? n[c].push(l[c]) : n[c] = [l[c]]);
            continue;
          }
          var u = r[s], d = i[s];
          u === void 0 ? r[s] = d : r[s] = dn(dn([], Array.isArray(u) ? u : [u], !0), Array.isArray(d) ? d : [d], !0);
        }
    }
  }
  if (Object.keys(n).length > 0) {
    r.subComponentStyles = {};
    var f = r.subComponentStyles, p = function(g) {
      if (n.hasOwnProperty(g)) {
        var b = n[g];
        f[g] = function(x) {
          return la.apply(void 0, b.map(function(m) {
            return typeof m == "function" ? m(x) : m;
          }));
        };
      }
    };
    for (var c in n)
      p(c);
  }
  return r;
}
function Ku() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return zs(e, Bn());
}
function zs(e, t) {
  var r = { subComponentStyles: {} }, n = e[0];
  if (!n && e.length <= 1)
    return { subComponentStyles: {} };
  var o = la.apply(void 0, e), a = [];
  for (var i in o)
    if (o.hasOwnProperty(i)) {
      if (i === "subComponentStyles") {
        r.subComponentStyles = o.subComponentStyles || {};
        continue;
      }
      var s = o[i], l = Bs(s), c = l.classes, u = l.objects;
      if (u != null && u.length) {
        var d = $s(t || {}, { displayName: i }, u);
        d && (a.push(d), r[i] = c.concat([d.className]).join(" "));
      } else
        r[i] = c.join(" ");
    }
  for (var f = 0, p = a; f < p.length; f++) {
    var d = p[f];
    d && Vs(d, t == null ? void 0 : t.specificityMultiplier);
  }
  return r;
}
function Xu(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  for (var n = [], o = 0, a = t; o < a.length; o++) {
    var i = a[o];
    i && n.push(typeof i == "function" ? i(e) : i);
  }
  return n.length === 1 ? n[0] : n.length ? la.apply(void 0, n) : {};
}
function Ws(e) {
  var t = Qe.getInstance(), r = ia(Bn(), e), n = t.classNameFromKey(r);
  if (!n) {
    var o = t.getClassName();
    t.insertRule("@font-face{".concat(r, "}"), !0), t.cacheClassName(o, r, [], ["font-face", r]);
  }
}
function Ze(e) {
  var t = Qe.getInstance(), r = [];
  for (var n in e)
    e.hasOwnProperty(n) && r.push(n, "{", ia(Bn(), e[n]), "}");
  var o = r.join(""), a = t.classNameFromKey(o);
  if (a)
    return a;
  var i = t.getClassName();
  return t.insertRule("@keyframes ".concat(i, "{").concat(o, "}"), !0), t.cacheClassName(i, o, [], ["keyframes", o]), i;
}
function Qu(e) {
  var t = {}, r = function(o) {
    if (e.hasOwnProperty(o)) {
      var a;
      Object.defineProperty(t, o, {
        get: function() {
          return a === void 0 && (a = sa(e[o]).toString()), a;
        },
        enumerable: !0,
        configurable: !0
      });
    }
  };
  for (var n in e)
    r(n);
  return t;
}
function ca() {
  return (
    // eslint-disable-next-line no-restricted-globals
    typeof window != "undefined" && !!// eslint-disable-next-line no-restricted-globals, deprecation/deprecation
    (window.document && window.document.createElement)
  );
}
var Do = void 0;
try {
  Do = window;
} catch (e) {
}
function ce(e) {
  if (!(!ca() || typeof Do == "undefined")) {
    var t = e;
    return t && t.ownerDocument && t.ownerDocument.defaultView ? t.ownerDocument.defaultView : Do;
  }
}
var ua = (
  /** @class */
  function() {
    function e(t, r) {
      this._timeoutIds = null, this._immediateIds = null, this._intervalIds = null, this._animationFrameIds = null, this._isDisposed = !1, this._parent = t || null, this._onErrorHandler = r, this._noop = function() {
      };
    }
    return e.prototype.dispose = function() {
      var t;
      if (this._isDisposed = !0, this._parent = null, this._timeoutIds) {
        for (t in this._timeoutIds)
          this._timeoutIds.hasOwnProperty(t) && this.clearTimeout(parseInt(t, 10));
        this._timeoutIds = null;
      }
      if (this._immediateIds) {
        for (t in this._immediateIds)
          this._immediateIds.hasOwnProperty(t) && this.clearImmediate(parseInt(t, 10));
        this._immediateIds = null;
      }
      if (this._intervalIds) {
        for (t in this._intervalIds)
          this._intervalIds.hasOwnProperty(t) && this.clearInterval(parseInt(t, 10));
        this._intervalIds = null;
      }
      if (this._animationFrameIds) {
        for (t in this._animationFrameIds)
          this._animationFrameIds.hasOwnProperty(t) && this.cancelAnimationFrame(parseInt(t, 10));
        this._animationFrameIds = null;
      }
    }, e.prototype.setTimeout = function(t, r) {
      var n = this, o = 0;
      return this._isDisposed || (this._timeoutIds || (this._timeoutIds = {}), o = setTimeout(function() {
        try {
          n._timeoutIds && delete n._timeoutIds[o], t.apply(n._parent);
        } catch (a) {
          n._logError(a);
        }
      }, r), this._timeoutIds[o] = !0), o;
    }, e.prototype.clearTimeout = function(t) {
      this._timeoutIds && this._timeoutIds[t] && (clearTimeout(t), delete this._timeoutIds[t]);
    }, e.prototype.setImmediate = function(t, r) {
      var n = this, o = 0, a = ce(r);
      if (!this._isDisposed) {
        this._immediateIds || (this._immediateIds = {});
        var i = function() {
          try {
            n._immediateIds && delete n._immediateIds[o], t.apply(n._parent);
          } catch (s) {
            n._logError(s);
          }
        };
        o = a.setTimeout(i, 0), this._immediateIds[o] = !0;
      }
      return o;
    }, e.prototype.clearImmediate = function(t, r) {
      var n = ce(r);
      this._immediateIds && this._immediateIds[t] && (n.clearTimeout(t), delete this._immediateIds[t]);
    }, e.prototype.setInterval = function(t, r) {
      var n = this, o = 0;
      return this._isDisposed || (this._intervalIds || (this._intervalIds = {}), o = setInterval(function() {
        try {
          t.apply(n._parent);
        } catch (a) {
          n._logError(a);
        }
      }, r), this._intervalIds[o] = !0), o;
    }, e.prototype.clearInterval = function(t) {
      this._intervalIds && this._intervalIds[t] && (clearInterval(t), delete this._intervalIds[t]);
    }, e.prototype.throttle = function(t, r, n) {
      var o = this;
      if (this._isDisposed)
        return this._noop;
      var a = r || 0, i = !0, s = !0, l = 0, c, u, d = null;
      n && typeof n.leading == "boolean" && (i = n.leading), n && typeof n.trailing == "boolean" && (s = n.trailing);
      var f = function(g) {
        var b = Date.now(), x = b - l, m = i ? a - x : a;
        return x >= a && (!g || i) ? (l = b, d && (o.clearTimeout(d), d = null), c = t.apply(o._parent, u)) : d === null && s && (d = o.setTimeout(f, m)), c;
      }, p = function() {
        for (var g = [], b = 0; b < arguments.length; b++)
          g[b] = arguments[b];
        return u = g, f(!0);
      };
      return p;
    }, e.prototype.debounce = function(t, r, n) {
      var o = this;
      if (this._isDisposed) {
        var a = function() {
        };
        return a.cancel = function() {
        }, a.flush = function() {
          return null;
        }, a.pending = function() {
          return !1;
        }, a;
      }
      var i = r || 0, s = !1, l = !0, c = null, u = 0, d = Date.now(), f, p, g = null;
      n && typeof n.leading == "boolean" && (s = n.leading), n && typeof n.trailing == "boolean" && (l = n.trailing), n && typeof n.maxWait == "number" && !isNaN(n.maxWait) && (c = n.maxWait);
      var b = function(S) {
        g && (o.clearTimeout(g), g = null), d = S;
      }, x = function(S) {
        b(S), f = t.apply(o._parent, p);
      }, m = function(S) {
        var _ = Date.now(), P = !1;
        S && (s && _ - u >= i && (P = !0), u = _);
        var D = _ - u, z = i - D, q = _ - d, I = !1;
        return c !== null && (q >= c && g ? I = !0 : z = Math.min(z, c - q)), D >= i || I || P ? x(_) : (g === null || !S) && l && (g = o.setTimeout(m, z)), f;
      }, y = function() {
        return !!g;
      }, C = function() {
        y() && b(Date.now());
      }, E = function() {
        return y() && x(Date.now()), f;
      }, k = function() {
        for (var S = [], _ = 0; _ < arguments.length; _++)
          S[_] = arguments[_];
        return p = S, m(!0);
      };
      return k.cancel = C, k.flush = E, k.pending = y, k;
    }, e.prototype.requestAnimationFrame = function(t, r) {
      var n = this, o = 0, a = ce(r);
      if (!this._isDisposed) {
        this._animationFrameIds || (this._animationFrameIds = {});
        var i = function() {
          try {
            n._animationFrameIds && delete n._animationFrameIds[o], t.apply(n._parent);
          } catch (s) {
            n._logError(s);
          }
        };
        o = a.requestAnimationFrame ? a.requestAnimationFrame(i) : a.setTimeout(i, 0), this._animationFrameIds[o] = !0;
      }
      return o;
    }, e.prototype.cancelAnimationFrame = function(t, r) {
      var n = ce(r);
      this._animationFrameIds && this._animationFrameIds[t] && (n.cancelAnimationFrame ? n.cancelAnimationFrame(t) : n.clearTimeout(t), delete this._animationFrameIds[t]);
    }, e.prototype._logError = function(t) {
      this._onErrorHandler && this._onErrorHandler(t);
    }, e;
  }()
);
function Ju(e) {
  return e && !!e._virtual;
}
function Zu(e) {
  var t;
  return e && Ju(e) && (t = e._virtual.parent), t;
}
function Us(e, t) {
  return t === void 0 && (t = !0), e && (t && Zu(e) || e.parentNode && e.parentNode);
}
function Lo(e, t, r) {
  r === void 0 && (r = !0);
  var n = !1;
  if (e && t)
    if (r)
      if (e === t)
        n = !0;
      else
        for (n = !1; t; ) {
          var o = Us(t);
          if (o === e) {
            n = !0;
            break;
          }
          t = o;
        }
    else
      e.contains && (n = e.contains(t));
  return n;
}
function qs(e, t, r) {
  return r != null || (r = document), !e || e === r.body ? null : t(e) ? e : qs(Us(e), t);
}
var Bo = "data-portal-element";
function ed(e) {
  e.setAttribute(Bo, "true");
}
function td(e, t, r) {
  var n = qs(e, function(o) {
    return t === o || o.hasAttribute(Bo);
  }, r);
  return n !== null && n.hasAttribute(Bo);
}
function rd(e, t) {
  var r = e, n = t;
  r._virtual || (r._virtual = {
    children: []
  });
  var o = r._virtual.parent;
  if (o && o !== t) {
    var a = o._virtual.children.indexOf(r);
    a > -1 && o._virtual.children.splice(a, 1);
  }
  r._virtual.parent = n || void 0, n && (n._virtual || (n._virtual = {
    children: []
  }), n._virtual.children.push(r));
}
function We(e) {
  if (!(!ca() || typeof document == "undefined")) {
    var t = e;
    return t && t.ownerDocument ? t.ownerDocument : document;
  }
}
var nd = "data-is-focusable", od = "data-is-visible", ad = "data-focuszone-id", id = "data-is-sub-focuszone";
function sd(e, t) {
  var r = rn(e, e, !0, !1, !1, !0, void 0, void 0, t);
  return r ? (hd(r), !0) : !1;
}
function rn(e, t, r, n, o, a, i, s, l) {
  if (!t || t === e && o && !i)
    return null;
  var c = l ? ld : Gs, u = c(t);
  if (r && u && cd(t, s))
    return t;
  if (!o && u && (a || !(ud(t) || dd(t)))) {
    var d = rn(e, t.firstElementChild, !0, !0, !1, a, i, s, l);
    if (d)
      return d;
  }
  if (t === e)
    return null;
  var f = rn(e, t.nextElementSibling, !0, !0, !1, a, i, s, l);
  return f || (n ? null : rn(e, t.parentElement, !1, !1, !0, a, i, s, l));
}
function Gs(e) {
  if (!e || !e.getAttribute)
    return !1;
  var t = e.getAttribute(od);
  return t != null ? t === "true" : e.offsetHeight !== 0 || e.offsetParent !== null || // eslint-disable-next-line @typescript-eslint/no-explicit-any
  e.isVisible === !0;
}
function ld(e, t) {
  var r = t != null ? t : ce();
  return !!e && Gs(e) && !e.hidden && r.getComputedStyle(e).visibility !== "hidden";
}
function cd(e, t) {
  if (!e || e.disabled)
    return !1;
  var r = 0, n = null;
  e && e.getAttribute && (n = e.getAttribute("tabIndex"), n && (r = parseInt(n, 10)));
  var o = e.getAttribute ? e.getAttribute(nd) : null, a = n !== null && r >= 0, i = !!e && o !== "false" && (e.tagName === "A" || e.tagName === "BUTTON" || e.tagName === "INPUT" || e.tagName === "TEXTAREA" || e.tagName === "SELECT" || o === "true" || a);
  return t ? r !== -1 && i : i;
}
function ud(e) {
  return !!(e && e.getAttribute && e.getAttribute(ad));
}
function dd(e) {
  return !!(e && e.getAttribute && e.getAttribute(id) === "true");
}
function fd(e) {
  var t = We(e), r = t && t.activeElement;
  return !!(r && Lo(e, r));
}
var Wr = void 0;
function hd(e) {
  if (e) {
    var t = ce(e);
    t && (Wr !== void 0 && t.cancelAnimationFrame(Wr), Wr = t.requestAnimationFrame(function() {
      e && e.focus(), Wr = void 0;
    }));
  }
}
function lt(e, t, r, n) {
  return e.addEventListener(t, r, n), function() {
    return e.removeEventListener(t, r, n);
  };
}
function vd(e, t) {
  if (!e || !t)
    return !e && !t;
  for (var r in e)
    if (e.hasOwnProperty(r) && (!t.hasOwnProperty(r) || t[r] !== e[r]))
      return !1;
  for (var r in t)
    if (t.hasOwnProperty(r) && !e.hasOwnProperty(r))
      return !1;
  return !0;
}
function pd(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return gd.apply(this, [null, e].concat(t));
}
function gd(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  t = t || {};
  for (var o = 0, a = r; o < a.length; o++) {
    var i = a[o];
    if (i)
      for (var s in i)
        i.hasOwnProperty(s) && (!e || e(s)) && (t[s] = i[s]);
  }
  return t;
}
var ao;
sa({
  overflow: "hidden !important"
});
function md(e) {
  if (ao === void 0) {
    var t = e != null ? e : We(), r = t.createElement("div");
    r.style.setProperty("width", "100px"), r.style.setProperty("height", "100px"), r.style.setProperty("overflow", "scroll"), r.style.setProperty("position", "absolute"), r.style.setProperty("top", "-9999px"), t.body.appendChild(r), ao = r.offsetWidth - r.clientWidth, t.body.removeChild(r);
  }
  return ao;
}
function ot(e) {
  console && console.warn && console.warn(e);
}
function bd(e, t, r, n, o) {
  if (o === !0 && process.env.NODE_ENV !== "production")
    for (var a = 0, i = r; a < i.length; a++) {
      var s = i[a];
      s in t || ot("".concat(e, " property '").concat(s, "' is required when '").concat(n, "' is used.'"));
    }
}
function Ys(e, t, r) {
  if (process.env.NODE_ENV !== "production") {
    for (var n in r)
      if (t && t[n] !== void 0) {
        var o = r[n];
        o && t[o] !== void 0 && ot("".concat(e, " property '").concat(n, "' is mutually exclusive with '").concat(r[n], "'. ") + "Use one or the other.");
      }
  }
}
function da(e, t, r) {
  if (process.env.NODE_ENV !== "production") {
    for (var n in r)
      if (t && n in t) {
        var o = "".concat(e, " property '").concat(n, "' was used but has been deprecated."), a = r[n];
        a && (o += " Use '".concat(a, "' instead.")), ot(o);
      }
  }
}
var yd = (
  /** @class */
  function(e) {
    dt(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.state = {
        isRendered: ce() === void 0
      }, n;
    }
    return t.prototype.componentDidMount = function() {
      var r = this, n = this.props.delay;
      this._timeoutId = window.setTimeout(function() {
        r.setState({
          isRendered: !0
        });
      }, n);
    }, t.prototype.componentWillUnmount = function() {
      this._timeoutId && clearTimeout(this._timeoutId);
    }, t.prototype.render = function() {
      return this.state.isRendered ? h.Children.only(this.props.children) : null;
    }, t.defaultProps = {
      delay: 0
    }, t;
  }(h.Component)
), io = "__globalSettings__", fa = "__callbacks__", _d = 0, Ks = (
  /** @class */
  function() {
    function e() {
    }
    return e.getValue = function(t, r) {
      var n = Mo();
      return n[t] === void 0 && (n[t] = typeof r == "function" ? r() : r), n[t];
    }, e.setValue = function(t, r) {
      var n = Mo(), o = n[fa], a = n[t];
      if (r !== a) {
        n[t] = r;
        var i = {
          oldValue: a,
          value: r,
          key: t
        };
        for (var s in o)
          o.hasOwnProperty(s) && o[s](i);
      }
      return r;
    }, e.addChangeListener = function(t) {
      var r = t.__id__, n = di();
      r || (r = t.__id__ = String(_d++)), n[r] = t;
    }, e.removeChangeListener = function(t) {
      var r = di();
      delete r[t.__id__];
    }, e;
  }()
);
function Mo() {
  var e, t = ce(), r = t || {};
  return r[io] || (r[io] = (e = {}, e[fa] = {}, e)), r[io];
}
function di() {
  var e = Mo();
  return e[fa];
}
var me = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  ctrl: 17,
  alt: 18,
  pauseBreak: 19,
  capslock: 20,
  escape: 27,
  space: 32,
  pageUp: 33,
  pageDown: 34,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  insert: 45,
  del: 46,
  zero: 48,
  one: 49,
  two: 50,
  three: 51,
  four: 52,
  five: 53,
  six: 54,
  seven: 55,
  eight: 56,
  nine: 57,
  colon: 58,
  a: 65,
  b: 66,
  c: 67,
  d: 68,
  e: 69,
  f: 70,
  g: 71,
  h: 72,
  i: 73,
  j: 74,
  k: 75,
  l: 76,
  m: 77,
  n: 78,
  o: 79,
  p: 80,
  q: 81,
  r: 82,
  s: 83,
  t: 84,
  u: 85,
  v: 86,
  w: 87,
  x: 88,
  y: 89,
  z: 90,
  leftWindow: 91,
  rightWindow: 92,
  select: 93,
  /* eslint-disable @typescript-eslint/naming-convention */
  zero_numpad: 96,
  one_numpad: 97,
  two_numpad: 98,
  three_numpad: 99,
  four_numpad: 100,
  five_numpad: 101,
  six_numpad: 102,
  seven_numpad: 103,
  eight_numpad: 104,
  nine_numpad: 105,
  /* eslint-enable @typescript-eslint/naming-convention */
  multiply: 106,
  add: 107,
  subtract: 109,
  decimalPoint: 110,
  divide: 111,
  f1: 112,
  f2: 113,
  f3: 114,
  f4: 115,
  f5: 116,
  f6: 117,
  f7: 118,
  f8: 119,
  f9: 120,
  f10: 121,
  f11: 122,
  f12: 123,
  numlock: 144,
  scrollLock: 145,
  semicolon: 186,
  equalSign: 187,
  comma: 188,
  dash: 189,
  period: 190,
  forwardSlash: 191,
  graveAccent: 192,
  openBracket: 219,
  backSlash: 220,
  closeBracket: 221,
  singleQuote: 222
}, Ke = (
  /** @class */
  function() {
    function e(t, r, n, o) {
      t === void 0 && (t = 0), r === void 0 && (r = 0), n === void 0 && (n = 0), o === void 0 && (o = 0), this.top = n, this.bottom = o, this.left = t, this.right = r;
    }
    return Object.defineProperty(e.prototype, "width", {
      /**
       * Calculated automatically by subtracting the right from left
       */
      get: function() {
        return this.right - this.left;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "height", {
      /**
       * Calculated automatically by subtracting the bottom from top.
       */
      get: function() {
        return this.bottom - this.top;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.equals = function(t) {
      return parseFloat(this.top.toFixed(4)) === parseFloat(t.top.toFixed(4)) && parseFloat(this.bottom.toFixed(4)) === parseFloat(t.bottom.toFixed(4)) && parseFloat(this.left.toFixed(4)) === parseFloat(t.left.toFixed(4)) && parseFloat(this.right.toFixed(4)) === parseFloat(t.right.toFixed(4));
    }, e;
  }()
);
function xd(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return t.length < 2 ? t[0] : function() {
    for (var n = [], o = 0; o < arguments.length; o++)
      n[o] = arguments[o];
    t.forEach(function(a) {
      return a && a.apply(e, n);
    });
  };
}
function Xs(e) {
  var t = null;
  try {
    var r = ce();
    t = r ? r.sessionStorage.getItem(e) : null;
  } catch (n) {
  }
  return t;
}
function Cd(e, t) {
  var r;
  try {
    (r = ce()) === null || r === void 0 || r.sessionStorage.setItem(e, t);
  } catch (n) {
  }
}
var Qs = "isRTL", pt;
function Sr(e) {
  if (e === void 0 && (e = {}), e.rtl !== void 0)
    return e.rtl;
  if (pt === void 0) {
    var t = Xs(Qs);
    t !== null && (pt = t === "1", Ed(pt));
    var r = We();
    pt === void 0 && r && (pt = (r.body && r.body.getAttribute("dir") || r.documentElement.getAttribute("dir")) === "rtl", Ms(pt));
  }
  return !!pt;
}
function Ed(e, t) {
  t === void 0 && (t = !1);
  var r = We();
  r && r.documentElement.setAttribute("dir", e ? "rtl" : "ltr"), t && Cd(Qs, e ? "1" : "0"), pt = e, Ms(pt);
}
var wd = 50, Sd = 5, nn = 0, so = Qe.getInstance();
so && so.onReset && so.onReset(function() {
  return nn++;
});
var Ur = "__retval__";
function Ue(e) {
  e === void 0 && (e = {});
  var t = /* @__PURE__ */ new Map(), r = 0, n = 0, o = nn, a = function(i, s) {
    var l;
    if (s === void 0 && (s = {}), e.useStaticStyles && typeof i == "function" && i.__noStyleOverride__)
      return i(s);
    n++;
    var c = t, u = s.theme, d = u && u.rtl !== void 0 ? u.rtl : Sr(), f = e.disableCaching;
    if (o !== nn && (o = nn, t = /* @__PURE__ */ new Map(), r = 0), e.disableCaching || (c = fi(t, i), c = fi(c, s)), (f || !c[Ur]) && (i === void 0 ? c[Ur] = {} : c[Ur] = zs([
      typeof i == "function" ? i(s) : i
    ], { rtl: !!d, specificityMultiplier: e.useStaticStyles ? Sd : void 0 }), f || r++), r > (e.cacheSize || wd)) {
      var p = ce();
      !((l = p == null ? void 0 : p.FabricConfig) === null || l === void 0) && l.enableClassNameCacheFullWarning && (console.warn("Styles are being recalculated too frequently. Cache miss rate is ".concat(r, "/").concat(n, ".")), console.trace()), t.clear(), r = 0, e.disableCaching = !0;
    }
    return c[Ur];
  };
  return a;
}
function lo(e, t) {
  return t = kd(t), e.has(t) || e.set(t, /* @__PURE__ */ new Map()), e.get(t);
}
function fi(e, t) {
  if (typeof t == "function") {
    var r = t.__cachedInputs__;
    if (r)
      for (var n = 0, o = t.__cachedInputs__; n < o.length; n++) {
        var a = o[n];
        e = lo(e, a);
      }
    else
      e = lo(e, t);
  } else if (typeof t == "object")
    for (var i in t)
      t.hasOwnProperty(i) && (e = lo(e, t[i]));
  return e;
}
function kd(e) {
  switch (e) {
    case void 0:
      return "__undefined__";
    case null:
      return "__null__";
    default:
      return e;
  }
}
var hi = !1, on = 0, Td = { empty: !0 }, co = {}, jo = typeof WeakMap == "undefined" ? null : WeakMap;
function Rd() {
  on++;
}
function Mn(e, t, r) {
  if (t === void 0 && (t = 100), r === void 0 && (r = !1), !jo)
    return e;
  if (!hi) {
    var n = Qe.getInstance();
    n && n.onReset && Qe.getInstance().onReset(Rd), hi = !0;
  }
  var o, a = 0, i = on;
  return function() {
    for (var l = [], c = 0; c < arguments.length; c++)
      l[c] = arguments[c];
    var u = o;
    (o === void 0 || i !== on || t > 0 && a > t) && (o = vi(), a = 0, i = on), u = o;
    for (var d = 0; d < l.length; d++) {
      var f = Nd(l[d]);
      u.map.has(f) || u.map.set(f, vi()), u = u.map.get(f);
    }
    return u.hasOwnProperty("value") || (u.value = e.apply(void 0, l), a++), r && (u.value === null || u.value === void 0) && (u.value = e.apply(void 0, l)), u.value;
  };
}
function Nd(e) {
  if (e) {
    if (typeof e == "object" || typeof e == "function")
      return e;
    co[e] || (co[e] = { val: e });
  } else
    return Td;
  return co[e];
}
function vi() {
  return {
    map: jo ? new jo() : null
  };
}
function Fo(e, t) {
  return e[t] !== void 0 && e[t] !== null;
}
function ha() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = [], n = 0, o = e; n < o.length; n++) {
    var a = o[n];
    if (a)
      if (typeof a == "string")
        r.push(a);
      else if (a.hasOwnProperty("toString") && typeof a.toString == "function")
        r.push(a.toString());
      else
        for (var i in a)
          a[i] && r.push(i);
  }
  return r.join(" ");
}
var Pd = "customizations", Id = { settings: {}, scopedSettings: {}, inCustomizerContext: !1 }, mt = Ks.getValue(Pd, {
  settings: {},
  scopedSettings: {},
  inCustomizerContext: !1
}), qr = [], Et = (
  /** @class */
  function() {
    function e() {
    }
    return e.reset = function() {
      mt.settings = {}, mt.scopedSettings = {};
    }, e.applySettings = function(t) {
      mt.settings = w(w({}, mt.settings), t), e._raiseChange();
    }, e.applyScopedSettings = function(t, r) {
      mt.scopedSettings[t] = w(w({}, mt.scopedSettings[t]), r), e._raiseChange();
    }, e.getSettings = function(t, r, n) {
      n === void 0 && (n = Id);
      for (var o = {}, a = r && n.scopedSettings[r] || {}, i = r && mt.scopedSettings[r] || {}, s = 0, l = t; s < l.length; s++) {
        var c = l[s];
        o[c] = a[c] || n.settings[c] || i[c] || mt.settings[c];
      }
      return o;
    }, e.applyBatchedUpdates = function(t, r) {
      e._suppressUpdates = !0;
      try {
        t();
      } catch (n) {
      }
      e._suppressUpdates = !1, r || e._raiseChange();
    }, e.observe = function(t) {
      qr.push(t);
    }, e.unobserve = function(t) {
      qr = qr.filter(function(r) {
        return r !== t;
      });
    }, e._raiseChange = function() {
      e._suppressUpdates || qr.forEach(function(t) {
        return t();
      });
    }, e;
  }()
), Ho = h.createContext({
  customizations: {
    inCustomizerContext: !1,
    settings: {},
    scopedSettings: {}
  }
});
function Od(e, t) {
  e === void 0 && (e = {});
  var r = Js(t) ? t : Dd(t);
  return r(e);
}
function Ad(e, t) {
  e === void 0 && (e = {});
  var r = Js(t) ? t : Ld(t);
  return r(e);
}
function Js(e) {
  return typeof e == "function";
}
function Dd(e) {
  return function(t) {
    return e ? w(w({}, t), e) : t;
  };
}
function Ld(e) {
  return e === void 0 && (e = {}), function(t) {
    var r = w({}, t);
    for (var n in e)
      e.hasOwnProperty(n) && (r[n] = w(w({}, t[n]), e[n]));
    return r;
  };
}
function Bd(e, t) {
  var r = (t || {}).customizations, n = r === void 0 ? { settings: {}, scopedSettings: {} } : r;
  return {
    customizations: {
      settings: Od(n.settings, e.settings),
      scopedSettings: Ad(n.scopedSettings, e.scopedSettings),
      inCustomizerContext: !0
    }
  };
}
var Md = (
  /** @class */
  function(e) {
    dt(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._onCustomizationChange = function() {
        return r.forceUpdate();
      }, r;
    }
    return t.prototype.componentDidMount = function() {
      Et.observe(this._onCustomizationChange);
    }, t.prototype.componentWillUnmount = function() {
      Et.unobserve(this._onCustomizationChange);
    }, t.prototype.render = function() {
      var r = this, n = this.props.contextTransform;
      return h.createElement(Ho.Consumer, null, function(o) {
        var a = Bd(r.props, o);
        return n && (a = n(a)), h.createElement(Ho.Provider, { value: a }, r.props.children);
      });
    }, t;
  }(h.Component)
);
function jd(e, t) {
  var r = Fd(), n = h.useContext(Ho).customizations, o = n.inCustomizerContext;
  return h.useEffect(function() {
    return o || Et.observe(r), function() {
      o || Et.unobserve(r);
    };
  }, [o]), Et.getSettings(e, t, n);
}
function Fd() {
  var e = h.useState(0), t = e[1];
  return function() {
    return t(function(r) {
      return ++r;
    });
  };
}
function Hd(e, t) {
  for (var r in t)
    t.hasOwnProperty(r) && (e[r] = xd(e, e[r], t[r]));
}
var fn = "__currentId__", $d = "id__", hn = ce() || {};
hn[fn] === void 0 && (hn[fn] = 0);
var pi = !1;
function Ct(e) {
  if (!pi) {
    var t = Qe.getInstance();
    t && t.onReset && t.onReset(Vd), pi = !0;
  }
  var r = hn[fn]++;
  return (e === void 0 ? $d : e) + r;
}
function Vd(e) {
  e === void 0 && (e = 0), hn[fn] = e;
}
var de = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = {}, n = 0, o = e; n < o.length; n++)
    for (var a = o[n], i = Array.isArray(a) ? a : Object.keys(a), s = 0, l = i; s < l.length; s++) {
      var c = l[s];
      r[c] = 1;
    }
  return r;
}, zd = de([
  "onCopy",
  "onCut",
  "onPaste",
  "onCompositionEnd",
  "onCompositionStart",
  "onCompositionUpdate",
  "onFocus",
  "onFocusCapture",
  "onBlur",
  "onBlurCapture",
  "onChange",
  "onInput",
  "onSubmit",
  "onLoad",
  "onError",
  "onKeyDown",
  "onKeyDownCapture",
  "onKeyPress",
  "onKeyUp",
  "onAbort",
  "onCanPlay",
  "onCanPlayThrough",
  "onDurationChange",
  "onEmptied",
  "onEncrypted",
  "onEnded",
  "onLoadedData",
  "onLoadedMetadata",
  "onLoadStart",
  "onPause",
  "onPlay",
  "onPlaying",
  "onProgress",
  "onRateChange",
  "onSeeked",
  "onSeeking",
  "onStalled",
  "onSuspend",
  "onTimeUpdate",
  "onVolumeChange",
  "onWaiting",
  "onClick",
  "onClickCapture",
  "onContextMenu",
  "onDoubleClick",
  "onDrag",
  "onDragEnd",
  "onDragEnter",
  "onDragExit",
  "onDragLeave",
  "onDragOver",
  "onDragStart",
  "onDrop",
  "onMouseDown",
  "onMouseDownCapture",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onMouseUpCapture",
  "onSelect",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onScroll",
  "onWheel",
  "onPointerCancel",
  "onPointerDown",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerMove",
  "onPointerOut",
  "onPointerOver",
  "onPointerUp",
  "onGotPointerCapture",
  "onLostPointerCapture"
]), Wd = de([
  "accessKey",
  "children",
  "className",
  "contentEditable",
  "dir",
  "draggable",
  "hidden",
  "htmlFor",
  "id",
  "lang",
  "ref",
  "role",
  "style",
  "tabIndex",
  "title",
  "translate",
  "spellCheck",
  "name"
  // global
]), Se = de(Wd, zd);
de(Se, [
  "form"
  // button, fieldset, input, label, meter, object, output, select, textarea
]);
var Ud = de(Se, [
  "height",
  "loop",
  "muted",
  "preload",
  "src",
  "width"
  // canvas, embed, iframe, img, input, object, video
]);
de(Ud, [
  "poster"
  // video
]);
de(Se, [
  "start"
  // ol
]);
de(Se, [
  "value"
  // button, input, li, option, meter, progress, param
]);
de(Se, [
  "download",
  "href",
  "hrefLang",
  "media",
  "rel",
  "target",
  "type"
  // a, button, input, link, menu, object, script, source, style
]);
var va = de(Se, [
  "autoFocus",
  "disabled",
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "type",
  "value"
  // button, input, li, option, meter, progress, param,
]), Zs = de(va, [
  "accept",
  "alt",
  "autoCapitalize",
  "autoComplete",
  "checked",
  "dirname",
  "form",
  "height",
  "inputMode",
  "list",
  "max",
  "maxLength",
  "min",
  "minLength",
  "multiple",
  "pattern",
  "placeholder",
  "readOnly",
  "required",
  "src",
  "step",
  "size",
  "type",
  "value",
  "width"
  // canvas, embed, iframe, img, input, object, video
]), qd = de(va, [
  "autoCapitalize",
  "cols",
  "dirname",
  "form",
  "maxLength",
  "minLength",
  "placeholder",
  "readOnly",
  "required",
  "rows",
  "wrap"
  // textarea
]);
de(va, [
  "form",
  "multiple",
  "required"
  // input, select, textarea
]);
de(Se, [
  "selected",
  "value"
  // button, input, li, option, meter, progress, param
]);
de(Se, [
  "cellPadding",
  "cellSpacing"
  // table
]);
de(Se, [
  "rowSpan",
  "scope"
  // th
]);
de(Se, [
  "colSpan",
  "headers",
  "rowSpan",
  "scope"
  // th
]);
de(Se, [
  "span"
  // col, colgroup
]);
de(Se, [
  "span"
  // col, colgroup
]);
de(Se, [
  "acceptCharset",
  "action",
  "encType",
  "encType",
  "method",
  "noValidate",
  "target"
  // form
]);
de(Se, [
  "allow",
  "allowFullScreen",
  "allowPaymentRequest",
  "allowTransparency",
  "csp",
  "height",
  "importance",
  "referrerPolicy",
  "sandbox",
  "src",
  "srcDoc",
  "width"
  // canvas, embed, iframe, img, input, object, video,
]);
var Gd = de(Se, [
  "alt",
  "crossOrigin",
  "height",
  "src",
  "srcSet",
  "useMap",
  "width"
  // canvas, embed, iframe, img, input, object, video
]), fr = Se;
function Je(e, t, r) {
  for (var n = Array.isArray(t), o = {}, a = Object.keys(e), i = 0, s = a; i < s.length; i++) {
    var l = s[i], c = !n && t[l] || n && t.indexOf(l) >= 0 || l.indexOf("data-") === 0 || l.indexOf("aria-") === 0;
    c && (!r || (r == null ? void 0 : r.indexOf(l)) === -1) && (o[l] = e[l]);
  }
  return o;
}
function Ir(e) {
  Hd(e, {
    componentDidMount: Yd,
    componentDidUpdate: Kd,
    componentWillUnmount: Xd
  });
}
function Yd() {
  vn(this.props.componentRef, this);
}
function Kd(e) {
  e.componentRef !== this.props.componentRef && (vn(e.componentRef, null), vn(this.props.componentRef, this));
}
function Xd() {
  vn(this.props.componentRef, null);
}
function vn(e, t) {
  e && (typeof e == "object" ? e.current = t : typeof e == "function" && e(t));
}
var tt, Qd = (tt = {}, tt[me.up] = 1, tt[me.down] = 1, tt[me.left] = 1, tt[me.right] = 1, tt[me.home] = 1, tt[me.end] = 1, tt[me.tab] = 1, tt[me.pageUp] = 1, tt[me.pageDown] = 1, tt);
function el(e) {
  return !!Qd[e];
}
var Ft = "ms-Fabric--isFocusVisible", gi = "ms-Fabric--isFocusHidden";
function mi(e, t) {
  e && (e.classList.add(t ? Ft : gi), e.classList.remove(t ? gi : Ft));
}
function jn(e, t, r) {
  var n;
  r ? r.forEach(function(o) {
    return mi(o.current, e);
  }) : mi((n = ce(t)) === null || n === void 0 ? void 0 : n.document.body, e);
}
var bi = /* @__PURE__ */ new WeakMap(), yi = /* @__PURE__ */ new WeakMap();
function _i(e, t) {
  var r, n = bi.get(e);
  return n ? r = n + t : r = 1, bi.set(e, r), r;
}
function Jd(e) {
  var t = yi.get(e);
  if (t)
    return t;
  var r = function(i) {
    return tl(i, e.registeredProviders);
  }, n = function(i) {
    return rl(i, e.registeredProviders);
  }, o = function(i) {
    return nl(i, e.registeredProviders);
  }, a = function(i) {
    return ol(i, e.registeredProviders);
  };
  return t = { onMouseDown: r, onPointerDown: n, onKeyDown: o, onKeyUp: a }, yi.set(e, t), t;
}
var pn = h.createContext(void 0);
function Zd(e) {
  var t = h.useContext(pn);
  h.useEffect(function() {
    var r, n, o, a, i = ce(e == null ? void 0 : e.current);
    if (!(!i || ((r = i.FabricConfig) === null || r === void 0 ? void 0 : r.disableFocusRects) === !0)) {
      var s = i, l, c, u, d;
      if (!((n = t == null ? void 0 : t.providerRef) === null || n === void 0) && n.current && (!((a = (o = t == null ? void 0 : t.providerRef) === null || o === void 0 ? void 0 : o.current) === null || a === void 0) && a.addEventListener)) {
        s = t.providerRef.current;
        var f = (
          /*@__NOINLINE__*/
          Jd(t)
        );
        l = f.onMouseDown, c = f.onPointerDown, u = f.onKeyDown, d = f.onKeyUp;
      } else
        l = tl, c = rl, u = nl, d = ol;
      var p = _i(s, 1);
      return p <= 1 && (s.addEventListener("mousedown", l, !0), s.addEventListener("pointerdown", c, !0), s.addEventListener("keydown", u, !0), s.addEventListener("keyup", d, !0)), function() {
        var g;
        !i || ((g = i.FabricConfig) === null || g === void 0 ? void 0 : g.disableFocusRects) === !0 || (p = _i(s, -1), p === 0 && (s.removeEventListener("mousedown", l, !0), s.removeEventListener("pointerdown", c, !0), s.removeEventListener("keydown", u, !0), s.removeEventListener("keyup", d, !0)));
      };
    }
  }, [t, e]);
}
function tl(e, t) {
  jn(!1, e.target, t);
}
function rl(e, t) {
  e.pointerType !== "mouse" && jn(!1, e.target, t);
}
function nl(e, t) {
  el(e.which) && jn(!0, e.target, t);
}
function ol(e, t) {
  el(e.which) && jn(!0, e.target, t);
}
var al = function(e) {
  var t = e.providerRef, r = e.layerRoot, n = h.useState([])[0], o = h.useContext(pn), a = o !== void 0 && !r, i = h.useMemo(function() {
    return a ? void 0 : {
      providerRef: t,
      registeredProviders: n,
      registerProvider: function(s) {
        n.push(s), o == null || o.registerProvider(s);
      },
      unregisterProvider: function(s) {
        o == null || o.unregisterProvider(s);
        var l = n.indexOf(s);
        l >= 0 && n.splice(l, 1);
      }
    };
  }, [t, n, o, a]);
  return h.useEffect(function() {
    if (i)
      return i.registerProvider(i.providerRef), function() {
        return i.unregisterProvider(i.providerRef);
      };
  }, [i]), i ? h.createElement(pn.Provider, { value: i }, e.children) : h.createElement(h.Fragment, null, e.children);
};
function ef(e) {
  var t = null;
  try {
    var r = ce();
    t = r ? r.localStorage.getItem(e) : null;
  } catch (n) {
  }
  return t;
}
var Tt, xi = "language";
function tf(e) {
  if (e === void 0 && (e = "sessionStorage"), Tt === void 0) {
    var t = We(), r = e === "localStorage" ? ef(xi) : e === "sessionStorage" ? Xs(xi) : void 0;
    r && (Tt = r), Tt === void 0 && t && (Tt = t.documentElement.getAttribute("lang")), Tt === void 0 && (Tt = "en");
  }
  return Tt;
}
function Ci(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  for (var n = 0, o = t; n < o.length; n++) {
    var a = o[n];
    il(e || {}, a);
  }
  return e;
}
function il(e, t, r) {
  r === void 0 && (r = []), r.push(t);
  for (var n in t)
    if (t.hasOwnProperty(n) && n !== "__proto__" && n !== "constructor" && n !== "prototype") {
      var o = t[n];
      if (typeof o == "object" && o !== null && !Array.isArray(o)) {
        var a = r.indexOf(o) > -1;
        e[n] = a ? o : il(e[n] || {}, o, r);
      } else
        e[n] = o;
    }
  return r.pop(), e;
}
var rf = ["TEMPLATE", "STYLE", "SCRIPT"];
function nf(e) {
  var t = We(e);
  if (!t)
    return function() {
    };
  for (var r = []; e !== t.body && e.parentElement; ) {
    for (var n = 0, o = e.parentElement.children; n < o.length; n++) {
      var a = o[n], i = a.getAttribute("aria-hidden");
      a !== e && (i == null ? void 0 : i.toLowerCase()) !== "true" && rf.indexOf(a.tagName) === -1 && r.push([a, i]);
    }
    e = e.parentElement;
  }
  return r.forEach(function(s) {
    var l = s[0];
    l.setAttribute("aria-hidden", "true");
  }), function() {
    of(r), r = [];
  };
}
function of(e) {
  e.forEach(function(t) {
    var r = t[0], n = t[1];
    n ? r.setAttribute("aria-hidden", n) : r.removeAttribute("aria-hidden");
  });
}
function af(e) {
  return e.clientWidth < e.scrollWidth;
}
function sf(e) {
  return e.clientHeight < e.scrollHeight;
}
function lf(e) {
  return af(e) || sf(e);
}
var cf = ["theme", "styles"];
function qe(e, t, r, n, o) {
  n = n || { scope: "", fields: void 0 };
  var a = n.scope, i = n.fields, s = i === void 0 ? cf : i, l = h.forwardRef(function(u, d) {
    var f = h.useRef(), p = jd(s, a), g = p.styles;
    p.dir;
    var b = Ls(p, ["styles", "dir"]), x = r ? r(u) : void 0, m = f.current && f.current.__cachedInputs__ || [], y = u.styles;
    if (!f.current || g !== m[1] || y !== m[2]) {
      var C = function(E) {
        return Xu(E, t, g, y);
      };
      C.__cachedInputs__ = [
        t,
        g,
        y
      ], C.__noStyleOverride__ = !g && !y, f.current = C;
    }
    return h.createElement(e, w({ ref: d }, b, x, u, { styles: f.current }));
  });
  l.displayName = "Styled".concat(e.displayName || e.name);
  var c = o ? h.memo(l) : l;
  return l.displayName && (c.displayName = l.displayName), c;
}
var Rt;
process.env.NODE_ENV !== "production" && (Rt = {
  valueOnChange: {},
  valueDefaultValue: {},
  controlledToUncontrolled: {},
  uncontrolledToControlled: {}
});
function sl(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = e.componentId, r = e.componentName, n = e.defaultValueProp, o = e.props, a = e.oldProps, i = e.onChangeProp, s = e.readOnlyProp, l = e.valueProp, c = a ? Fo(a, l) : void 0, u = Fo(o, l);
    if (u) {
      var d = !!o[i], f = !!(s && o[s]);
      !(d || f) && !Rt.valueOnChange[t] && (Rt.valueOnChange[t] = !0, ot("Warning: You provided a '".concat(String(l), "' prop to a ").concat(String(r), " without an '").concat(String(i), "' handler. ") + "This will render a read-only field. If the field should be mutable use '".concat(String(n), "'. ") + "Otherwise, set '".concat(String(i), "'").concat(s ? " or '".concat(String(s), "'") : "", ".")));
      var p = o[n];
      p != null && !Rt.valueDefaultValue[t] && (Rt.valueDefaultValue[t] = !0, ot("Warning: You provided both '".concat(String(l), "' and '").concat(String(n), "' to a ").concat(r, ". ") + "Form fields must be either controlled or uncontrolled (specify either the '".concat(String(l), "' prop, ") + "or the '".concat(String(n), "' prop, but not both). Decide between using a controlled or uncontrolled ") + "".concat(r, " and remove one of these props. More info: https://fb.me/react-controlled-components")));
    }
    if (a && u !== c) {
      var g = c ? "a controlled" : "an uncontrolled", b = c ? "uncontrolled" : "controlled", x = c ? Rt.controlledToUncontrolled : Rt.uncontrolledToControlled;
      x[t] || (x[t] = !0, ot("Warning: A component is changing ".concat(g, " ").concat(r, " to be ").concat(b, ". ") + "".concat(r, "s should not switch from controlled to uncontrolled (or vice versa). ") + "Decide between using controlled or uncontrolled for the lifetime of the component. More info: https://fb.me/react-controlled-components"));
    }
  }
}
var uf = function() {
  var e, t = ce();
  return !((e = t == null ? void 0 : t.navigator) === null || e === void 0) && e.userAgent ? t.navigator.userAgent.indexOf("rv:11.0") > -1 : !1;
};
function ll(e, t) {
  for (var r = w({}, t), n = 0, o = Object.keys(e); n < o.length; n++) {
    var a = o[n];
    r[a] === void 0 && (r[a] = e[a]);
  }
  return r;
}
var cl = ca() ? h.useLayoutEffect : h.useEffect, df = "icons", Ot = Ks.getValue(df, {
  __options: {
    disableWarnings: !1,
    warnOnMissingIcons: !0
  },
  __remapped: {}
}), uo = Qe.getInstance();
uo && uo.onReset && uo.onReset(function() {
  for (var e in Ot)
    Ot.hasOwnProperty(e) && Ot[e].subset && (Ot[e].subset.className = void 0);
});
var ff = function(e) {
  return e.toLowerCase();
};
function hf(e) {
  var t = void 0, r = Ot.__options;
  if (e = e ? ff(e) : "", e = Ot.__remapped[e] || e, e)
    if (t = Ot[e], t) {
      var n = t.subset;
      n && n.fontFace && (n.isRegistered || (Ws(n.fontFace), n.isRegistered = !0), n.className || (n.className = sa(n.style, {
        fontFamily: n.fontFace.fontFamily,
        fontWeight: n.fontFace.fontWeight || "normal",
        fontStyle: n.fontFace.fontStyle || "normal"
      })));
    } else
      !r.disableWarnings && r.warnOnMissingIcons && ot('The icon "'.concat(e, '" was used but not registered. See https://github.com/microsoft/fluentui/wiki/Using-icons for more information.'));
  return t;
}
function vf(e, t, r, n, o) {
  o === void 0 && (o = !1);
  var a = w({
    primaryButtonBorder: "transparent",
    errorText: n ? "#F1707B" : "#a4262c",
    messageText: n ? "#F3F2F1" : "#323130",
    messageLink: n ? "#6CB8F6" : "#005A9E",
    messageLinkHovered: n ? "#82C7FF" : "#004578",
    infoIcon: n ? "#C8C6C4" : "#605e5c",
    errorIcon: n ? "#F1707B" : "#A80000",
    blockingIcon: n ? "#442726" : "#FDE7E9",
    warningIcon: n ? "#C8C6C4" : "#797775",
    severeWarningIcon: n ? "#FCE100" : "#D83B01",
    successIcon: n ? "#92C353" : "#107C10",
    infoBackground: n ? "#323130" : "#f3f2f1",
    errorBackground: n ? "#442726" : "#FDE7E9",
    blockingBackground: n ? "#442726" : "#FDE7E9",
    warningBackground: n ? "#433519" : "#FFF4CE",
    severeWarningBackground: n ? "#4F2A0F" : "#FED9CC",
    successBackground: n ? "#393D1B" : "#DFF6DD",
    // deprecated
    warningHighlight: n ? "#fff100" : "#ffb900",
    successText: n ? "#92c353" : "#107C10"
  }, r), i = ul(e, t, a, n);
  return pf(i, o);
}
function ul(e, t, r, n, o) {
  var a = {}, i = e || {}, s = i.white, l = i.black, c = i.themePrimary, u = i.themeDark, d = i.themeDarker, f = i.themeDarkAlt, p = i.themeLighter, g = i.neutralLight, b = i.neutralLighter, x = i.neutralDark, m = i.neutralQuaternary, y = i.neutralQuaternaryAlt, C = i.neutralPrimary, E = i.neutralSecondary, k = i.neutralSecondaryAlt, S = i.neutralTertiary, _ = i.neutralTertiaryAlt, P = i.neutralLighterAlt, D = i.accent;
  return s && (a.bodyBackground = s, a.bodyFrameBackground = s, a.accentButtonText = s, a.buttonBackground = s, a.primaryButtonText = s, a.primaryButtonTextHovered = s, a.primaryButtonTextPressed = s, a.inputBackground = s, a.inputForegroundChecked = s, a.listBackground = s, a.menuBackground = s, a.cardStandoutBackground = s), l && (a.bodyTextChecked = l, a.buttonTextCheckedHovered = l), c && (a.link = c, a.primaryButtonBackground = c, a.inputBackgroundChecked = c, a.inputIcon = c, a.inputFocusBorderAlt = c, a.menuIcon = c, a.menuHeader = c, a.accentButtonBackground = c), u && (a.primaryButtonBackgroundPressed = u, a.inputBackgroundCheckedHovered = u, a.inputIconHovered = u), d && (a.linkHovered = d), f && (a.primaryButtonBackgroundHovered = f), p && (a.inputPlaceholderBackgroundChecked = p), g && (a.bodyBackgroundChecked = g, a.bodyFrameDivider = g, a.bodyDivider = g, a.variantBorder = g, a.buttonBackgroundCheckedHovered = g, a.buttonBackgroundPressed = g, a.listItemBackgroundChecked = g, a.listHeaderBackgroundPressed = g, a.menuItemBackgroundPressed = g, a.menuItemBackgroundChecked = g), b && (a.bodyBackgroundHovered = b, a.buttonBackgroundHovered = b, a.buttonBackgroundDisabled = b, a.buttonBorderDisabled = b, a.primaryButtonBackgroundDisabled = b, a.disabledBackground = b, a.listItemBackgroundHovered = b, a.listHeaderBackgroundHovered = b, a.menuItemBackgroundHovered = b), m && (a.primaryButtonTextDisabled = m, a.disabledSubtext = m), y && (a.listItemBackgroundCheckedHovered = y), S && (a.disabledBodyText = S, a.variantBorderHovered = (r == null ? void 0 : r.variantBorderHovered) || S, a.buttonTextDisabled = S, a.inputIconDisabled = S, a.disabledText = S), C && (a.bodyText = C, a.actionLink = C, a.buttonText = C, a.inputBorderHovered = C, a.inputText = C, a.listText = C, a.menuItemText = C), P && (a.bodyStandoutBackground = P, a.defaultStateBackground = P), x && (a.actionLinkHovered = x, a.buttonTextHovered = x, a.buttonTextChecked = x, a.buttonTextPressed = x, a.inputTextHovered = x, a.menuItemTextHovered = x), E && (a.bodySubtext = E, a.focusBorder = E, a.inputBorder = E, a.smallInputBorder = E, a.inputPlaceholderText = E), k && (a.buttonBorder = k), _ && (a.disabledBodySubtext = _, a.disabledBorder = _, a.buttonBackgroundChecked = _, a.menuDivider = _), D && (a.accentButtonBackground = D), t != null && t.elevation4 && (a.cardShadow = t.elevation4), !n && (t != null && t.elevation8) ? a.cardShadowHovered = t.elevation8 : a.variantBorderHovered && (a.cardShadowHovered = "0 0 1px " + a.variantBorderHovered), a = w(w({}, a), r), a;
}
function pf(e, t) {
  var r = "";
  return t === !0 && (r = " /* @deprecated */"), e.listTextColor = e.listText + r, e.menuItemBackgroundChecked += r, e.warningHighlight += r, e.warningText = e.messageText + r, e.successText += r, e;
}
function gf(e, t) {
  var r, n, o;
  t === void 0 && (t = {});
  var a = Ci({}, e, t, {
    semanticColors: ul(t.palette, t.effects, t.semanticColors, t.isInverted === void 0 ? e.isInverted : t.isInverted)
  });
  if (!((r = t.palette) === null || r === void 0) && r.themePrimary && !(!((n = t.palette) === null || n === void 0) && n.accent) && (a.palette.accent = t.palette.themePrimary), t.defaultFontStyle)
    for (var i = 0, s = Object.keys(a.fonts); i < s.length; i++) {
      var l = s[i];
      a.fonts[l] = Ci(a.fonts[l], t.defaultFontStyle, (o = t == null ? void 0 : t.fonts) === null || o === void 0 ? void 0 : o[l]);
    }
  return a;
}
var Ei = {
  themeDarker: "#004578",
  themeDark: "#005a9e",
  themeDarkAlt: "#106ebe",
  themePrimary: "#0078d4",
  themeSecondary: "#2b88d8",
  themeTertiary: "#71afe5",
  themeLight: "#c7e0f4",
  themeLighter: "#deecf9",
  themeLighterAlt: "#eff6fc",
  black: "#000000",
  blackTranslucent40: "rgba(0,0,0,.4)",
  neutralDark: "#201f1e",
  neutralPrimary: "#323130",
  neutralPrimaryAlt: "#3b3a39",
  neutralSecondary: "#605e5c",
  neutralSecondaryAlt: "#8a8886",
  neutralTertiary: "#a19f9d",
  neutralTertiaryAlt: "#c8c6c4",
  neutralQuaternary: "#d2d0ce",
  neutralQuaternaryAlt: "#e1dfdd",
  neutralLight: "#edebe9",
  neutralLighter: "#f3f2f1",
  neutralLighterAlt: "#faf9f8",
  accent: "#0078d4",
  white: "#ffffff",
  whiteTranslucent40: "rgba(255,255,255,.4)",
  yellowDark: "#d29200",
  yellow: "#ffb900",
  yellowLight: "#fff100",
  orange: "#d83b01",
  orangeLight: "#ea4300",
  orangeLighter: "#ff8c00",
  redDark: "#a4262c",
  red: "#e81123",
  magentaDark: "#5c005c",
  magenta: "#b4009e",
  magentaLight: "#e3008c",
  purpleDark: "#32145a",
  purple: "#5c2d91",
  purpleLight: "#b4a0ff",
  blueDark: "#002050",
  blueMid: "#00188f",
  blue: "#0078d4",
  blueLight: "#00bcf2",
  tealDark: "#004b50",
  teal: "#008272",
  tealLight: "#00b294",
  greenDark: "#004b1c",
  green: "#107c10",
  greenLight: "#bad80a"
}, Qt;
(function(e) {
  e.depth0 = "0 0 0 0 transparent", e.depth4 = "0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)", e.depth8 = "0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108)", e.depth16 = "0 6.4px 14.4px 0 rgba(0, 0, 0, 0.132), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.108)", e.depth64 = "0 25.6px 57.6px 0 rgba(0, 0, 0, 0.22), 0 4.8px 14.4px 0 rgba(0, 0, 0, 0.18)";
})(Qt || (Qt = {}));
var wi = {
  elevation4: Qt.depth4,
  elevation8: Qt.depth8,
  elevation16: Qt.depth16,
  elevation64: Qt.depth64,
  roundedCorner2: "2px",
  roundedCorner4: "4px",
  roundedCorner6: "6px"
}, mf = {
  s2: "4px",
  s1: "8px",
  m: "16px",
  l1: "20px",
  l2: "32px"
}, ae = "cubic-bezier(.1,.9,.2,1)", Ye = "cubic-bezier(.1,.25,.75,.9)", Gr = "0.167s", Si = "0.267s", J = "0.367s", ki = "0.467s", xe = Ze({
  from: { opacity: 0 },
  to: { opacity: 1 }
}), Ce = Ze({
  from: { opacity: 1 },
  to: { opacity: 0, visibility: "hidden" }
}), bf = wt(-10), yf = wt(-20), _f = wt(-40), xf = wt(-400), Cf = wt(10), Ef = wt(20), wf = wt(40), Sf = wt(400), kf = Fn(10), Tf = Fn(20), Rf = Fn(-10), Nf = Fn(-20), Pf = St(10), If = St(20), Of = St(40), Af = St(400), Df = St(-10), Lf = St(-20), Bf = St(-40), Mf = St(-400), jf = Hn(-10), Ff = Hn(-20), Hf = Hn(10), $f = Hn(20), Vf = Ze({
  from: { transform: "scale3d(.98,.98,1)" },
  to: { transform: "scale3d(1,1,1)" }
}), zf = Ze({
  from: { transform: "scale3d(1,1,1)" },
  to: { transform: "scale3d(.98,.98,1)" }
}), Wf = Ze({
  from: { transform: "scale3d(1.03,1.03,1)" },
  to: { transform: "scale3d(1,1,1)" }
}), Uf = Ze({
  from: { transform: "scale3d(1,1,1)" },
  to: { transform: "scale3d(1.03,1.03,1)" }
}), qf = Ze({
  from: { transform: "rotateZ(0deg)" },
  to: { transform: "rotateZ(90deg)" }
}), Gf = Ze({
  from: { transform: "rotateZ(0deg)" },
  to: { transform: "rotateZ(-90deg)" }
}), Yf = {
  slideRightIn10: H("".concat(xe, ",").concat(bf), J, ae),
  slideRightIn20: H("".concat(xe, ",").concat(yf), J, ae),
  slideRightIn40: H("".concat(xe, ",").concat(_f), J, ae),
  slideRightIn400: H("".concat(xe, ",").concat(xf), J, ae),
  slideLeftIn10: H("".concat(xe, ",").concat(Cf), J, ae),
  slideLeftIn20: H("".concat(xe, ",").concat(Ef), J, ae),
  slideLeftIn40: H("".concat(xe, ",").concat(wf), J, ae),
  slideLeftIn400: H("".concat(xe, ",").concat(Sf), J, ae),
  slideUpIn10: H("".concat(xe, ",").concat(kf), J, ae),
  slideUpIn20: H("".concat(xe, ",").concat(Tf), J, ae),
  slideDownIn10: H("".concat(xe, ",").concat(Rf), J, ae),
  slideDownIn20: H("".concat(xe, ",").concat(Nf), J, ae),
  slideRightOut10: H("".concat(Ce, ",").concat(Pf), J, ae),
  slideRightOut20: H("".concat(Ce, ",").concat(If), J, ae),
  slideRightOut40: H("".concat(Ce, ",").concat(Of), J, ae),
  slideRightOut400: H("".concat(Ce, ",").concat(Af), J, ae),
  slideLeftOut10: H("".concat(Ce, ",").concat(Df), J, ae),
  slideLeftOut20: H("".concat(Ce, ",").concat(Lf), J, ae),
  slideLeftOut40: H("".concat(Ce, ",").concat(Bf), J, ae),
  slideLeftOut400: H("".concat(Ce, ",").concat(Mf), J, ae),
  slideUpOut10: H("".concat(Ce, ",").concat(jf), J, ae),
  slideUpOut20: H("".concat(Ce, ",").concat(Ff), J, ae),
  slideDownOut10: H("".concat(Ce, ",").concat(Hf), J, ae),
  slideDownOut20: H("".concat(Ce, ",").concat($f), J, ae),
  scaleUpIn100: H("".concat(xe, ",").concat(Vf), J, ae),
  scaleDownIn100: H("".concat(xe, ",").concat(Wf), J, ae),
  scaleUpOut103: H("".concat(Ce, ",").concat(Uf), Gr, Ye),
  scaleDownOut98: H("".concat(Ce, ",").concat(zf), Gr, Ye),
  fadeIn100: H(xe, Gr, Ye),
  fadeIn200: H(xe, Si, Ye),
  fadeIn400: H(xe, J, Ye),
  fadeIn500: H(xe, ki, Ye),
  fadeOut100: H(Ce, Gr, Ye),
  fadeOut200: H(Ce, Si, Ye),
  fadeOut400: H(Ce, J, Ye),
  fadeOut500: H(Ce, ki, Ye),
  rotate90deg: H(qf, "0.1s", Ye),
  rotateN90deg: H(Gf, "0.1s", Ye)
  // expandCollapse 100/200/400, delay 100/200
};
function H(e, t, r) {
  return {
    animationName: e,
    animationDuration: t,
    animationTimingFunction: r,
    animationFillMode: "both"
  };
}
function wt(e) {
  return Ze({
    from: { transform: "translate3d(".concat(e, "px,0,0)"), pointerEvents: "none" },
    to: { transform: "translate3d(0,0,0)", pointerEvents: "auto" }
  });
}
function Fn(e) {
  return Ze({
    from: { transform: "translate3d(0,".concat(e, "px,0)"), pointerEvents: "none" },
    to: { transform: "translate3d(0,0,0)", pointerEvents: "auto" }
  });
}
function St(e) {
  return Ze({
    from: { transform: "translate3d(0,0,0)" },
    to: { transform: "translate3d(".concat(e, "px,0,0)") }
  });
}
function Hn(e) {
  return Ze({
    from: { transform: "translate3d(0,0,0)" },
    to: { transform: "translate3d(0,".concat(e, "px,0)") }
  });
}
var ue;
(function(e) {
  e.Arabic = "Segoe UI Web (Arabic)", e.Cyrillic = "Segoe UI Web (Cyrillic)", e.EastEuropean = "Segoe UI Web (East European)", e.Greek = "Segoe UI Web (Greek)", e.Hebrew = "Segoe UI Web (Hebrew)", e.Thai = "Leelawadee UI Web", e.Vietnamese = "Segoe UI Web (Vietnamese)", e.WestEuropean = "Segoe UI Web (West European)", e.Selawik = "Selawik Web", e.Armenian = "Segoe UI Web (Armenian)", e.Georgian = "Segoe UI Web (Georgian)";
})(ue || (ue = {}));
var X;
(function(e) {
  e.Arabic = "'".concat(ue.Arabic, "'"), e.ChineseSimplified = "'Microsoft Yahei UI', Verdana, Simsun", e.ChineseTraditional = "'Microsoft Jhenghei UI', Pmingliu", e.Cyrillic = "'".concat(ue.Cyrillic, "'"), e.EastEuropean = "'".concat(ue.EastEuropean, "'"), e.Greek = "'".concat(ue.Greek, "'"), e.Hebrew = "'".concat(ue.Hebrew, "'"), e.Hindi = "'Nirmala UI'", e.Japanese = "'Yu Gothic UI', 'Meiryo UI', Meiryo, 'MS Pgothic', Osaka", e.Korean = "'Malgun Gothic', Gulim", e.Selawik = "'".concat(ue.Selawik, "'"), e.Thai = "'Leelawadee UI Web', 'Kmer UI'", e.Vietnamese = "'".concat(ue.Vietnamese, "'"), e.WestEuropean = "'".concat(ue.WestEuropean, "'"), e.Armenian = "'".concat(ue.Armenian, "'"), e.Georgian = "'".concat(ue.Georgian, "'");
})(X || (X = {}));
var Oe;
(function(e) {
  e.size10 = "10px", e.size12 = "12px", e.size14 = "14px", e.size16 = "16px", e.size18 = "18px", e.size20 = "20px", e.size24 = "24px", e.size28 = "28px", e.size32 = "32px", e.size42 = "42px", e.size68 = "68px", e.mini = "10px", e.xSmall = "10px", e.small = "12px", e.smallPlus = "12px", e.medium = "14px", e.mediumPlus = "16px", e.icon = "16px", e.large = "18px", e.xLarge = "20px", e.xLargePlus = "24px", e.xxLarge = "28px", e.xxLargePlus = "32px", e.superLarge = "42px", e.mega = "68px";
})(Oe || (Oe = {}));
var le;
(function(e) {
  e.light = 100, e.semilight = 300, e.regular = 400, e.semibold = 600, e.bold = 700;
})(le || (le = {}));
var gn;
(function(e) {
  e.xSmall = "10px", e.small = "12px", e.medium = "16px", e.large = "20px";
})(gn || (gn = {}));
var Kf = "'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif", Xf = "'Segoe UI', '".concat(ue.WestEuropean, "'"), fo = {
  ar: X.Arabic,
  bg: X.Cyrillic,
  cs: X.EastEuropean,
  el: X.Greek,
  et: X.EastEuropean,
  he: X.Hebrew,
  hi: X.Hindi,
  hr: X.EastEuropean,
  hu: X.EastEuropean,
  ja: X.Japanese,
  kk: X.EastEuropean,
  ko: X.Korean,
  lt: X.EastEuropean,
  lv: X.EastEuropean,
  pl: X.EastEuropean,
  ru: X.Cyrillic,
  sk: X.EastEuropean,
  "sr-latn": X.EastEuropean,
  th: X.Thai,
  tr: X.EastEuropean,
  uk: X.Cyrillic,
  vi: X.Vietnamese,
  "zh-hans": X.ChineseSimplified,
  "zh-hant": X.ChineseTraditional,
  hy: X.Armenian,
  ka: X.Georgian
};
function Qf(e) {
  return "".concat(e, ", ").concat(Kf);
}
function Jf(e) {
  for (var t in fo)
    if (fo.hasOwnProperty(t) && e && t.indexOf(e) === 0)
      return fo[t];
  return Xf;
}
function $e(e, t, r) {
  return {
    fontFamily: r,
    MozOsxFontSmoothing: "grayscale",
    WebkitFontSmoothing: "antialiased",
    fontSize: e,
    fontWeight: t
  };
}
function Zf(e) {
  var t = Jf(e), r = Qf(t), n = {
    tiny: $e(Oe.mini, le.regular, r),
    xSmall: $e(Oe.xSmall, le.regular, r),
    small: $e(Oe.small, le.regular, r),
    smallPlus: $e(Oe.smallPlus, le.regular, r),
    medium: $e(Oe.medium, le.regular, r),
    mediumPlus: $e(Oe.mediumPlus, le.regular, r),
    large: $e(Oe.large, le.regular, r),
    xLarge: $e(Oe.xLarge, le.semibold, r),
    xLargePlus: $e(Oe.xLargePlus, le.semibold, r),
    xxLarge: $e(Oe.xxLarge, le.semibold, r),
    xxLargePlus: $e(Oe.xxLargePlus, le.semibold, r),
    superLarge: $e(Oe.superLarge, le.semibold, r),
    mega: $e(Oe.mega, le.semibold, r)
  };
  return n;
}
var eh = "https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets", th = Zf(tf());
function Pt(e, t, r, n) {
  e = "'".concat(e, "'");
  var o = n !== void 0 ? "local('".concat(n, "'),") : "";
  Ws({
    fontFamily: e,
    src: o + "url('".concat(t, ".woff2') format('woff2'),") + "url('".concat(t, ".woff') format('woff')"),
    fontWeight: r,
    fontStyle: "normal",
    fontDisplay: "swap"
  });
}
function rt(e, t, r, n, o) {
  n === void 0 && (n = "segoeui");
  var a = "".concat(e, "/").concat(r, "/").concat(n);
  Pt(t, a + "-light", le.light, o && o + " Light"), Pt(t, a + "-semilight", le.semilight, o && o + " SemiLight"), Pt(t, a + "-regular", le.regular, o), Pt(t, a + "-semibold", le.semibold, o && o + " SemiBold"), Pt(t, a + "-bold", le.bold, o && o + " Bold");
}
function rh(e) {
  if (e) {
    var t = "".concat(e, "/fonts");
    rt(t, ue.Thai, "leelawadeeui-thai", "leelawadeeui"), rt(t, ue.Arabic, "segoeui-arabic"), rt(t, ue.Cyrillic, "segoeui-cyrillic"), rt(t, ue.EastEuropean, "segoeui-easteuropean"), rt(t, ue.Greek, "segoeui-greek"), rt(t, ue.Hebrew, "segoeui-hebrew"), rt(t, ue.Vietnamese, "segoeui-vietnamese"), rt(t, ue.WestEuropean, "segoeui-westeuropean", "segoeui", "Segoe UI"), rt(t, X.Selawik, "selawik", "selawik"), rt(t, ue.Armenian, "segoeui-armenian"), rt(t, ue.Georgian, "segoeui-georgian"), Pt("Leelawadee UI Web", "".concat(t, "/leelawadeeui-thai/leelawadeeui-semilight"), le.light), Pt("Leelawadee UI Web", "".concat(t, "/leelawadeeui-thai/leelawadeeui-bold"), le.semibold);
  }
}
function nh() {
  var e, t, r = (e = ce()) === null || e === void 0 ? void 0 : e.FabricConfig;
  return (t = r == null ? void 0 : r.fontBaseUrl) !== null && t !== void 0 ? t : eh;
}
rh(nh());
function $n(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = !1);
  var r = !!e.isInverted, n = {
    palette: Ei,
    effects: wi,
    fonts: th,
    spacing: mf,
    isInverted: r,
    disableGlobalClassNames: !1,
    semanticColors: vf(Ei, wi, void 0, r, t),
    rtl: void 0
  };
  return gf(n, e);
}
var ne = "@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)";
function At() {
  return {
    forcedColorAdjust: "none",
    MsHighContrastAdjust: "none"
  };
}
var kr;
(function(e) {
  e.Nav = 1, e.ScrollablePane = 1, e.FocusStyle = 1, e.Coachmark = 1e3, e.Layer = 1e6, e.KeytipLayer = 1000001;
})(kr || (kr = {}));
function dl(e, t, r, n, o, a, i, s) {
  return typeof t == "number" || !t ? Ti(e, {
    inset: t,
    position: r,
    highContrastStyle: n,
    borderColor: o,
    outlineColor: a,
    isFocusedOnly: i,
    borderRadius: s
  }) : Ti(e, t);
}
function Ti(e, t) {
  var r, n;
  t === void 0 && (t = {});
  var o = t.borderRadius, a = t.inset, i = a === void 0 ? 0 : a, s = t.width, l = s === void 0 ? 1 : s, c = t.position, u = c === void 0 ? "relative" : c, d = t.highContrastStyle, f = t.borderColor, p = f === void 0 ? e.palette.white : f, g = t.outlineColor, b = g === void 0 ? e.palette.neutralSecondary : g, x = t.isFocusedOnly, m = x === void 0 ? !0 : x, y = t.pointerEvents;
  return {
    // Clear browser-specific focus styles and use 'transparent' as placeholder for focus style.
    outline: "transparent",
    // Requirement because pseudo-element is absolutely positioned.
    position: u,
    selectors: (r = {
      // Clear the focus border in Firefox.
      // Reference: http://stackoverflow.com/a/199319/1436671
      "::-moz-focus-inner": {
        border: "0"
      }
    }, // When the element that uses this mixin is in a :focus state, add a pseudo-element to
    // create a border.
    r[".".concat(Ft, " &").concat(m ? ":focus" : "", ":after")] = {
      content: '""',
      position: "absolute",
      pointerEvents: y,
      left: i + 1,
      top: i + 1,
      bottom: i + 1,
      right: i + 1,
      border: "".concat(l, "px solid ").concat(p),
      outline: "".concat(l, "px solid ").concat(b),
      zIndex: kr.FocusStyle,
      borderRadius: o,
      selectors: (n = {}, n[ne] = d, n)
    }, r)
  };
}
function oh() {
  return {
    selectors: {
      "&::-moz-focus-inner": {
        // Clear the focus border in Firefox. Reference: http://stackoverflow.com/a/199319/1436671
        border: 0
      },
      "&": {
        // Clear browser specific focus styles and use transparent as placeholder for focus style
        outline: "transparent"
      }
    }
  };
}
var Ri = function(e, t, r, n) {
  var o, a, i;
  r === void 0 && (r = "border"), n === void 0 && (n = -1);
  var s = r === "borderBottom";
  return {
    borderColor: e,
    selectors: {
      ":after": (o = {
        pointerEvents: "none",
        content: "''",
        position: "absolute",
        left: s ? 0 : n,
        top: n,
        bottom: n,
        right: s ? 0 : n
      }, o[r] = "2px solid ".concat(e), o.borderRadius = t, o.width = r === "borderBottom" ? "100%" : void 0, o.selectors = (a = {}, a[ne] = (i = {}, i[r === "border" ? "borderColor" : "borderBottomColor"] = "Highlight", i), a), o)
    }
  };
}, fl = {
  position: "absolute",
  width: 1,
  height: 1,
  margin: -1,
  padding: 0,
  border: 0,
  overflow: "hidden",
  whiteSpace: "nowrap"
}, ah = Mn(function(e, t) {
  var r = Qe.getInstance();
  return t ? Object.keys(e).reduce(function(n, o) {
    return n[o] = r.getClassName(e[o]), n;
  }, {}) : e;
});
function hr(e, t, r) {
  return ah(e, r !== void 0 ? r : t.disableGlobalClassNames);
}
var Jt = function() {
  return Jt = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Jt.apply(this, arguments);
}, yr = typeof window == "undefined" ? global : window, Ni = yr && yr.CSPSettings && yr.CSPSettings.nonce, Ve = ih();
function ih() {
  var e = yr.__themeState__ || {
    theme: void 0,
    lastStyleElement: void 0,
    registeredStyles: []
  };
  return e.runState || (e = Jt(Jt({}, e), { perf: {
    count: 0,
    duration: 0
  }, runState: {
    flushTimer: 0,
    mode: 0,
    buffer: []
  } })), e.registeredThemableStyles || (e = Jt(Jt({}, e), { registeredThemableStyles: [] })), yr.__themeState__ = e, e;
}
function sh(e, t) {
  Ve.loadStyles ? Ve.loadStyles(hl(e).styleString, e) : dh(e);
}
function lh(e) {
  Ve.theme = e, uh();
}
function ch(e) {
  e === void 0 && (e = 3), (e === 3 || e === 2) && (Pi(Ve.registeredStyles), Ve.registeredStyles = []), (e === 3 || e === 1) && (Pi(Ve.registeredThemableStyles), Ve.registeredThemableStyles = []);
}
function Pi(e) {
  e.forEach(function(t) {
    var r = t && t.styleElement;
    r && r.parentElement && r.parentElement.removeChild(r);
  });
}
function uh() {
  if (Ve.theme) {
    for (var e = [], t = 0, r = Ve.registeredThemableStyles; t < r.length; t++) {
      var n = r[t];
      e.push(n.themableStyle);
    }
    e.length > 0 && (ch(
      1
      /* ClearStyleOptions.onlyThemable */
    ), sh([].concat.apply([], e)));
  }
}
function hl(e) {
  var t = Ve.theme, r = !1, n = (e || []).map(function(o) {
    var a = o.theme;
    if (a) {
      r = !0;
      var i = t ? t[a] : void 0, s = o.defaultValue || "inherit";
      return t && !i && console && !(a in t) && typeof DEBUG != "undefined" && DEBUG && console.warn('Theming value not provided for "'.concat(a, '". Falling back to "').concat(s, '".')), i || s;
    } else
      return o.rawString;
  });
  return {
    styleString: n.join(""),
    themable: r
  };
}
function dh(e) {
  if (typeof document != "undefined") {
    var t = document.getElementsByTagName("head")[0], r = document.createElement("style"), n = hl(e), o = n.styleString, a = n.themable;
    r.setAttribute("data-load-themed-styles", "true"), Ni && r.setAttribute("nonce", Ni), r.appendChild(document.createTextNode(o)), Ve.perf.count++, t.appendChild(r);
    var i = document.createEvent("HTMLEvents");
    i.initEvent(
      "styleinsert",
      !0,
      !1
      /* cancelable */
    ), i.args = {
      newStyle: r
    }, document.dispatchEvent(i);
    var s = {
      styleElement: r,
      themableStyle: e
    };
    a ? Ve.registeredThemableStyles.push(s) : Ve.registeredStyles.push(s);
  }
}
var it = $n({}), fh = [], $o = "theme";
function vl() {
  var e, t, r, n = ce();
  !((t = n == null ? void 0 : n.FabricConfig) === null || t === void 0) && t.legacyTheme ? hh(n.FabricConfig.legacyTheme) : Et.getSettings([$o]).theme || (!((r = n == null ? void 0 : n.FabricConfig) === null || r === void 0) && r.theme && (it = $n(n.FabricConfig.theme)), Et.applySettings((e = {}, e[$o] = it, e)));
}
vl();
function hh(e, t) {
  var r;
  return t === void 0 && (t = !1), it = $n(e, t), lh(w(w(w(w({}, it.palette), it.semanticColors), it.effects), vh(it))), Et.applySettings((r = {}, r[$o] = it, r)), fh.forEach(function(n) {
    try {
      n(it);
    } catch (o) {
    }
  }), it;
}
function vh(e) {
  for (var t = {}, r = 0, n = Object.keys(e.fonts); r < n.length; r++)
    for (var o = n[r], a = e.fonts[o], i = 0, s = Object.keys(a); i < s.length; i++) {
      var l = s[i], c = o + l.charAt(0).toUpperCase() + l.slice(1), u = a[l];
      l === "fontSize" && typeof u == "number" && (u = u + "px"), t[c] = u;
    }
  return t;
}
var ho = {
  boxShadow: "none",
  margin: 0,
  padding: 0,
  boxSizing: "border-box"
};
function Ii(e) {
  return {
    selectors: {
      "::placeholder": e,
      ":-ms-input-placeholder": e,
      "::-ms-input-placeholder": e
      // Edge
    }
  };
}
var Dt = Qu(Yf);
Ds("@fluentui/style-utilities", "8.10.7");
vl();
var Ee = {
  /**
   * Appear above the target element, with the left edges of the callout and target aligning.
   */
  topLeftEdge: 0,
  /**
   * Appear above the target element, with the centers of the callout and target aligning.
   */
  topCenter: 1,
  /**
   * Appear above the target element, with the right edges of the callout and target aligning.
   */
  topRightEdge: 2,
  /**
   * Appear above the target element, aligning with the target element such that the callout tends toward
   * the center of the screen.
   */
  topAutoEdge: 3,
  /**
   * Appear below the target element, with the left edges of the callout and target aligning.
   */
  bottomLeftEdge: 4,
  /**
   * Appear below the target element, with the centers of the callout and target aligning.
   */
  bottomCenter: 5,
  /**
   * Appear below the target element, with the right edges of the callout and target aligning.
   */
  bottomRightEdge: 6,
  /**
   * Appear below the target element, aligning with the target element such that the callout tends toward
   * the center of the screen.
   */
  bottomAutoEdge: 7,
  /**
   * Appear to the left of the target element, with the top edges of the callout and target aligning.
   */
  leftTopEdge: 8,
  /**
   * Appear to the left of the target element, with the centers of the callout and target aligning.
   */
  leftCenter: 9,
  /**
   * Appear to the left of the target element, with the bottom edges of the callout and target aligning.
   */
  leftBottomEdge: 10,
  /**
   * Appear to the right of the target element, with the top edges of the callout and target aligning.
   */
  rightTopEdge: 11,
  /**
   * Appear to the right of the target element, with the centers of the callout and target aligning.
   */
  rightCenter: 12,
  /**
   * Appear to the right of the target element, with the bottom edges of the callout and target aligning.
   */
  rightBottomEdge: 13
}, A;
(function(e) {
  e[e.top = 1] = "top", e[e.bottom = -1] = "bottom", e[e.left = 2] = "left", e[e.right = -2] = "right";
})(A || (A = {}));
var Oi;
(function(e) {
  e[e.top = 0] = "top", e[e.bottom = 1] = "bottom", e[e.start = 2] = "start", e[e.end = 3] = "end";
})(Oi || (Oi = {}));
var Te;
function Le(e, t, r) {
  return {
    targetEdge: e,
    alignmentEdge: t,
    isAuto: r
  };
}
var Ai = (Te = {}, Te[Ee.topLeftEdge] = Le(A.top, A.left), Te[Ee.topCenter] = Le(A.top), Te[Ee.topRightEdge] = Le(A.top, A.right), Te[Ee.topAutoEdge] = Le(A.top, void 0, !0), Te[Ee.bottomLeftEdge] = Le(A.bottom, A.left), Te[Ee.bottomCenter] = Le(A.bottom), Te[Ee.bottomRightEdge] = Le(A.bottom, A.right), Te[Ee.bottomAutoEdge] = Le(A.bottom, void 0, !0), Te[Ee.leftTopEdge] = Le(A.left, A.top), Te[Ee.leftCenter] = Le(A.left), Te[Ee.leftBottomEdge] = Le(A.left, A.bottom), Te[Ee.rightTopEdge] = Le(A.right, A.top), Te[Ee.rightCenter] = Le(A.right), Te[Ee.rightBottomEdge] = Le(A.right, A.bottom), Te);
function pa(e, t) {
  return !(e.top < t.top || e.bottom > t.bottom || e.left < t.left || e.right > t.right);
}
function mn(e, t) {
  var r = [];
  return e.top < t.top && r.push(A.top), e.bottom > t.bottom && r.push(A.bottom), e.left < t.left && r.push(A.left), e.right > t.right && r.push(A.right), r;
}
function Re(e, t) {
  return e[A[t]];
}
function Di(e, t, r) {
  return e[A[t]] = r, e;
}
function Tr(e, t) {
  var r = vr(t);
  return (Re(e, r.positiveEdge) + Re(e, r.negativeEdge)) / 2;
}
function Vn(e, t) {
  return e > 0 ? t : t * -1;
}
function Vo(e, t) {
  return Vn(e, Re(t, e));
}
function ct(e, t, r) {
  var n = Re(e, r) - Re(t, r);
  return Vn(r, n);
}
function lr(e, t, r, n) {
  n === void 0 && (n = !0);
  var o = Re(e, t) - r, a = Di(e, t, r);
  return n && (a = Di(e, t * -1, Re(e, t * -1) - o)), a;
}
function Rr(e, t, r, n) {
  return n === void 0 && (n = 0), lr(e, r, Re(t, r) + Vn(r, n));
}
function ph(e, t, r, n) {
  n === void 0 && (n = 0);
  var o = r * -1, a = Vn(o, n);
  return lr(e, r * -1, Re(t, r) + a);
}
function bn(e, t, r) {
  var n = Vo(r, e);
  return n > Vo(r, t);
}
function gh(e, t) {
  for (var r = mn(e, t), n = 0, o = 0, a = r; o < a.length; o++) {
    var i = a[o];
    n += Math.pow(ct(e, t, i), 2);
  }
  return n;
}
function mh(e, t, r, n) {
  return n === void 0 && (n = 200), r !== A.bottom && r !== A.top ? !1 : ct(e, t, r) >= n;
}
function bh(e, t, r, n, o, a, i) {
  o === void 0 && (o = !1), i === void 0 && (i = 0);
  var s = [
    A.left,
    A.right,
    A.bottom,
    A.top
  ];
  Sr() && (s[0] *= -1, s[1] *= -1);
  for (var l = e, c = n.targetEdge, u = n.alignmentEdge, d, f = c, p = u, g = 0; g < 4; g++) {
    if (bn(l, r, c))
      return {
        elementRectangle: l,
        targetEdge: c,
        alignmentEdge: u
      };
    if (o && mh(t, r, c, a)) {
      switch (c) {
        case A.bottom:
          l.bottom = r.bottom;
          break;
        case A.top:
          l.top = r.top;
          break;
      }
      return {
        elementRectangle: l,
        targetEdge: c,
        alignmentEdge: u,
        forcedInBounds: !0
      };
    } else {
      var b = gh(l, r);
      (!d || b < d) && (d = b, f = c, p = u), s.splice(s.indexOf(c), 1), s.length > 0 && (s.indexOf(c * -1) > -1 ? c = c * -1 : (u = c, c = s.slice(-1)[0]), l = yn(e, t, { targetEdge: c, alignmentEdge: u }, i));
    }
  }
  return l = yn(e, t, { targetEdge: f, alignmentEdge: p }, i), {
    elementRectangle: l,
    targetEdge: f,
    alignmentEdge: p
  };
}
function yh(e, t, r, n) {
  var o = e.alignmentEdge, a = e.targetEdge, i = e.elementRectangle, s = o * -1, l = yn(i, t, { targetEdge: a, alignmentEdge: s }, r, n);
  return {
    elementRectangle: l,
    targetEdge: a,
    alignmentEdge: s
  };
}
function _h(e, t, r, n, o, a, i, s, l) {
  o === void 0 && (o = !1), i === void 0 && (i = 0);
  var c = n.alignmentEdge, u = n.alignTargetEdge, d = {
    elementRectangle: e,
    targetEdge: n.targetEdge,
    alignmentEdge: c
  };
  !s && !l && (d = bh(e, t, r, n, o, a, i));
  var f = mn(d.elementRectangle, r), p = s ? -d.targetEdge : void 0;
  if (f.length > 0)
    if (u)
      if (d.alignmentEdge && f.indexOf(d.alignmentEdge * -1) > -1) {
        var g = yh(d, t, i, l);
        if (pa(g.elementRectangle, r))
          return g;
        d = vo(mn(g.elementRectangle, r), d, r, p);
      } else
        d = vo(f, d, r, p);
    else
      d = vo(f, d, r, p);
  return d;
}
function vo(e, t, r, n) {
  for (var o = 0, a = e; o < a.length; o++) {
    var i = a[o], s = void 0;
    if (n && n === i * -1)
      s = lr(t.elementRectangle, i, Re(r, i), !1), t.forcedInBounds = !0;
    else {
      s = Rr(t.elementRectangle, r, i);
      var l = bn(s, r, i * -1);
      l || (s = lr(s, i * -1, Re(r, i * -1), !1), t.forcedInBounds = !0);
    }
    t.elementRectangle = s;
  }
  return t;
}
function pl(e, t, r) {
  var n = vr(t).positiveEdge, o = Tr(e, t), a = o - Re(e, n);
  return lr(e, n, r - a);
}
function yn(e, t, r, n, o) {
  n === void 0 && (n = 0);
  var a = new Ke(e.left, e.right, e.top, e.bottom), i = r.alignmentEdge, s = r.targetEdge, l = o ? s : s * -1;
  if (a = o ? Rr(a, t, s, n) : ph(a, t, s, n), i)
    a = Rr(a, t, i);
  else {
    var c = Tr(t, s);
    a = pl(a, l, c);
  }
  return a;
}
function vr(e) {
  return e === A.top || e === A.bottom ? {
    positiveEdge: A.left,
    negativeEdge: A.right
  } : {
    positiveEdge: A.top,
    negativeEdge: A.bottom
  };
}
function gl(e, t, r) {
  return r && Math.abs(ct(e, r, t)) > Math.abs(ct(e, r, t * -1)) ? t * -1 : t;
}
function xh(e, t, r) {
  return r !== void 0 && Re(e, t) === Re(r, t);
}
function Ch(e, t, r, n, o, a, i, s) {
  var l = {}, c = zn(t), u = a ? r : r * -1, d = o || vr(r).positiveEdge;
  return (!i || xh(e, Mh(d), n)) && (d = gl(e, d, n)), l[A[u]] = ct(e, c, u), l[A[d]] = ct(e, c, d), s && (l[A[u * -1]] = ct(e, c, u * -1), l[A[d * -1]] = ct(e, c, d * -1)), l;
}
function Eh(e) {
  return Math.sqrt(e * e * 2);
}
function wh(e, t, r) {
  if (e === void 0 && (e = Ee.bottomAutoEdge), r)
    return {
      alignmentEdge: r.alignmentEdge,
      isAuto: r.isAuto,
      targetEdge: r.targetEdge
    };
  var n = w({}, Ai[e]);
  return Sr() ? (n.alignmentEdge && n.alignmentEdge % 2 === 0 && (n.alignmentEdge = n.alignmentEdge * -1), t !== void 0 ? Ai[t] : n) : n;
}
function Sh(e, t, r, n, o) {
  return e.isAuto && (e.alignmentEdge = ml(e.targetEdge, t, r)), e.alignTargetEdge = o, e;
}
function ml(e, t, r) {
  var n = Tr(t, e), o = Tr(r, e), a = vr(e), i = a.positiveEdge, s = a.negativeEdge;
  return n <= o ? i : s;
}
function kh(e, t, r, n, o, a, i, s, l) {
  a === void 0 && (a = !1);
  var c = yn(e, t, n, o, l);
  return pa(c, r) ? {
    elementRectangle: c,
    targetEdge: n.targetEdge,
    alignmentEdge: n.alignmentEdge
  } : _h(c, t, r, n, a, i, o, s, l);
}
function Th(e, t, r) {
  var n = e.targetEdge * -1, o = new Ke(0, e.elementRectangle.width, 0, e.elementRectangle.height), a = {}, i = gl(e.elementRectangle, e.alignmentEdge ? e.alignmentEdge : vr(n).positiveEdge, r), s = ct(e.elementRectangle, e.targetRectangle, n), l = s > Math.abs(Re(t, n));
  return a[A[n]] = Re(t, n), a[A[i]] = ct(t, o, i), {
    elementPosition: w({}, a),
    closestEdge: ml(e.targetEdge, t, o),
    targetEdge: n,
    hideBeak: !l
  };
}
function Rh(e, t) {
  var r = t.targetRectangle, n = vr(t.targetEdge), o = n.positiveEdge, a = n.negativeEdge, i = Tr(r, t.targetEdge), s = new Ke(e / 2, t.elementRectangle.width - e / 2, e / 2, t.elementRectangle.height - e / 2), l = new Ke(0, e, 0, e);
  return l = lr(l, t.targetEdge * -1, -e / 2), l = pl(l, t.targetEdge * -1, i - Vo(o, t.elementRectangle)), bn(l, s, o) ? bn(l, s, a) || (l = Rr(l, s, a)) : l = Rr(l, s, o), l;
}
function zn(e) {
  var t = e.getBoundingClientRect();
  return new Ke(t.left, t.right, t.top, t.bottom);
}
function Nh(e) {
  return new Ke(e.left, e.right, e.top, e.bottom);
}
function Ph(e, t) {
  var r;
  if (t) {
    if (t.preventDefault) {
      var n = t;
      r = new Ke(n.clientX, n.clientX, n.clientY, n.clientY);
    } else if (t.getBoundingClientRect)
      r = zn(t);
    else {
      var o = t, a = o.left || o.x, i = o.top || o.y, s = o.right || a, l = o.bottom || i;
      r = new Ke(a, s, i, l);
    }
    if (!pa(r, e))
      for (var c = mn(r, e), u = 0, d = c; u < d.length; u++) {
        var f = d[u];
        r[A[f]] = e[A[f]];
      }
  } else
    r = new Ke(0, 0, 0, 0);
  return r;
}
function Ih(e, t, r, n, o, a) {
  o === void 0 && (o = !1);
  var i = e.gapSpace ? e.gapSpace : 0, s = Ph(r, e.target), l = Sh(wh(e.directionalHint, e.directionalHintForRTL, n), s, r, e.coverTarget, e.alignTargetEdge), c = kh(zn(t), s, r, l, i, o, a, e.directionalHintFixed, e.coverTarget);
  return w(w({}, c), { targetRectangle: s });
}
function Oh(e, t, r, n, o) {
  var a = Ch(e.elementRectangle, t, e.targetEdge, r, e.alignmentEdge, n, o, e.forcedInBounds);
  return {
    elementPosition: a,
    targetEdge: e.targetEdge,
    alignmentEdge: e.alignmentEdge
  };
}
function bl(e, t, r) {
  return t === void 0 && (t = 0), r === void 0 && (r = 0), Eh(e ? t : 0) / 2 + r;
}
function yl(e, t, r, n, o, a, i, s) {
  o === void 0 && (o = !1);
  var l = s != null ? s : ce(), c = e.isBeakVisible && e.beakWidth || 0, u = bl(e.isBeakVisible, e.beakWidth, e.gapSpace), d = e;
  d.gapSpace = u;
  var f = e.bounds ? Nh(e.bounds) : new Ke(0, l.innerWidth - md(), 0, l.innerHeight), p = Ih(d, r, f, n, o, a), g = Rh(c, p), b = Th(p, g, f);
  return w(w({}, Oh(p, t, f, e.coverTarget, i)), { beakPosition: b });
}
function Ah(e, t, r, n, o) {
  var a = o != null ? o : ce();
  return yl(e, t, r, n, !1, void 0, !0, a);
}
function Dh(e) {
  var t, r, n, o, a = e, i = e, s = e, l, c = (t = s.left) !== null && t !== void 0 ? t : s.x, u = (r = s.top) !== null && r !== void 0 ? r : s.y, d = (n = s.right) !== null && n !== void 0 ? n : c, f = (o = s.bottom) !== null && o !== void 0 ? o : u;
  return a.stopPropagation ? l = new Ke(a.clientX, a.clientX, a.clientY, a.clientY) : c !== void 0 && u !== void 0 ? l = new Ke(c, d, u, f) : l = zn(i), l;
}
function Lh(e, t, r, n, o, a, i) {
  return yl(e, t, r, n, o, a, void 0, i);
}
function Bh(e, t, r, n, o) {
  return Ah(e, t, r, n, o);
}
function Mh(e) {
  return e * -1;
}
function jh(e, t) {
  var r = void 0;
  if (t.getWindowSegments && (r = t.getWindowSegments()), r === void 0 || r.length <= 1)
    return {
      top: 0,
      left: 0,
      right: t.innerWidth,
      bottom: t.innerHeight,
      width: t.innerWidth,
      height: t.innerHeight
    };
  var n = 0, o = 0;
  if (e !== null && e.getBoundingClientRect) {
    var a = e.getBoundingClientRect();
    n = (a.left + a.right) / 2, o = (a.top + a.bottom) / 2;
  } else
    e !== null && (n = e.left || e.x, o = e.top || e.y);
  for (var i = { top: 0, left: 0, right: 0, bottom: 0, width: 0, height: 0 }, s = 0, l = r; s < l.length; s++) {
    var c = l[s];
    n && c.left <= n && c.right >= n && o && c.top <= o && c.bottom >= o && (i = {
      top: c.top,
      left: c.left,
      right: c.right,
      bottom: c.bottom,
      width: c.width,
      height: c.height
    });
  }
  return i;
}
function Fh(e, t) {
  return jh(e, t);
}
function Hh(e, t, r) {
  return bl(e, t, r);
}
function $h(e) {
  return Dh(e);
}
function Or() {
  var e = h.useRef();
  return e.current || (e.current = new ua()), h.useEffect(function() {
    return function() {
      var t;
      (t = e.current) === null || t === void 0 || t.dispose(), e.current = void 0;
    };
  }, []), e.current;
}
function _n(e) {
  var t = h.useRef();
  return t.current === void 0 && (t.current = {
    value: typeof e == "function" ? e() : e
  }), t.current.value;
}
function Vh(e, t, r) {
  var n = h.useState(t), o = n[0], a = n[1], i = _n(e !== void 0), s = i ? e : o, l = h.useRef(s), c = h.useRef(r);
  h.useEffect(function() {
    l.current = s, c.current = r;
  });
  var u = _n(function() {
    return function(d, f) {
      var p = typeof d == "function" ? d(l.current) : d;
      c.current && c.current(f, p), i || a(p);
    };
  });
  return [s, u];
}
function _l(e, t) {
  var r = h.useRef(t);
  return r.current || (r.current = Ct(e)), r.current;
}
function Ht() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = h.useCallback(function(n) {
    r.current = n;
    for (var o = 0, a = e; o < a.length; o++) {
      var i = a[o];
      typeof i == "function" ? i(n) : i && (i.current = n);
    }
  }, dn([], e, !0));
  return r;
}
function xn(e, t, r, n) {
  var o = h.useRef(r);
  o.current = r, h.useEffect(function() {
    var a = e && "current" in e ? e.current : e;
    if (!(!a || !a.addEventListener)) {
      var i = lt(a, t, function(s) {
        return o.current(s);
      }, n);
      return i;
    }
  }, [e, t, n]);
}
function zh(e) {
  var t = ss();
  return mc(function() {
    t.current = e;
  }), t.current;
}
var ga = h.createContext({
  // eslint-disable-next-line no-restricted-globals
  window: typeof window == "object" ? window : void 0
}), ma = function() {
  return h.useContext(ga).window;
};
function Wh(e, t) {
  var r = h.useRef(), n = h.useRef(null), o = ma();
  if (!e || e !== r.current || typeof e == "string") {
    var a = t == null ? void 0 : t.current;
    if (e)
      if (typeof e == "string") {
        var i = We(a);
        n.current = i ? i.querySelector(e) : null;
      } else
        "stopPropagation" in e || "getBoundingClientRect" in e ? n.current = e : "current" in e ? n.current = e.current : n.current = e;
    r.current = e;
  }
  return [n, o];
}
var Uh = 0;
function xl(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = e.name, r = e.props, n = e.other, o = n === void 0 ? [] : n, a = e.conditionallyRequired, i = e.deprecations, s = e.mutuallyExclusive, l = e.controlledUsage, c = h.useRef(!1), u = _n(function() {
      return "useWarnings_".concat(Uh++);
    }), d = zh(r);
    if (!c.current) {
      c.current = !0;
      for (var f = 0, p = o; f < p.length; f++) {
        var g = p[f];
        ot(g);
      }
      if (a)
        for (var b = 0, x = a; b < x.length; b++) {
          var m = x[b];
          bd(t, r, m.requiredProps, m.conditionalPropName, m.condition);
        }
      i && da(t, r, i), s && Ys(t, r, s);
    }
    l && sl(w(w({}, l), { componentId: u, props: r, componentName: t, oldProps: d }));
  }
}
function qh(e, t) {
  var r = Or(), n = h.useState(!1), o = n[0], a = n[1];
  return h.useEffect(function() {
    return r.requestAnimationFrame(function() {
      var i;
      if (!(e.style && e.style.overflowY)) {
        var s = !1;
        if (t && t.current && (!((i = t.current) === null || i === void 0) && i.firstElementChild)) {
          var l = t.current.clientHeight, c = t.current.firstElementChild.clientHeight;
          l > 0 && c > l && (s = c - l > 1);
        }
        o !== s && a(s);
      }
    }), function() {
      return r.dispose();
    };
  }), o;
}
function Gh(e) {
  var t = e.originalElement, r = e.containsFocus;
  t && r && t !== ce() && setTimeout(function() {
    var n;
    (n = t.focus) === null || n === void 0 || n.call(t);
  }, 0);
}
function Yh(e, t) {
  var r = e.onRestoreFocus, n = r === void 0 ? Gh : r, o = h.useRef(), a = h.useRef(!1);
  h.useEffect(function() {
    return o.current = We().activeElement, fd(t.current) && (a.current = !0), function() {
      var i;
      n == null || n({
        originalElement: o.current,
        containsFocus: a.current,
        documentContainsFocus: ((i = We()) === null || i === void 0 ? void 0 : i.hasFocus()) || !1
      }), o.current = void 0;
    };
  }, []), xn(t, "focus", h.useCallback(function() {
    a.current = !0;
  }, []), !0), xn(t, "blur", h.useCallback(function(i) {
    t.current && i.relatedTarget && !t.current.contains(i.relatedTarget) && (a.current = !1);
  }, []), !0);
}
function Kh(e, t) {
  var r = String(e["aria-modal"]).toLowerCase() === "true" && e.enableAriaHiddenSiblings;
  h.useEffect(function() {
    if (r && t.current) {
      var n = nf(t.current);
      return n;
    }
  }, [t, r]);
}
var Cl = h.forwardRef(function(e, t) {
  var r = ll({ shouldRestoreFocus: !0, enableAriaHiddenSiblings: !0 }, e), n = h.useRef(), o = Ht(n, t);
  Kh(r, n), Yh(r, n);
  var a = r.role, i = r.className, s = r.ariaLabel, l = r.ariaLabelledBy, c = r.ariaDescribedBy, u = r.style, d = r.children, f = r.onDismiss, p = qh(r, n), g = h.useCallback(function(x) {
    switch (x.which) {
      case me.escape:
        f && (f(x), x.preventDefault(), x.stopPropagation());
        break;
    }
  }, [f]), b = ma();
  return xn(b, "keydown", g), h.createElement("div", w({ ref: o }, Je(r, fr), { className: i, role: a, "aria-label": s, "aria-labelledby": l, "aria-describedby": c, onKeyDown: g, style: w({ overflowY: p ? "scroll" : void 0, outline: "none" }, u) }), d);
});
Cl.displayName = "Popup";
var Xh = function() {
  var e;
  return ((e = ma()) !== null && e !== void 0 ? e : typeof window != "undefined") ? window : void 0;
}, Li = function(e) {
  var t, r;
  return ((r = (t = e == null ? void 0 : e.window) === null || t === void 0 ? void 0 : t.document) !== null && r !== void 0 ? r : typeof document != "undefined") ? document : void 0;
}, Qh = function(e) {
  var t;
  return ((t = e == null ? void 0 : e.window) !== null && t !== void 0 ? t : typeof window != "undefined") ? window : void 0;
}, Kt, Jh = "CalloutContentBase", Zh = (Kt = {}, Kt[A.top] = Dt.slideUpIn10, Kt[A.bottom] = Dt.slideDownIn10, Kt[A.left] = Dt.slideLeftIn10, Kt[A.right] = Dt.slideRightIn10, Kt), Bi = { top: 0, left: 0 }, ev = {
  opacity: 0,
  filter: "opacity(0)",
  pointerEvents: "none"
}, tv = ["role", "aria-roledescription"], El = {
  preventDismissOnLostFocus: !1,
  preventDismissOnScroll: !1,
  preventDismissOnResize: !1,
  isBeakVisible: !0,
  beakWidth: 16,
  gapSpace: 0,
  minPagePadding: 8,
  directionalHint: Ee.bottomAutoEdge
}, rv = Ue({
  disableCaching: !0
  // disabling caching because stylesProp.position mutates often
});
function nv(e, t, r) {
  var n = e.bounds, o = e.minPagePadding, a = o === void 0 ? El.minPagePadding : o, i = e.target, s = h.useState(!1), l = s[0], c = s[1], u = h.useRef(), d = h.useCallback(function() {
    if (!u.current || l) {
      var p = typeof n == "function" ? r ? n(i, r) : void 0 : n;
      !p && r && (p = Fh(t.current, r), p = {
        top: p.top + a,
        left: p.left + a,
        right: p.right - a,
        bottom: p.bottom - a,
        width: p.width - a * 2,
        height: p.height - a * 2
      }), u.current = p, l && c(!1);
    }
    return u.current;
  }, [n, a, i, t, r, l]), f = Or();
  return xn(r, "resize", f.debounce(function() {
    c(!0);
  }, 500, { leading: !0 })), d;
}
function ov(e, t, r, n) {
  var o, a = e.calloutMaxHeight, i = e.finalHeight, s = e.directionalHint, l = e.directionalHintFixed, c = e.hidden, u = e.gapSpace, d = e.beakWidth, f = e.isBeakVisible, p = e.coverTarget, g = h.useState(), b = g[0], x = g[1], m = (o = n == null ? void 0 : n.elementPosition) !== null && o !== void 0 ? o : {}, y = m.top, C = m.bottom, E = r != null && r.current ? $h(r.current) : void 0;
  return h.useEffect(function() {
    var k, S = (k = t()) !== null && k !== void 0 ? k : {}, _ = S.top, P = S.bottom, D;
    (n == null ? void 0 : n.targetEdge) === A.top && (E != null && E.top) && !p && (P = E.top - Hh(f, d, u)), typeof y == "number" && P ? D = P - y : typeof C == "number" && typeof _ == "number" && P && (D = P - _ - C), !a && !c || a && D && a > D ? x(D) : x(a || void 0);
  }, [
    C,
    a,
    i,
    s,
    l,
    t,
    c,
    n,
    y,
    u,
    d,
    f,
    E,
    p
  ]), b;
}
function av(e, t, r, n, o, a) {
  var i = h.useState(), s = i[0], l = i[1], c = h.useRef(0), u = h.useRef(), d = Or(), f = e.hidden, p = e.target, g = e.finalHeight, b = e.calloutMaxHeight, x = e.onPositioned, m = e.directionalHint, y = e.hideOverflow, C = e.preferScrollResizePositioning, E = Xh(), k = h.useRef(), S;
  k.current !== a.current && (k.current = a.current, S = a.current ? E == null ? void 0 : E.getComputedStyle(a.current) : void 0);
  var _ = S == null ? void 0 : S.overflowY;
  return h.useEffect(function() {
    if (f)
      l(void 0), c.current = 0;
    else {
      var P = d.requestAnimationFrame(function() {
        var D, z;
        if (t.current && r) {
          var q = w(w({}, e), { target: n.current, bounds: o() }), I = r.cloneNode(!0);
          I.style.maxHeight = b ? "".concat(b) : "", I.style.visibility = "hidden", (D = r.parentElement) === null || D === void 0 || D.appendChild(I);
          var R = u.current === p ? s : void 0, L = y || _ === "clip" || _ === "hidden", M = C && !L, $ = g ? Bh(q, t.current, I, R, E) : Lh(q, t.current, I, R, M, void 0, E);
          (z = r.parentElement) === null || z === void 0 || z.removeChild(I), !s && $ || s && $ && !cv(s, $) && c.current < 5 ? (c.current++, l($)) : c.current > 0 && (c.current = 0, x == null || x(s));
        }
      }, r);
      return u.current = p, function() {
        d.cancelAnimationFrame(P), u.current = void 0;
      };
    }
  }, [
    f,
    m,
    d,
    r,
    b,
    t,
    n,
    g,
    o,
    x,
    s,
    e,
    p,
    y,
    C,
    _,
    E
  ]), s;
}
function iv(e, t, r) {
  var n = e.hidden, o = e.setInitialFocus, a = Or(), i = !!t;
  h.useEffect(function() {
    if (!n && o && i && r) {
      var s = a.requestAnimationFrame(function() {
        return sd(r);
      }, r);
      return function() {
        return a.cancelAnimationFrame(s);
      };
    }
  }, [n, i, a, r, o]);
}
function sv(e, t, r, n, o) {
  var a = e.hidden, i = e.onDismiss, s = e.preventDismissOnScroll, l = e.preventDismissOnResize, c = e.preventDismissOnLostFocus, u = e.dismissOnTargetClick, d = e.shouldDismissOnWindowFocus, f = e.preventDismissOnEvent, p = h.useRef(!1), g = Or(), b = _n([
    function() {
      p.current = !0;
    },
    function() {
      p.current = !1;
    }
  ]), x = !!t;
  return h.useEffect(function() {
    var m = function(_) {
      x && !s && E(_);
    }, y = function(_) {
      !l && !(f && f(_)) && (i == null || i(_));
    }, C = function(_) {
      c || E(_);
    }, E = function(_) {
      var P = _.composedPath ? _.composedPath() : [], D = P.length > 0 ? P[0] : _.target, z = r.current && !Lo(r.current, D);
      if (z && p.current) {
        p.current = !1;
        return;
      }
      if (!n.current && z || _.target !== o && z && (!n.current || "stopPropagation" in n.current || u || D !== n.current && !Lo(n.current, D))) {
        if (f && f(_))
          return;
        i == null || i(_);
      }
    }, k = function(_) {
      d && (f && !f(_) || !f && !c) && !(o != null && o.document.hasFocus()) && _.relatedTarget === null && (i == null || i(_));
    }, S = new Promise(function(_) {
      g.setTimeout(function() {
        if (!a && o) {
          var P = [
            lt(o, "scroll", m, !0),
            lt(o, "resize", y, !0),
            lt(o.document.documentElement, "focus", C, !0),
            lt(o.document.documentElement, "click", C, !0),
            lt(o, "blur", k, !0)
          ];
          _(function() {
            P.forEach(function(D) {
              return D();
            });
          });
        }
      }, 0);
    });
    return function() {
      S.then(function(_) {
        return _();
      });
    };
  }, [
    a,
    g,
    r,
    n,
    o,
    i,
    d,
    u,
    c,
    l,
    s,
    x,
    f
  ]), b;
}
var wl = h.memo(h.forwardRef(function(e, t) {
  var r = ll(El, e), n = r.styles, o = r.style, a = r.ariaLabel, i = r.ariaDescribedBy, s = r.ariaLabelledBy, l = r.className, c = r.isBeakVisible, u = r.children, d = r.beakWidth, f = r.calloutWidth, p = r.calloutMaxWidth, g = r.calloutMinWidth, b = r.doNotLayer, x = r.finalHeight, m = r.hideOverflow, y = m === void 0 ? !!x : m, C = r.backgroundColor, E = r.calloutMaxHeight, k = r.onScroll, S = r.shouldRestoreFocus, _ = S === void 0 ? !0 : S, P = r.target, D = r.hidden, z = r.onLayerMounted, q = r.popupProps, I = h.useRef(null), R = h.useRef(null), L = Ht(R, q == null ? void 0 : q.ref), M = h.useState(null), $ = M[0], G = M[1], be = h.useCallback(function(Dr) {
    G(Dr);
  }, []), Y = Ht(I, t), Q = Wh(r.target, {
    current: $
  }), ye = Q[0], fe = Q[1], et = nv(r, ye, fe), oe = av(r, I, $, ye, et, L), at = ov(r, et, ye, oe), De = sv(r, oe, I, ye, fe), Ge = De[0], Ne = De[1], Pe = (oe == null ? void 0 : oe.elementPosition.top) && (oe == null ? void 0 : oe.elementPosition.bottom), Fe = w(w({}, oe == null ? void 0 : oe.elementPosition), { maxHeight: at });
  if (Pe && (Fe.bottom = void 0), iv(r, oe, $), h.useEffect(function() {
    D || z == null || z();
  }, [D]), !fe)
    return null;
  var O = y, _e = c && !!P, He = rv(n, {
    theme: r.theme,
    className: l,
    overflowYHidden: O,
    calloutWidth: f,
    positions: oe,
    beakWidth: d,
    backgroundColor: C,
    calloutMaxWidth: p,
    calloutMinWidth: g,
    doNotLayer: b
  }), Vt = w(w({ maxHeight: E || "100%" }, o), O && { overflowY: "hidden" }), zt = r.hidden ? { visibility: "hidden" } : void 0;
  return h.createElement(
    "div",
    { ref: Y, className: He.container, style: zt },
    h.createElement(
      "div",
      w({}, Je(r, fr, tv), {
        className: ha(He.root, oe && oe.targetEdge && Zh[oe.targetEdge]),
        style: oe ? w({}, Fe) : ev,
        // Safari and Firefox on Mac OS requires this to back-stop click events so focus remains in the Callout.
        // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
        tabIndex: -1,
        ref: be
      }),
      _e && h.createElement("div", { className: He.beak, style: lv(oe) }),
      _e && h.createElement("div", { className: He.beakCurtain }),
      h.createElement(
        Cl,
        w({
          // don't use getNativeElementProps for role and roledescription because it will also
          // pass through data-* props (resulting in them being used in two places)
          role: r.role,
          "aria-roledescription": r["aria-roledescription"],
          ariaDescribedBy: i,
          ariaLabel: a,
          ariaLabelledBy: s,
          className: He.calloutMain,
          onDismiss: r.onDismiss,
          onMouseDown: Ge,
          onMouseUp: Ne,
          onRestoreFocus: r.onRestoreFocus,
          onScroll: k,
          shouldRestoreFocus: _,
          style: Vt
        }, q, { ref: L }),
        u
      )
    )
  );
}), function(e, t) {
  return !t.shouldUpdateWhenHidden && e.hidden && t.hidden ? !0 : vd(e, t);
});
function lv(e) {
  var t, r, n = w(w({}, (t = e == null ? void 0 : e.beakPosition) === null || t === void 0 ? void 0 : t.elementPosition), { display: !((r = e == null ? void 0 : e.beakPosition) === null || r === void 0) && r.hideBeak ? "none" : void 0 });
  return !n.top && !n.bottom && !n.left && !n.right && (n.left = Bi.left, n.top = Bi.top), n;
}
function cv(e, t) {
  return Mi(e.elementPosition, t.elementPosition) && Mi(e.beakPosition.elementPosition, t.beakPosition.elementPosition);
}
function Mi(e, t) {
  for (var r in t)
    if (t.hasOwnProperty(r)) {
      var n = e[r], o = t[r];
      if (n !== void 0 && o !== void 0) {
        if (n.toFixed(2) !== o.toFixed(2))
          return !1;
      } else
        return !1;
    }
  return !0;
}
wl.displayName = Jh;
function uv(e) {
  return {
    height: e,
    width: e
  };
}
var dv = {
  container: "ms-Callout-container",
  root: "ms-Callout",
  beak: "ms-Callout-beak",
  beakCurtain: "ms-Callout-beakCurtain",
  calloutMain: "ms-Callout-main"
}, fv = function(e) {
  var t, r = e.theme, n = e.className, o = e.overflowYHidden, a = e.calloutWidth, i = e.beakWidth, s = e.backgroundColor, l = e.calloutMaxWidth, c = e.calloutMinWidth, u = e.doNotLayer, d = hr(dv, r), f = r.semanticColors, p = r.effects;
  return {
    container: [
      d.container,
      {
        position: "relative"
      }
    ],
    root: [
      d.root,
      r.fonts.medium,
      {
        position: "absolute",
        display: "flex",
        zIndex: u ? kr.Layer : void 0,
        boxSizing: "border-box",
        borderRadius: p.roundedCorner2,
        boxShadow: p.elevation16,
        selectors: (t = {}, t[ne] = {
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: "WindowText"
        }, t)
      },
      oh(),
      n,
      !!a && { width: a },
      !!l && { maxWidth: l },
      !!c && { minWidth: c }
    ],
    beak: [
      d.beak,
      {
        position: "absolute",
        backgroundColor: f.menuBackground,
        boxShadow: "inherit",
        border: "inherit",
        boxSizing: "border-box",
        transform: "rotate(45deg)"
      },
      uv(i),
      s && {
        backgroundColor: s
      }
    ],
    beakCurtain: [
      d.beakCurtain,
      {
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: f.menuBackground,
        borderRadius: p.roundedCorner2
      }
    ],
    calloutMain: [
      d.calloutMain,
      {
        backgroundColor: f.menuBackground,
        overflowX: "hidden",
        overflowY: "auto",
        position: "relative",
        width: "100%",
        borderRadius: p.roundedCorner2
      },
      o && {
        overflowY: "hidden"
      },
      s && {
        backgroundColor: s
      }
    ]
  };
}, hv = qe(wl, fv, void 0, {
  scope: "CalloutContent"
}), Sl = h.createContext(void 0), vv = function() {
  return function() {
  };
};
Sl.Provider;
function pv() {
  var e;
  return (e = h.useContext(Sl)) !== null && e !== void 0 ? e : vv;
}
var gv = Ue(), mv = Mn(function(e, t) {
  return $n(w(w({}, e), { rtl: t }));
}), bv = function(e) {
  var t = e.theme, r = e.dir, n = Sr(t) ? "rtl" : "ltr", o = Sr() ? "rtl" : "ltr", a = r || n;
  return {
    // If Fabric dir !== contextDir
    // Or If contextDir !== pageDir
    // Then we need to set dir of the Fabric root
    rootDir: a !== n || a !== o ? a : r,
    // If dir !== contextDir || pageDir
    // then set contextual theme around content
    needsTheme: a !== n
  };
}, kl = h.forwardRef(function(e, t) {
  var r = e.className, n = e.theme, o = e.applyTheme, a = e.applyThemeToBody, i = e.styles, s = gv(i, {
    theme: n,
    applyTheme: o,
    className: r
  }), l = h.useRef(null);
  return _v(a, s, l), h.createElement(h.Fragment, null, yv(e, s, l, t));
});
kl.displayName = "FabricBase";
function yv(e, t, r, n) {
  var o = t.root, a = e.as, i = a === void 0 ? "div" : a, s = e.dir, l = e.theme, c = Je(e, fr, ["dir"]), u = bv(e), d = u.rootDir, f = u.needsTheme, p = h.createElement(
    al,
    { providerRef: r },
    h.createElement(i, w({ dir: d }, c, { className: o, ref: Ht(r, n) }))
  );
  return f && (p = // eslint-disable-next-line deprecation/deprecation
  h.createElement(Md, { settings: { theme: mv(l, s === "rtl") } }, p)), p;
}
function _v(e, t, r) {
  var n = t.bodyThemed;
  return h.useEffect(function() {
    if (e) {
      var o = We(r.current);
      if (o)
        return o.body.classList.add(n), function() {
          o.body.classList.remove(n);
        };
    }
  }, [n, e, r]), r;
}
var po = { fontFamily: "inherit" }, xv = {
  root: "ms-Fabric",
  bodyThemed: "ms-Fabric-bodyThemed"
}, Cv = function(e) {
  var t = e.applyTheme, r = e.className, n = e.preventBlanketFontInheritance, o = e.theme, a = hr(xv, o);
  return {
    root: [
      a.root,
      o.fonts.medium,
      {
        color: o.palette.neutralPrimary
      },
      !n && {
        "& button": po,
        "& input": po,
        "& textarea": po
      },
      // apply theme to only if applyTheme is true
      t && {
        color: o.semanticColors.bodyText,
        backgroundColor: o.semanticColors.bodyBackground
      },
      r
    ],
    bodyThemed: [
      {
        backgroundColor: o.semanticColors.bodyBackground
      }
    ]
  };
}, Ev = qe(kl, Cv, void 0, {
  scope: "Fabric"
}), _r = {}, ba = {}, Tl = "fluent-default-layer-host", wv = "#".concat(Tl);
function Sv(e, t) {
  _r[e] || (_r[e] = []), _r[e].push(t);
  var r = ba[e];
  if (r)
    for (var n = 0, o = r; n < o.length; n++) {
      var a = o[n];
      a.notifyLayersChanged();
    }
}
function kv(e, t) {
  var r = _r[e];
  if (r) {
    var n = r.indexOf(t);
    n >= 0 && (r.splice(n, 1), r.length === 0 && delete _r[e]);
  }
  var o = ba[e];
  if (o)
    for (var a = 0, i = o; a < i.length; a++) {
      var s = i[a];
      s.notifyLayersChanged();
    }
}
function Tv(e) {
  var t = ba[e];
  return t && t[0] || void 0;
}
function Rv(e) {
  var t = e.createElement("div");
  return t.setAttribute("id", Tl), t.style.cssText = "position:fixed;z-index:1000000", e == null || e.body.appendChild(t), t;
}
function Nv() {
  return wv;
}
var Pv = Ue(), Iv = function(e) {
  return e != null && e.current ? e.current.classList.contains(Ft) : !1;
}, Rl = h.forwardRef(function(e, t) {
  var r = pv(), n = h.useRef(null), o = Ht(n, t), a = h.useRef(), i = h.useRef(null), s = h.useContext(pn), l = h.useState(!1), c = l[0], u = l[1], d = h.useCallback(function(L) {
    var M = Iv(s == null ? void 0 : s.providerRef);
    L && M && L.classList.add(Ft);
  }, [s]), f = e.children, p = e.className, g = e.eventBubblingEnabled, b = e.fabricProps, x = e.hostId, m = e.insertFirst, y = e.onLayerDidMount, C = y === void 0 ? function() {
  } : y, E = e.onLayerMounted, k = E === void 0 ? function() {
  } : E, S = e.onLayerWillUnmount, _ = e.styles, P = e.theme, D = Ht(i, b == null ? void 0 : b.ref, d), z = Pv(_, {
    theme: P,
    className: p,
    isNotHost: !x
  }), q = function(L) {
    var M, $;
    if (x) {
      var G = Tv(x);
      return G ? (M = G.rootRef.current) !== null && M !== void 0 ? M : null : ($ = L.getElementById(x)) !== null && $ !== void 0 ? $ : null;
    } else {
      var be = Nv(), Y = be ? L.querySelector(be) : null;
      return Y || (Y = Rv(L)), Y;
    }
  }, I = function() {
    S == null || S();
    var L = a.current;
    a.current = void 0, L && L.parentNode && L.parentNode.removeChild(L);
  }, R = function() {
    var L, M = We(n.current);
    if (M) {
      var $ = q(M);
      if ($) {
        I();
        var G = ((L = $.ownerDocument) !== null && L !== void 0 ? L : M).createElement("div");
        G.className = z.root, ed(G), rd(G, n.current), m ? $.insertBefore(G, $.firstChild) : $.appendChild(G), a.current = G, u(!0);
      }
    }
  };
  return cl(function() {
    R(), x && Sv(x, R);
    var L = a.current ? r(a.current) : void 0;
    return function() {
      L && L(), I(), x && kv(x, R);
    };
  }, [x]), h.useEffect(function() {
    a.current && c && (k == null || k(), C == null || C(), u(!1));
  }, [c, k, C]), Dv(e), h.createElement("span", { className: "ms-layer", ref: o }, a.current && bc.createPortal(h.createElement(
    al,
    { layerRoot: !0, providerRef: D },
    h.createElement(Ev, w({}, !g && Av(), b, { className: ha(z.content, b == null ? void 0 : b.className), ref: D }), f)
  ), a.current));
});
Rl.displayName = "LayerBase";
var Yr, Ov = function(e) {
  e.eventPhase === Event.BUBBLING_PHASE && e.type !== "mouseenter" && e.type !== "mouseleave" && e.type !== "touchstart" && e.type !== "touchend" && e.stopPropagation();
};
function Av() {
  return Yr || (Yr = {}, [
    "onClick",
    "onContextMenu",
    "onDoubleClick",
    "onDrag",
    "onDragEnd",
    "onDragEnter",
    "onDragExit",
    "onDragLeave",
    "onDragOver",
    "onDragStart",
    "onDrop",
    "onMouseDown",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseOver",
    "onMouseOut",
    "onMouseUp",
    "onTouchMove",
    "onTouchStart",
    "onTouchCancel",
    "onTouchEnd",
    "onKeyDown",
    "onKeyPress",
    "onKeyUp",
    "onFocus",
    "onBlur",
    "onChange",
    "onInput",
    "onInvalid",
    "onSubmit"
  ].forEach(function(e) {
    return Yr[e] = Ov;
  })), Yr;
}
function Dv(e) {
  process.env.NODE_ENV !== "production" && xl({
    name: "Layer",
    props: e,
    deprecations: { onLayerMounted: "onLayerDidMount" }
  });
}
var Lv = {
  root: "ms-Layer",
  rootNoHost: "ms-Layer--fixed",
  content: "ms-Layer-content"
}, Bv = function(e) {
  var t = e.className, r = e.isNotHost, n = e.theme, o = hr(Lv, n);
  return {
    root: [
      o.root,
      n.fonts.medium,
      r && [
        o.rootNoHost,
        {
          position: "fixed",
          zIndex: kr.Layer,
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          visibility: "hidden"
        }
      ],
      t
    ],
    content: [
      o.content,
      {
        visibility: "visible"
      }
    ]
  };
}, Mv = qe(Rl, Bv, void 0, {
  scope: "Layer",
  fields: ["hostId", "theme", "styles"]
}), ya = h.forwardRef(function(e, t) {
  var r = e.layerProps, n = e.doNotLayer, o = Ls(e, ["layerProps", "doNotLayer"]), a = h.createElement(hv, w({}, o, { doNotLayer: n, ref: t }));
  return n ? a : h.createElement(Mv, w({}, r), a);
});
ya.displayName = "Callout";
var jv = Ue(), Fv = (
  /** @class */
  function(e) {
    dt(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._onRenderContent = function(n) {
        return typeof n.content == "string" ? h.createElement("p", { className: r._classNames.subText }, n.content) : h.createElement("div", { className: r._classNames.subText }, n.content);
      }, r;
    }
    return t.prototype.render = function() {
      var r = this.props, n = r.className, o = r.calloutProps, a = r.directionalHint, i = r.directionalHintForRTL, s = r.styles, l = r.id, c = r.maxWidth, u = r.onRenderContent, d = u === void 0 ? this._onRenderContent : u, f = r.targetElement, p = r.theme;
      return this._classNames = jv(s, {
        theme: p,
        className: n || o && o.className,
        beakWidth: o && o.isBeakVisible ? o.beakWidth : 0,
        gapSpace: o && o.gapSpace,
        maxWidth: c
      }), h.createElement(
        ya,
        w({ target: f, directionalHint: a, directionalHintForRTL: i }, o, Je(this.props, fr, ["id"]), { className: this._classNames.root }),
        h.createElement("div", { className: this._classNames.content, id: l, onFocus: this.props.onFocus, onMouseEnter: this.props.onMouseEnter, onMouseLeave: this.props.onMouseLeave }, d(this.props, this._onRenderContent))
      );
    }, t.defaultProps = {
      directionalHint: Ee.topCenter,
      maxWidth: "364px",
      calloutProps: {
        isBeakVisible: !0,
        beakWidth: 16,
        gapSpace: 0,
        setInitialFocus: !0,
        doNotLayer: !1
      }
    }, t;
  }(h.Component)
), Hv = function(e) {
  var t = e.className, r = e.beakWidth, n = r === void 0 ? 16 : r, o = e.gapSpace, a = o === void 0 ? 0 : o, i = e.maxWidth, s = e.theme, l = s.semanticColors, c = s.fonts, u = s.effects, d = -(Math.sqrt(n * n / 2) + a) + 1 / // There isn't really a great way to pass in a `window` reference here so disabling the line rule
  // eslint-disable-next-line no-restricted-globals
  window.devicePixelRatio;
  return {
    root: [
      "ms-Tooltip",
      s.fonts.medium,
      Dt.fadeIn200,
      {
        background: l.menuBackground,
        boxShadow: u.elevation8,
        padding: "8px",
        maxWidth: i,
        selectors: {
          ":after": {
            content: "''",
            position: "absolute",
            bottom: d,
            left: d,
            right: d,
            top: d,
            zIndex: 0
          }
        }
      },
      t
    ],
    content: [
      "ms-Tooltip-content",
      c.small,
      {
        position: "relative",
        zIndex: 1,
        color: l.menuItemText,
        wordWrap: "break-word",
        overflowWrap: "break-word",
        overflow: "hidden"
      }
    ],
    subText: [
      "ms-Tooltip-subtext",
      {
        // Using inherit here to avoid unintentional global overrides of the <p> tag.
        fontSize: "inherit",
        fontWeight: "inherit",
        color: "inherit",
        margin: 0
      }
    ]
  };
}, $v = qe(Fv, Hv, void 0, {
  scope: "Tooltip"
}), Zt;
(function(e) {
  e[e.zero = 0] = "zero", e[e.medium = 1] = "medium", e[e.long = 2] = "long";
})(Zt || (Zt = {}));
var Cn;
(function(e) {
  e[e.Parent = 0] = "Parent", e[e.Self = 1] = "Self";
})(Cn || (Cn = {}));
var Vv = Ue(), zv = (
  /** @class */
  function(e) {
    dt(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n._tooltipHost = h.createRef(), n._defaultTooltipId = Ct("tooltip"), n.show = function() {
        n._toggleTooltip(!0);
      }, n.dismiss = function() {
        n._hideTooltip();
      }, n._getTargetElement = function() {
        if (n._tooltipHost.current) {
          var o = n.props.overflowMode;
          if (o !== void 0)
            switch (o) {
              case Cn.Parent:
                return n._tooltipHost.current.parentElement;
              case Cn.Self:
                return n._tooltipHost.current;
            }
          return n._tooltipHost.current;
        }
      }, n._onTooltipFocus = function(o) {
        if (n._ignoreNextFocusEvent) {
          n._ignoreNextFocusEvent = !1;
          return;
        }
        n._onTooltipMouseEnter(o);
      }, n._onTooltipContentFocus = function(o) {
        t._currentVisibleTooltip && t._currentVisibleTooltip !== n && t._currentVisibleTooltip.dismiss(), t._currentVisibleTooltip = n, n._clearDismissTimer(), n._clearOpenTimer();
      }, n._onTooltipBlur = function(o) {
        var a;
        n._ignoreNextFocusEvent = ((a = Li(n.context)) === null || a === void 0 ? void 0 : a.activeElement) === o.target, n._dismissTimerId = n._async.setTimeout(function() {
          n._hideTooltip();
        }, 0);
      }, n._onTooltipMouseEnter = function(o) {
        var a = n.props, i = a.overflowMode, s = a.delay, l = Li(n.context);
        if (t._currentVisibleTooltip && t._currentVisibleTooltip !== n && t._currentVisibleTooltip.dismiss(), t._currentVisibleTooltip = n, i !== void 0) {
          var c = n._getTargetElement();
          if (c && !lf(c))
            return;
        }
        if (!(o.target && td(o.target, n._getTargetElement(), l)))
          if (n._clearDismissTimer(), n._clearOpenTimer(), s !== Zt.zero) {
            var u = n._getDelayTime(s);
            n._openTimerId = n._async.setTimeout(function() {
              n._toggleTooltip(!0);
            }, u);
          } else
            n._toggleTooltip(!0);
      }, n._onTooltipMouseLeave = function(o) {
        var a = n.props.closeDelay;
        n._clearDismissTimer(), n._clearOpenTimer(), a ? n._dismissTimerId = n._async.setTimeout(function() {
          n._toggleTooltip(!1);
        }, a) : n._toggleTooltip(!1), t._currentVisibleTooltip === n && (t._currentVisibleTooltip = void 0);
      }, n._onTooltipKeyDown = function(o) {
        (o.which === me.escape || o.ctrlKey) && n.state.isTooltipVisible && (n._hideTooltip(), o.stopPropagation());
      }, n._clearDismissTimer = function() {
        n._async.clearTimeout(n._dismissTimerId);
      }, n._clearOpenTimer = function() {
        n._async.clearTimeout(n._openTimerId);
      }, n._hideTooltip = function() {
        n._clearOpenTimer(), n._clearDismissTimer(), n._toggleTooltip(!1);
      }, n._toggleTooltip = function(o) {
        n.state.isTooltipVisible !== o && n.setState({ isTooltipVisible: o }, function() {
          return n.props.onTooltipToggle && n.props.onTooltipToggle(o);
        });
      }, n._getDelayTime = function(o) {
        switch (o) {
          case Zt.medium:
            return 300;
          case Zt.long:
            return 500;
          default:
            return 0;
        }
      }, Ir(n), n.state = {
        isAriaPlaceholderRendered: !1,
        isTooltipVisible: !1
      }, n;
    }
    return t.prototype.render = function() {
      var r = this.props, n = r.calloutProps, o = r.children, a = r.content, i = r.directionalHint, s = r.directionalHintForRTL, l = r.hostClassName, c = r.id, u = r.setAriaDescribedBy, d = u === void 0 ? !0 : u, f = r.tooltipProps, p = r.styles, g = r.theme;
      this._classNames = Vv(p, {
        theme: g,
        className: l
      });
      var b = this.state.isTooltipVisible, x = c || this._defaultTooltipId, m = w(w({ id: "".concat(x, "--tooltip"), content: a, targetElement: this._getTargetElement(), directionalHint: i, directionalHintForRTL: s, calloutProps: pd({}, n, {
        onDismiss: this._hideTooltip,
        onFocus: this._onTooltipContentFocus,
        onMouseEnter: this._onTooltipMouseEnter,
        onMouseLeave: this._onTooltipMouseLeave
      }), onMouseEnter: this._onTooltipMouseEnter, onMouseLeave: this._onTooltipMouseLeave }, Je(this.props, fr, ["id"])), f), y = f != null && f.onRenderContent ? f.onRenderContent(m, function(k) {
        return k != null && k.content ? h.createElement(h.Fragment, null, k.content) : null;
      }) : a, C = b && !!y, E = d && b && y ? x : void 0;
      return h.createElement(
        "div",
        w({ className: this._classNames.root, ref: this._tooltipHost }, { onFocusCapture: this._onTooltipFocus }, { onBlurCapture: this._onTooltipBlur }, { onMouseEnter: this._onTooltipMouseEnter, onMouseLeave: this._onTooltipMouseLeave, onKeyDown: this._onTooltipKeyDown, role: "none", "aria-describedby": E }),
        o,
        C && h.createElement($v, w({}, m)),
        h.createElement("div", { hidden: !0, id: x, style: fl }, y)
      );
    }, t.prototype.componentDidMount = function() {
      this._async = new ua(this);
    }, t.prototype.componentWillUnmount = function() {
      t._currentVisibleTooltip && t._currentVisibleTooltip === this && (t._currentVisibleTooltip = void 0), this._async.dispose();
    }, t.defaultProps = {
      delay: Zt.medium
    }, t.contextType = ga, t;
  }(h.Component)
), Wv = {
  root: "ms-TooltipHost",
  ariaPlaceholder: "ms-TooltipHost-aria-placeholder"
}, Uv = function(e) {
  var t = e.className, r = e.theme, n = hr(Wv, r);
  return {
    root: [
      n.root,
      {
        display: "inline"
      },
      t
    ]
  };
}, qv = qe(zv, Uv, void 0, {
  scope: "TooltipHost"
}), En;
(function(e) {
  e[e.default = 0] = "default", e[e.image = 1] = "image", e[e.Default = 1e5] = "Default", e[e.Image = 100001] = "Image";
})(En || (En = {}));
var Be;
(function(e) {
  e[e.center = 0] = "center", e[e.contain = 1] = "contain", e[e.cover = 2] = "cover", e[e.none = 3] = "none", e[e.centerCover = 4] = "centerCover", e[e.centerContain = 5] = "centerContain";
})(Be || (Be = {}));
var Nr;
(function(e) {
  e[e.landscape = 0] = "landscape", e[e.portrait = 1] = "portrait";
})(Nr || (Nr = {}));
var Ae;
(function(e) {
  e[e.notLoaded = 0] = "notLoaded", e[e.loaded = 1] = "loaded", e[e.error = 2] = "error", e[e.errorLoaded = 3] = "errorLoaded";
})(Ae || (Ae = {}));
var Gv = Ue(), Yv = /\.svg$/i, Kv = "fabricImage";
function Xv(e, t) {
  var r = e.onLoadingStateChange, n = e.onLoad, o = e.onError, a = e.src, i = h.useState(Ae.notLoaded), s = i[0], l = i[1];
  cl(function() {
    l(Ae.notLoaded);
  }, [a]), h.useEffect(function() {
    if (s === Ae.notLoaded) {
      var d = t.current ? a && t.current.naturalWidth > 0 && t.current.naturalHeight > 0 || t.current.complete && Yv.test(a) : !1;
      d && l(Ae.loaded);
    }
  }), h.useEffect(function() {
    r == null || r(s);
  }, [s]);
  var c = h.useCallback(function(d) {
    n == null || n(d), a && l(Ae.loaded);
  }, [a, n]), u = h.useCallback(function(d) {
    o == null || o(d), l(Ae.error);
  }, [o]);
  return [s, c, u];
}
var Nl = h.forwardRef(function(e, t) {
  var r = h.useRef(), n = h.useRef(), o = Xv(e, n), a = o[0], i = o[1], s = o[2], l = Je(e, Gd, [
    "width",
    "height"
  ]), c = e.src, u = e.alt, d = e.width, f = e.height, p = e.shouldFadeIn, g = p === void 0 ? !0 : p, b = e.shouldStartVisible, x = e.className, m = e.imageFit, y = e.role, C = e.maximizeFrame, E = e.styles, k = e.theme, S = e.loading, _ = Qv(e, a, n, r), P = Gv(E, {
    theme: k,
    className: x,
    width: d,
    height: f,
    maximizeFrame: C,
    shouldFadeIn: g,
    shouldStartVisible: b,
    isLoaded: a === Ae.loaded || a === Ae.notLoaded && e.shouldStartVisible,
    isLandscape: _ === Nr.landscape,
    isCenter: m === Be.center,
    isCenterContain: m === Be.centerContain,
    isCenterCover: m === Be.centerCover,
    isContain: m === Be.contain,
    isCover: m === Be.cover,
    isNone: m === Be.none,
    isError: a === Ae.error,
    isNotImageFit: m === void 0
  });
  return h.createElement(
    "div",
    { className: P.root, style: { width: d, height: f }, ref: r },
    h.createElement("img", w({}, l, { onLoad: i, onError: s, key: Kv + e.src || "", className: P.image, ref: Ht(n, t), src: c, alt: u, role: y, loading: S }))
  );
});
Nl.displayName = "ImageBase";
function Qv(e, t, r, n) {
  var o = h.useRef(t), a = h.useRef();
  return (a === void 0 || o.current === Ae.notLoaded && t === Ae.loaded) && (a.current = Jv(e, t, r, n)), o.current = t, a.current;
}
function Jv(e, t, r, n) {
  var o = e.imageFit, a = e.width, i = e.height;
  if (e.coverStyle !== void 0)
    return e.coverStyle;
  if (t === Ae.loaded && (o === Be.cover || o === Be.contain || o === Be.centerContain || o === Be.centerCover) && r.current && n.current) {
    var s = void 0;
    typeof a == "number" && typeof i == "number" && o !== Be.centerContain && o !== Be.centerCover ? s = a / i : s = n.current.clientWidth / n.current.clientHeight;
    var l = r.current.naturalWidth / r.current.naturalHeight;
    if (l > s)
      return Nr.landscape;
  }
  return Nr.portrait;
}
var Zv = {
  root: "ms-Image",
  rootMaximizeFrame: "ms-Image--maximizeFrame",
  image: "ms-Image-image",
  imageCenter: "ms-Image-image--center",
  imageContain: "ms-Image-image--contain",
  imageCover: "ms-Image-image--cover",
  imageCenterContain: "ms-Image-image--centerContain",
  imageCenterCover: "ms-Image-image--centerCover",
  imageNone: "ms-Image-image--none",
  imageLandscape: "ms-Image-image--landscape",
  imagePortrait: "ms-Image-image--portrait"
}, ep = function(e) {
  var t = e.className, r = e.width, n = e.height, o = e.maximizeFrame, a = e.isLoaded, i = e.shouldFadeIn, s = e.shouldStartVisible, l = e.isLandscape, c = e.isCenter, u = e.isContain, d = e.isCover, f = e.isCenterContain, p = e.isCenterCover, g = e.isNone, b = e.isError, x = e.isNotImageFit, m = e.theme, y = hr(Zv, m), C = {
    position: "absolute",
    left: "50% /* @noflip */",
    top: "50%",
    transform: "translate(-50%,-50%)"
    // @todo test RTL renders transform: translate(50%,-50%);
  }, E = ce(), k = E !== void 0 && // eslint-disable-next-line @fluentui/max-len
  // cast needed as vendor prefixed `msMaxTouchPoints` api is no longer part of TS lib declaration - introduced with TS 4.4
  E.navigator.msMaxTouchPoints === void 0, S = u && l || d && !l ? { width: "100%", height: "auto" } : { width: "auto", height: "100%" };
  return {
    root: [
      y.root,
      m.fonts.medium,
      {
        overflow: "hidden"
      },
      o && [
        y.rootMaximizeFrame,
        {
          height: "100%",
          width: "100%"
        }
      ],
      a && i && !s && Dt.fadeIn400,
      (c || u || d || f || p) && {
        position: "relative"
      },
      t
    ],
    image: [
      y.image,
      {
        display: "block",
        opacity: 0
      },
      a && [
        "is-loaded",
        {
          opacity: 1
        }
      ],
      c && [y.imageCenter, C],
      u && [
        y.imageContain,
        k && {
          width: "100%",
          height: "100%",
          objectFit: "contain"
        },
        !k && S,
        !k && C
      ],
      d && [
        y.imageCover,
        k && {
          width: "100%",
          height: "100%",
          objectFit: "cover"
        },
        !k && S,
        !k && C
      ],
      f && [
        y.imageCenterContain,
        l && {
          maxWidth: "100%"
        },
        !l && {
          maxHeight: "100%"
        },
        C
      ],
      p && [
        y.imageCenterCover,
        l && {
          maxHeight: "100%"
        },
        !l && {
          maxWidth: "100%"
        },
        C
      ],
      g && [
        y.imageNone,
        {
          width: "auto",
          height: "auto"
        }
      ],
      x && [
        !!r && !n && {
          height: "auto",
          width: "100%"
        },
        !r && !!n && {
          height: "100%",
          width: "auto"
        },
        !!r && !!n && {
          height: "100%",
          width: "100%"
        }
      ],
      l && y.imageLandscape,
      !l && y.imagePortrait,
      !a && "is-notLoaded",
      i && "is-fadeIn",
      b && "is-error"
    ]
  };
}, Pl = qe(Nl, ep, void 0, {
  scope: "Image"
}, !0);
Pl.displayName = "Image";
var xr = Ku({
  root: {
    display: "inline-block"
  },
  placeholder: [
    "ms-Icon-placeHolder",
    {
      width: "1em"
    }
  ],
  image: [
    "ms-Icon-imageContainer",
    {
      overflow: "hidden"
    }
  ]
}), tp = "ms-Icon", rp = function(e) {
  var t = e.className, r = e.iconClassName, n = e.isPlaceholder, o = e.isImage, a = e.styles;
  return {
    root: [
      n && xr.placeholder,
      xr.root,
      o && xr.image,
      r,
      t,
      a && a.root,
      // eslint-disable-next-line deprecation/deprecation
      a && a.imageContainer
    ]
  };
}, Il = Mn(
  function(e) {
    var t = hf(e) || {
      subset: {},
      code: void 0
    }, r = t.code, n = t.subset;
    return r ? {
      children: r,
      iconClassName: n.className,
      fontFamily: n.fontFace && n.fontFace.fontFamily,
      mergeImageProps: n.mergeImageProps
    } : null;
  },
  void 0,
  !0
  /*ignoreNullOrUndefinedResult */
), np = function(e) {
  var t = e.iconName, r = e.className, n = e.style, o = n === void 0 ? {} : n, a = Il(t) || {}, i = a.iconClassName, s = a.children, l = a.fontFamily, c = a.mergeImageProps, u = Je(e, Se), d = e["aria-label"] || e.title, f = e["aria-label"] || e["aria-labelledby"] || e.title ? {
    role: c ? void 0 : "img"
  } : {
    "aria-hidden": !0
  }, p = s;
  return c && typeof s == "object" && typeof s.props == "object" && d && (p = h.cloneElement(s, { alt: d })), h.createElement("i", w({ "data-icon-name": t }, f, u, c ? {
    title: void 0,
    "aria-label": void 0
  } : {}, {
    className: ha(tp, xr.root, i, !t && xr.placeholder, r),
    // Apply the font family this way to ensure it doesn't get overridden by Fabric Core ms-Icon styles
    // https://github.com/microsoft/fluentui/issues/10449
    style: w({ fontFamily: l }, o)
  }), p);
};
Mn(function(e, t, r) {
  return np({ iconName: e, className: t, "aria-label": r });
});
var op = Ue({
  // Icon is used a lot by other components.
  // It's likely to see expected cases which pass different className to the Icon.
  // Therefore setting a larger cache size.
  cacheSize: 100
}), ap = (
  /** @class */
  function(e) {
    dt(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n._onImageLoadingStateChange = function(o) {
        n.props.imageProps && n.props.imageProps.onLoadingStateChange && n.props.imageProps.onLoadingStateChange(o), o === Ae.error && n.setState({ imageLoadError: !0 });
      }, n.state = {
        imageLoadError: !1
      }, n;
    }
    return t.prototype.render = function() {
      var r = this.props, n = r.children, o = r.className, a = r.styles, i = r.iconName, s = r.imageErrorAs, l = r.theme, c = typeof i == "string" && i.length === 0, u = (
        // eslint-disable-next-line deprecation/deprecation
        !!this.props.imageProps || this.props.iconType === En.image || this.props.iconType === En.Image
      ), d = Il(i) || {}, f = d.iconClassName, p = d.children, g = d.mergeImageProps, b = op(a, {
        theme: l,
        className: o,
        iconClassName: f,
        isImage: u,
        isPlaceholder: c
      }), x = u ? "span" : "i", m = Je(this.props, Se, [
        "aria-label"
      ]), y = this.state.imageLoadError, C = w(w({}, this.props.imageProps), { onLoadingStateChange: this._onImageLoadingStateChange }), E = y && s || Pl, k = this.props["aria-label"] || this.props.ariaLabel, S = C.alt || k || this.props.title, _ = !!(S || this.props["aria-labelledby"] || C["aria-label"] || C["aria-labelledby"]), P = _ ? {
        role: u || g ? void 0 : "img",
        "aria-label": u || g ? void 0 : S
      } : {
        "aria-hidden": !0
      }, D = p;
      return g && p && typeof p == "object" && S && (D = h.cloneElement(p, {
        alt: S
      })), h.createElement(x, w({ "data-icon-name": i }, P, m, g ? {
        title: void 0,
        "aria-label": void 0
      } : {}, { className: b.root }), u ? h.createElement(E, w({}, C)) : n || D);
    }, t;
  }(h.Component)
), zo = qe(ap, rp, void 0, {
  scope: "Icon"
}, !0);
zo.displayName = "Icon";
var ip = Ue({
  // Label is used a lot by other components.
  // It's likely to see expected cases which pass different className to the Label.
  // Therefore setting a larger cache size.
  cacheSize: 100
}), sp = (
  /** @class */
  function(e) {
    dt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.render = function() {
      var r = this.props, n = r.as, o = n === void 0 ? "label" : n, a = r.children, i = r.className, s = r.disabled, l = r.styles, c = r.required, u = r.theme, d = ip(l, {
        className: i,
        disabled: s,
        required: c,
        theme: u
      });
      return h.createElement(o, w({}, Je(this.props, fr), { className: d.root }), a);
    }, t;
  }(h.Component)
), lp = function(e) {
  var t, r = e.theme, n = e.className, o = e.disabled, a = e.required, i = r.semanticColors, s = le.semibold, l = i.bodyText, c = i.disabledBodyText, u = i.errorText;
  return {
    root: [
      "ms-Label",
      r.fonts.medium,
      {
        fontWeight: s,
        color: l,
        boxSizing: "border-box",
        boxShadow: "none",
        margin: 0,
        display: "block",
        padding: "5px 0",
        wordWrap: "break-word",
        overflowWrap: "break-word"
      },
      o && {
        color: c,
        selectors: (t = {}, t[ne] = w({ color: "GrayText" }, At()), t)
      },
      a && {
        selectors: {
          "::after": {
            content: "' *'",
            color: u,
            paddingRight: 12
          }
        }
      },
      n
    ]
  };
}, cr = qe(sp, lp, void 0, {
  scope: "Label"
}), wn = 100, cp = 359, Mt = 100, gt = 255, je = 100, Sn = 3, Cr = 6, up = 1, dp = 3, fp = /^[\da-f]{0,6}$/i, hp = /^\d{0,3}$/;
function vp(e, t, r) {
  t *= (r < 50 ? r : 100 - r) / 100;
  var n = r + t;
  return {
    h: e,
    s: n === 0 ? 0 : 2 * t / n * 100,
    v: n
  };
}
function Wn(e, t, r) {
  t = t / 100, r = r / 100;
  var n = [], o = r * t, a = e / 60, i = o * (1 - Math.abs(a % 2 - 1)), s = r - o;
  switch (Math.floor(a)) {
    case 0:
      n = [o, i, 0];
      break;
    case 1:
      n = [i, o, 0];
      break;
    case 2:
      n = [0, o, i];
      break;
    case 3:
      n = [0, i, o];
      break;
    case 4:
      n = [i, 0, o];
      break;
    case 5:
      n = [o, 0, i];
      break;
  }
  return {
    r: Math.round(gt * (n[0] + s)),
    g: Math.round(gt * (n[1] + s)),
    b: Math.round(gt * (n[2] + s))
  };
}
function pp(e, t, r) {
  var n = vp(e, t, r);
  return Wn(n.h, n.s, n.v);
}
function gp(e, t) {
  if (e) {
    var r = t != null ? t : We(), n = Ol(e) || yp(e) || _p(e) || bp(e);
    return n || mp(e, r);
  }
}
function mp(e, t) {
  var r;
  if (typeof t != "undefined") {
    var n = t.createElement("div");
    n.style.backgroundColor = e, n.style.position = "absolute", n.style.top = "-9999px", n.style.left = "-9999px", n.style.height = "1px", n.style.width = "1px", t.body.appendChild(n);
    var o = (r = t.defaultView) === null || r === void 0 ? void 0 : r.getComputedStyle(n), a = o && o.backgroundColor;
    if (t.body.removeChild(n), a === "rgba(0, 0, 0, 0)" || a === "transparent") {
      switch (e.trim()) {
        case "transparent":
        case "#0000":
        case "#00000000":
          return { r: 0, g: 0, b: 0, a: 0 };
      }
      return;
    }
    return Ol(a);
  }
}
function Ol(e) {
  if (e) {
    var t = e.match(/^rgb(a?)\(([\d., ]+)\)$/);
    if (t) {
      var r = !!t[1], n = r ? 4 : 3, o = t[2].split(/ *, */).map(Number);
      if (o.length === n)
        return {
          r: o[0],
          g: o[1],
          b: o[2],
          a: r ? o[3] * 100 : je
        };
    }
  }
}
function bp(e) {
  var t = e.match(/^hsl(a?)\(([\d., ]+)\)$/);
  if (t) {
    var r = !!t[1], n = r ? 4 : 3, o = t[2].split(/ *, */).map(Number);
    if (o.length === n) {
      var a = pp(o[0], o[1], o[2]);
      return a.a = r ? o[3] * 100 : je, a;
    }
  }
}
function yp(e) {
  if (e[0] === "#" && e.length === 7 && /^#[\da-fA-F]{6}$/.test(e))
    return {
      r: parseInt(e.slice(1, 3), 16),
      g: parseInt(e.slice(3, 5), 16),
      b: parseInt(e.slice(5, 7), 16),
      a: je
    };
}
function _p(e) {
  if (e[0] === "#" && e.length === 4 && /^#[\da-fA-F]{3}$/.test(e))
    return {
      r: parseInt(e[1] + e[1], 16),
      g: parseInt(e[2] + e[2], 16),
      b: parseInt(e[3] + e[3], 16),
      a: je
    };
}
function ze(e, t, r) {
  return r === void 0 && (r = 0), e < r ? r : e > t ? t : e;
}
function Un(e, t, r) {
  return [go(e), go(t), go(r)].join("");
}
function go(e) {
  e = ze(e, gt);
  var t = e.toString(16);
  return t.length === 1 ? "0" + t : t;
}
function xp(e, t, r) {
  var n = Wn(e, t, r), o = n.r, a = n.g, i = n.b;
  return Un(o, a, i);
}
function Cp(e, t, r) {
  var n = NaN, o = Math.max(e, t, r), a = Math.min(e, t, r), i = o - a;
  i === 0 ? n = 0 : e === o ? n = (t - r) / i % 6 : t === o ? n = (r - e) / i + 2 : r === o && (n = (e - t) / i + 4), n = Math.round(n * 60), n < 0 && (n += 360);
  var s = Math.round((o === 0 ? 0 : i / o) * 100), l = Math.round(o / gt * 100);
  return { h: n, s, v: l };
}
function Ar(e, t, r, n, o) {
  return n === je || typeof n != "number" ? "#".concat(o) : "rgba(".concat(e, ", ").concat(t, ", ").concat(r, ", ").concat(n / je, ")");
}
function Wo(e) {
  var t = e.a, r = t === void 0 ? je : t, n = e.b, o = e.g, a = e.r, i = Cp(a, o, n), s = i.h, l = i.s, c = i.v, u = Un(a, o, n), d = Ar(a, o, n, r, u), f = je - r;
  return { a: r, b: n, g: o, h: s, hex: u, r: a, s: l, str: d, v: c, t: f };
}
function an(e, t) {
  var r = t != null ? t : We(), n = gp(e, r);
  if (n)
    return w(w({}, Wo(n)), { str: e });
}
function Ep(e) {
  return "#".concat(xp(e.h, wn, Mt));
}
function Al(e, t, r) {
  var n = Wn(e.h, t, r), o = n.r, a = n.g, i = n.b, s = Un(o, a, i);
  return w(w({}, e), { s: t, v: r, r: o, g: a, b: i, hex: s, str: Ar(o, a, i, e.a, s) });
}
function wp(e, t) {
  var r = Wn(t, e.s, e.v), n = r.r, o = r.g, a = r.b, i = Un(n, o, a);
  return w(w({}, e), { h: t, r: n, g: o, b: a, hex: i, str: Ar(n, o, a, e.a, i) });
}
function ji(e, t) {
  return w(w({}, e), { a: t, t: je - t, str: Ar(e.r, e.g, e.b, t, e.hex) });
}
function Sp(e) {
  return {
    r: ze(e.r, gt),
    g: ze(e.g, gt),
    b: ze(e.b, gt),
    a: typeof e.a == "number" ? ze(e.a, je) : e.a
  };
}
function kp(e) {
  return !e || e.length < Sn ? "ffffff" : e.length >= Cr ? e.substring(0, Cr) : e.substring(0, Sn);
}
function mo(e, t) {
  var r = je - t;
  return w(w({}, e), { t, a: r, str: Ar(e.r, e.g, e.b, r, e.hex) });
}
var Tp = Ue(), Rp = "", bt = "TextField", Np = "RedEye", Pp = "Hide", Ip = (
  /** @class */
  function(e) {
    dt(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      n._textElement = h.createRef(), n._onFocus = function(i) {
        n.props.onFocus && n.props.onFocus(i), n.setState({ isFocused: !0 }, function() {
          n.props.validateOnFocusIn && n._validate(n.value);
        });
      }, n._onBlur = function(i) {
        n.props.onBlur && n.props.onBlur(i), n.setState({ isFocused: !1 }, function() {
          n.props.validateOnFocusOut && n._validate(n.value);
        });
      }, n._onRenderLabel = function(i) {
        var s = i.label, l = i.required, c = n._classNames.subComponentStyles ? n._classNames.subComponentStyles.label : void 0;
        return s ? h.createElement(cr, { required: l, htmlFor: n._id, styles: c, disabled: i.disabled, id: n._labelId }, i.label) : null;
      }, n._onRenderDescription = function(i) {
        return i.description ? h.createElement("span", { className: n._classNames.description }, i.description) : null;
      }, n._onRevealButtonClick = function(i) {
        n.setState(function(s) {
          return { isRevealingPassword: !s.isRevealingPassword };
        });
      }, n._onInputChange = function(i) {
        var s, l, c = i.target, u = c.value, d = bo(n.props, n.state) || "";
        if (u === void 0 || u === n._lastChangeValue || u === d) {
          n._lastChangeValue = void 0;
          return;
        }
        n._lastChangeValue = u, (l = (s = n.props).onChange) === null || l === void 0 || l.call(s, i, u), n._isControlled || n.setState({ uncontrolledValue: u });
      }, Ir(n), n._async = new ua(n), process.env.NODE_ENV !== "production" && Ys(bt, r, {
        errorMessage: "onGetErrorMessage"
      }), n._fallbackId = Ct(bt), n._descriptionId = Ct(bt + "Description"), n._labelId = Ct(bt + "Label"), n._prefixId = Ct(bt + "Prefix"), n._suffixId = Ct(bt + "Suffix"), n._warnControlledUsage();
      var o = r.defaultValue, a = o === void 0 ? Rp : o;
      return typeof a == "number" && (a = String(a)), n.state = {
        uncontrolledValue: n._isControlled ? void 0 : a,
        isFocused: !1,
        errorMessage: ""
      }, n._delayedValidate = n._async.debounce(n._validate, n.props.deferredValidationTime), n._lastValidation = 0, n;
    }
    return Object.defineProperty(t.prototype, "value", {
      /**
       * Gets the current value of the text field.
       */
      get: function() {
        return bo(this.props, this.state);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentDidMount = function() {
      this._adjustInputHeight(), this.props.validateOnLoad && this._validate(this.value);
    }, t.prototype.componentWillUnmount = function() {
      this._async.dispose();
    }, t.prototype.getSnapshotBeforeUpdate = function(r, n) {
      return {
        selection: [this.selectionStart, this.selectionEnd]
      };
    }, t.prototype.componentDidUpdate = function(r, n, o) {
      var a = this.props, i = (o || {}).selection, s = i === void 0 ? [null, null] : i, l = s[0], c = s[1];
      !!r.multiline != !!a.multiline && n.isFocused && (this.focus(), l !== null && c !== null && l >= 0 && c >= 0 && this.setSelectionRange(l, c)), r.value !== a.value && (this._lastChangeValue = void 0);
      var u = bo(r, n), d = this.value;
      u !== d && (this._warnControlledUsage(r), this.state.errorMessage && !a.errorMessage && this.setState({ errorMessage: "" }), this._adjustInputHeight(), Fi(a) && this._delayedValidate(d));
    }, t.prototype.render = function() {
      var r = this.props, n = r.borderless, o = r.className, a = r.disabled, i = r.invalid, s = r.iconProps, l = r.inputClassName, c = r.label, u = r.multiline, d = r.required, f = r.underlined, p = r.prefix, g = r.resizable, b = r.suffix, x = r.theme, m = r.styles, y = r.autoAdjustHeight, C = r.canRevealPassword, E = r.revealPasswordAriaLabel, k = r.type, S = r.onRenderPrefix, _ = S === void 0 ? this._onRenderPrefix : S, P = r.onRenderSuffix, D = P === void 0 ? this._onRenderSuffix : P, z = r.onRenderLabel, q = z === void 0 ? this._onRenderLabel : z, I = r.onRenderDescription, R = I === void 0 ? this._onRenderDescription : I, L = this.state, M = L.isFocused, $ = L.isRevealingPassword, G = this._errorMessage, be = typeof i == "boolean" ? i : !!G, Y = !!C && k === "password" && Op(), Q = this._classNames = Tp(m, {
        theme: x,
        className: o,
        disabled: a,
        focused: M,
        required: d,
        multiline: u,
        hasLabel: !!c,
        hasErrorMessage: be,
        borderless: n,
        resizable: g,
        hasIcon: !!s,
        underlined: f,
        inputClassName: l,
        autoAdjustHeight: y,
        hasRevealButton: Y
      });
      return (
        // eslint-disable-next-line deprecation/deprecation
        h.createElement(
          "div",
          { ref: this.props.elementRef, className: Q.root },
          h.createElement(
            "div",
            { className: Q.wrapper },
            q(this.props, this._onRenderLabel),
            h.createElement(
              "div",
              { className: Q.fieldGroup },
              (p !== void 0 || this.props.onRenderPrefix) && h.createElement("div", { className: Q.prefix, id: this._prefixId }, _(this.props, this._onRenderPrefix)),
              u ? this._renderTextArea() : this._renderInput(),
              s && h.createElement(zo, w({ className: Q.icon }, s)),
              Y && // Explicitly set type="button" since the default button type within a form is "submit"
              h.createElement(
                "button",
                { "aria-label": E, className: Q.revealButton, onClick: this._onRevealButtonClick, "aria-pressed": !!$, type: "button" },
                h.createElement(
                  "span",
                  { className: Q.revealSpan },
                  h.createElement(zo, { className: Q.revealIcon, iconName: $ ? Pp : Np })
                )
              ),
              (b !== void 0 || this.props.onRenderSuffix) && h.createElement("div", { className: Q.suffix, id: this._suffixId }, D(this.props, this._onRenderSuffix))
            )
          ),
          this._isDescriptionAvailable && h.createElement(
            "span",
            { id: this._descriptionId },
            R(this.props, this._onRenderDescription),
            G && h.createElement(
              "div",
              { role: "alert" },
              h.createElement(yd, null, this._renderErrorMessage())
            )
          )
        )
      );
    }, t.prototype.focus = function() {
      this._textElement.current && this._textElement.current.focus();
    }, t.prototype.blur = function() {
      this._textElement.current && this._textElement.current.blur();
    }, t.prototype.select = function() {
      this._textElement.current && this._textElement.current.select();
    }, t.prototype.setSelectionStart = function(r) {
      this._textElement.current && (this._textElement.current.selectionStart = r);
    }, t.prototype.setSelectionEnd = function(r) {
      this._textElement.current && (this._textElement.current.selectionEnd = r);
    }, Object.defineProperty(t.prototype, "selectionStart", {
      /**
       * Gets the selection start of the text field
       */
      get: function() {
        return this._textElement.current ? this._textElement.current.selectionStart : -1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "selectionEnd", {
      /**
       * Gets the selection end of the text field
       */
      get: function() {
        return this._textElement.current ? this._textElement.current.selectionEnd : -1;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setSelectionRange = function(r, n) {
      this._textElement.current && this._textElement.current.setSelectionRange(r, n);
    }, t.prototype._warnControlledUsage = function(r) {
      sl({
        componentId: this._id,
        componentName: bt,
        props: this.props,
        oldProps: r,
        valueProp: "value",
        defaultValueProp: "defaultValue",
        onChangeProp: "onChange",
        readOnlyProp: "readOnly"
      }), this.props.value === null && !this._hasWarnedNullValue && (this._hasWarnedNullValue = !0, ot("Warning: 'value' prop on '".concat(bt, "' should not be null. Consider using an ") + "empty string to clear the component or undefined to indicate an uncontrolled component."));
    }, Object.defineProperty(t.prototype, "_id", {
      /** Returns `props.id` if available, or a fallback if not. */
      get: function() {
        return this.props.id || this._fallbackId;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "_isControlled", {
      get: function() {
        return Fo(this.props, "value");
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._onRenderPrefix = function(r) {
      var n = r.prefix;
      return h.createElement("span", { style: { paddingBottom: "1px" } }, n);
    }, t.prototype._onRenderSuffix = function(r) {
      var n = r.suffix;
      return h.createElement("span", { style: { paddingBottom: "1px" } }, n);
    }, Object.defineProperty(t.prototype, "_errorMessage", {
      /**
       * Current error message from either `props.errorMessage` or the result of `props.onGetErrorMessage`.
       *
       * - If there is no validation error or we have not validated the input value, errorMessage is an empty string.
       * - If we have done the validation and there is validation error, errorMessage is the validation error message.
       */
      get: function() {
        var r = this.props.errorMessage, n = r === void 0 ? this.state.errorMessage : r;
        return n || "";
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._renderErrorMessage = function() {
      var r = this._errorMessage;
      return r ? typeof r == "string" ? h.createElement(
        "p",
        { className: this._classNames.errorMessage },
        h.createElement("span", { "data-automation-id": "error-message" }, r)
      ) : h.createElement("div", { className: this._classNames.errorMessage, "data-automation-id": "error-message" }, r) : null;
    }, Object.defineProperty(t.prototype, "_isDescriptionAvailable", {
      /**
       * If a custom description render function is supplied then treat description as always available.
       * Otherwise defer to the presence of description or error message text.
       */
      get: function() {
        var r = this.props;
        return !!(r.onRenderDescription || r.description || this._errorMessage);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._renderTextArea = function() {
      var r = this.props.invalid, n = r === void 0 ? !!this._errorMessage : r, o = Je(this.props, qd, ["defaultValue"]), a = this.props["aria-labelledby"] || (this.props.label ? this._labelId : void 0);
      return h.createElement("textarea", w({ id: this._id }, o, { ref: this._textElement, value: this.value || "", onInput: this._onInputChange, onChange: this._onInputChange, className: this._classNames.field, "aria-labelledby": a, "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : this.props["aria-describedby"], "aria-invalid": n, "aria-label": this.props.ariaLabel, readOnly: this.props.readOnly, onFocus: this._onFocus, onBlur: this._onBlur }));
    }, t.prototype._renderInput = function() {
      var r = this.props, n = r.ariaLabel, o = r.invalid, a = o === void 0 ? !!this._errorMessage : o, i = r.onRenderPrefix, s = r.onRenderSuffix, l = r.prefix, c = r.suffix, u = r.type, d = u === void 0 ? "text" : u, f = r.label, p = [];
      f && p.push(this._labelId), (l !== void 0 || i) && p.push(this._prefixId), (c !== void 0 || s) && p.push(this._suffixId);
      var g = w(w({ type: this.state.isRevealingPassword ? "text" : d, id: this._id }, Je(this.props, Zs, ["defaultValue", "type"])), { "aria-labelledby": this.props["aria-labelledby"] || (p.length > 0 ? p.join(" ") : void 0), ref: this._textElement, value: this.value || "", onInput: this._onInputChange, onChange: this._onInputChange, className: this._classNames.field, "aria-label": n, "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : this.props["aria-describedby"], "aria-invalid": a, onFocus: this._onFocus, onBlur: this._onBlur }), b = function(m) {
        return h.createElement("input", w({}, m));
      }, x = this.props.onRenderInput || b;
      return x(g, b);
    }, t.prototype._validate = function(r) {
      var n = this;
      if (!(this._latestValidateValue === r && Fi(this.props))) {
        this._latestValidateValue = r;
        var o = this.props.onGetErrorMessage, a = o && o(r || "");
        if (a !== void 0)
          if (typeof a == "string" || !("then" in a))
            this.setState({ errorMessage: a }), this._notifyAfterValidate(r, a);
          else {
            var i = ++this._lastValidation;
            a.then(function(s) {
              i === n._lastValidation && n.setState({ errorMessage: s }), n._notifyAfterValidate(r, s);
            });
          }
        else
          this._notifyAfterValidate(r, "");
      }
    }, t.prototype._notifyAfterValidate = function(r, n) {
      r === this.value && this.props.onNotifyValidationResult && this.props.onNotifyValidationResult(n, r);
    }, t.prototype._adjustInputHeight = function() {
      var r, n;
      if (this._textElement.current && this.props.autoAdjustHeight && this.props.multiline) {
        var o = (n = (r = this.props.scrollContainerRef) === null || r === void 0 ? void 0 : r.current) === null || n === void 0 ? void 0 : n.scrollTop, a = this._textElement.current;
        a.style.height = "", a.style.height = a.scrollHeight + "px", o && (this.props.scrollContainerRef.current.scrollTop = o);
      }
    }, t.defaultProps = {
      resizable: !0,
      deferredValidationTime: 200,
      validateOnLoad: !0
    }, t;
  }(h.Component)
);
function bo(e, t) {
  var r = e.value, n = r === void 0 ? t.uncontrolledValue : r;
  return typeof n == "number" ? String(n) : n;
}
function Fi(e) {
  return !(e.validateOnFocusIn || e.validateOnFocusOut);
}
var Kr;
function Op() {
  if (typeof Kr != "boolean") {
    var e = ce();
    if (e != null && e.navigator) {
      var t = /Edg/.test(e.navigator.userAgent || "");
      Kr = !(uf() || t);
    } else
      Kr = !0;
  }
  return Kr;
}
var Ap = {
  root: "ms-TextField",
  description: "ms-TextField-description",
  errorMessage: "ms-TextField-errorMessage",
  field: "ms-TextField-field",
  fieldGroup: "ms-TextField-fieldGroup",
  prefix: "ms-TextField-prefix",
  suffix: "ms-TextField-suffix",
  wrapper: "ms-TextField-wrapper",
  revealButton: "ms-TextField-reveal",
  multiline: "ms-TextField--multiline",
  borderless: "ms-TextField--borderless",
  underlined: "ms-TextField--underlined",
  unresizable: "ms-TextField--unresizable",
  required: "is-required",
  disabled: "is-disabled",
  active: "is-active"
};
function Dp(e) {
  var t = e.underlined, r = e.disabled, n = e.focused, o = e.theme, a = o.palette, i = o.fonts;
  return function() {
    var s;
    return {
      root: [
        t && r && {
          color: a.neutralTertiary
        },
        t && {
          fontSize: i.medium.fontSize,
          marginRight: 8,
          paddingLeft: 12,
          paddingRight: 0,
          lineHeight: "22px",
          height: 32
        },
        t && n && {
          selectors: (s = {}, s[ne] = {
            height: 31
            // -1px to prevent jumpiness in HC with the increased border-width to 2px
          }, s)
        }
      ]
    };
  };
}
function Lp(e) {
  var t, r, n, o, a, i, s, l, c, u, d, f, p = e.theme, g = e.className, b = e.disabled, x = e.focused, m = e.required, y = e.multiline, C = e.hasLabel, E = e.borderless, k = e.underlined, S = e.hasIcon, _ = e.resizable, P = e.hasErrorMessage, D = e.inputClassName, z = e.autoAdjustHeight, q = e.hasRevealButton, I = p.semanticColors, R = p.effects, L = p.fonts, M = hr(Ap, p), $ = {
    // Suffix/Prefix are not editable so the disabled slot perfectly fits.
    background: I.disabledBackground,
    color: b ? I.disabledText : I.inputPlaceholderText,
    display: "flex",
    alignItems: "center",
    padding: "0 10px",
    lineHeight: 1,
    whiteSpace: "nowrap",
    flexShrink: 0,
    selectors: (t = {}, t[ne] = {
      background: "Window",
      color: b ? "GrayText" : "WindowText"
    }, t)
  }, G = [
    {
      color: I.inputPlaceholderText,
      opacity: 1,
      selectors: (r = {}, r[ne] = {
        color: "GrayText"
      }, r)
    }
  ], be = {
    color: I.disabledText,
    selectors: (n = {}, n[ne] = {
      color: "GrayText"
    }, n)
  };
  return {
    root: [
      M.root,
      L.medium,
      m && M.required,
      b && M.disabled,
      x && M.active,
      y && M.multiline,
      E && M.borderless,
      k && M.underlined,
      ho,
      {
        position: "relative"
      },
      g
    ],
    wrapper: [
      M.wrapper,
      k && [
        {
          display: "flex",
          borderBottom: "1px solid ".concat(P ? I.errorText : I.inputBorder),
          width: "100%"
        },
        b && {
          borderBottomColor: I.disabledBackground,
          selectors: (o = {}, o[ne] = w({ borderColor: "GrayText" }, At()), o)
        },
        !b && {
          selectors: {
            ":hover": {
              borderBottomColor: P ? I.errorText : I.inputBorderHovered,
              selectors: (a = {}, a[ne] = w({ borderBottomColor: "Highlight" }, At()), a)
            }
          }
        },
        x && [
          {
            position: "relative"
          },
          Ri(P ? I.errorText : I.inputFocusBorderAlt, 0, "borderBottom")
        ]
      ]
    ],
    fieldGroup: [
      M.fieldGroup,
      ho,
      {
        border: "1px solid ".concat(I.inputBorder),
        borderRadius: R.roundedCorner2,
        background: I.inputBackground,
        cursor: "text",
        height: 32,
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        position: "relative"
      },
      y && {
        minHeight: "60px",
        height: "auto",
        display: "flex"
      },
      !x && !b && {
        selectors: {
          ":hover": {
            borderColor: I.inputBorderHovered,
            selectors: (i = {}, i[ne] = w({ borderColor: "Highlight" }, At()), i)
          }
        }
      },
      x && !k && Ri(P ? I.errorText : I.inputFocusBorderAlt, R.roundedCorner2),
      b && {
        borderColor: I.disabledBackground,
        selectors: (s = {}, s[ne] = w({ borderColor: "GrayText" }, At()), s),
        cursor: "default"
      },
      E && {
        border: "none"
      },
      E && x && {
        border: "none",
        selectors: {
          ":after": {
            border: "none"
          }
        }
      },
      k && {
        flex: "1 1 0px",
        border: "none",
        textAlign: "left"
      },
      k && b && {
        backgroundColor: "transparent"
      },
      P && !k && {
        borderColor: I.errorText,
        selectors: {
          "&:hover": {
            borderColor: I.errorText
          }
        }
      },
      !C && m && {
        selectors: (l = {
          ":before": {
            content: "'*'",
            color: I.errorText,
            position: "absolute",
            top: -5,
            right: -10
          }
        }, l[ne] = {
          selectors: {
            ":before": {
              color: "WindowText",
              right: -14
              // moving the * 4 pixel to right to alleviate border clipping in HC mode.
            }
          }
        }, l)
      }
    ],
    field: [
      L.medium,
      M.field,
      ho,
      {
        borderRadius: 0,
        border: "none",
        background: "none",
        backgroundColor: "transparent",
        color: I.inputText,
        padding: "0 8px",
        width: "100%",
        minWidth: 0,
        textOverflow: "ellipsis",
        outline: 0,
        selectors: (c = {
          "&:active, &:focus, &:hover": { outline: 0 },
          "::-ms-clear": {
            display: "none"
          }
        }, c[ne] = {
          background: "Window",
          color: b ? "GrayText" : "WindowText"
        }, c)
      },
      Ii(G),
      y && !_ && [
        M.unresizable,
        {
          resize: "none"
        }
      ],
      y && {
        minHeight: "inherit",
        lineHeight: 17,
        flexGrow: 1,
        paddingTop: 6,
        paddingBottom: 6,
        overflow: "auto",
        width: "100%"
      },
      y && z && {
        overflow: "hidden"
      },
      S && !q && {
        paddingRight: 24
      },
      y && S && {
        paddingRight: 40
      },
      b && [
        {
          backgroundColor: I.disabledBackground,
          color: I.disabledText,
          borderColor: I.disabledBackground
        },
        Ii(be)
      ],
      k && {
        textAlign: "left"
      },
      x && !E && {
        selectors: (u = {}, u[ne] = {
          paddingLeft: 11,
          paddingRight: 11
        }, u)
      },
      x && y && !E && {
        selectors: (d = {}, d[ne] = {
          paddingTop: 4
          // take into consideration the 2px increased border-width (not when borderless).
        }, d)
      },
      D
    ],
    icon: [
      y && {
        paddingRight: 24,
        alignItems: "flex-end"
      },
      {
        pointerEvents: "none",
        position: "absolute",
        bottom: 6,
        right: 8,
        top: "auto",
        fontSize: gn.medium,
        lineHeight: 18
      },
      b && {
        color: I.disabledText
      }
    ],
    description: [
      M.description,
      {
        color: I.bodySubtext,
        fontSize: L.xSmall.fontSize
      }
    ],
    errorMessage: [
      M.errorMessage,
      Dt.slideDownIn20,
      L.small,
      {
        color: I.errorText,
        margin: 0,
        paddingTop: 5,
        display: "flex",
        alignItems: "center"
      }
    ],
    prefix: [M.prefix, $],
    suffix: [M.suffix, $],
    revealButton: [
      M.revealButton,
      "ms-Button",
      "ms-Button--icon",
      dl(p, { inset: 1 }),
      {
        height: 30,
        width: 32,
        border: "none",
        padding: "0px 4px",
        backgroundColor: "transparent",
        color: I.link,
        selectors: {
          ":hover": {
            outline: 0,
            color: I.primaryButtonBackgroundHovered,
            backgroundColor: I.buttonBackgroundHovered,
            selectors: (f = {}, f[ne] = {
              borderColor: "Highlight",
              color: "Highlight"
            }, f)
          },
          ":focus": { outline: 0 }
        }
      },
      S && {
        marginRight: 28
      }
    ],
    revealSpan: {
      display: "flex",
      height: "100%",
      alignItems: "center"
    },
    revealIcon: {
      margin: "0px 4px",
      pointerEvents: "none",
      bottom: 6,
      right: 8,
      top: "auto",
      fontSize: gn.medium,
      lineHeight: 18
    },
    subComponentStyles: {
      label: Dp(e)
    }
  };
}
var Bp = qe(Ip, Lp, void 0, {
  scope: "TextField"
}), Mp = Ue(), sn = (
  /** @class */
  function(e) {
    dt(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n._disposables = [], n._root = h.createRef(), n._isAdjustingSaturation = !0, n._descriptionId = Ct("ColorRectangle-description"), n._onKeyDown = function(o) {
        var a = n.state.color, i = a.s, s = a.v, l = o.shiftKey ? 10 : 1;
        switch (o.which) {
          case me.up: {
            n._isAdjustingSaturation = !1, s += l;
            break;
          }
          case me.down: {
            n._isAdjustingSaturation = !1, s -= l;
            break;
          }
          case me.left: {
            n._isAdjustingSaturation = !0, i -= l;
            break;
          }
          case me.right: {
            n._isAdjustingSaturation = !0, i += l;
            break;
          }
          default:
            return;
        }
        n._updateColor(o, Al(a, ze(i, wn), ze(s, Mt)));
      }, n._onMouseDown = function(o) {
        var a = Qh(n.context);
        n._disposables.push(lt(a, "mousemove", n._onMouseMove, !0), lt(a, "mouseup", n._disposeListeners, !0)), n._onMouseMove(o);
      }, n._onMouseMove = function(o) {
        if (n._root.current) {
          var a = Hi(o, n.state.color, n._root.current);
          a && n._updateColor(o, a);
        }
      }, n._onTouchStart = function(o) {
        n._root.current && o.stopPropagation();
      }, n._onTouchMove = function(o) {
        if (n._root.current) {
          var a = Hi(o, n.state.color, n._root.current);
          a && n._updateColor(o, a), o.preventDefault(), o.stopPropagation();
        }
      }, n._disposeListeners = function() {
        n._disposables.forEach(function(o) {
          return o();
        }), n._disposables = [];
      }, Ir(n), n.state = { color: r.color }, n;
    }
    return Object.defineProperty(t.prototype, "color", {
      get: function() {
        return this.state.color;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentDidUpdate = function(r, n) {
      r !== this.props && this.props.color && this.setState({ color: this.props.color });
    }, t.prototype.componentDidMount = function() {
      this._root.current && (this._root.current.addEventListener("touchstart", this._onTouchStart, { capture: !0, passive: !1 }), this._root.current.addEventListener("touchmove", this._onTouchMove, { capture: !0, passive: !1 }));
    }, t.prototype.componentWillUnmount = function() {
      this._root.current && (this._root.current.removeEventListener("touchstart", this._onTouchStart), this._root.current.removeEventListener("touchmove", this._onTouchMove)), this._disposeListeners();
    }, t.prototype.render = function() {
      var r = this.props, n = r.minSize, o = r.theme, a = r.className, i = r.styles, s = r.ariaValueFormat, l = r.ariaLabel, c = r.ariaDescription, u = this.state.color, d = Mp(i, {
        theme: o,
        className: a,
        minSize: n
      }), f = s.replace("{0}", String(u.s)).replace("{1}", String(u.v));
      return h.createElement(
        "div",
        { ref: this._root, tabIndex: 0, className: d.root, style: { backgroundColor: Ep(u) }, onMouseDown: this._onMouseDown, onKeyDown: this._onKeyDown, role: "slider", "aria-valuetext": f, "aria-valuenow": this._isAdjustingSaturation ? u.s : u.v, "aria-valuemin": 0, "aria-valuemax": Mt, "aria-label": l, "aria-describedby": this._descriptionId, "data-is-focusable": !0 },
        h.createElement("div", { className: d.description, id: this._descriptionId }, c),
        h.createElement("div", { className: d.light }),
        h.createElement("div", { className: d.dark }),
        h.createElement("div", { className: d.thumb, style: { left: u.s + "%", top: Mt - u.v + "%", backgroundColor: u.str } })
      );
    }, t.prototype._updateColor = function(r, n) {
      var o = this.props.onChange, a = this.state.color;
      n.s === a.s && n.v === a.v || (o && o(r, n), r.defaultPrevented || (this.setState({ color: n }), r.preventDefault()));
    }, t.contextType = ga, t.defaultProps = {
      minSize: 220,
      ariaLabel: "Saturation and brightness",
      ariaValueFormat: "Saturation {0} brightness {1}",
      ariaDescription: "Use left and right arrow keys to set saturation. Use up and down arrow keys to set brightness."
    }, t;
  }(h.Component)
);
function Hi(e, t, r) {
  var n = r.getBoundingClientRect(), o = void 0, a = e;
  if (a.touches) {
    var i = a.touches[a.touches.length - 1];
    i.clientX !== void 0 && i.clientY !== void 0 && (o = {
      clientX: i.clientX,
      clientY: i.clientY
    });
  }
  if (!o) {
    var s = e;
    s.clientX !== void 0 && s.clientY !== void 0 && (o = {
      clientX: s.clientX,
      clientY: s.clientY
    });
  }
  if (o) {
    var l = (o.clientX - n.left) / n.width, c = (o.clientY - n.top) / n.height;
    return Al(t, ze(Math.round(l * wn), wn), ze(Math.round(Mt - c * Mt), Mt));
  }
}
var jp = function(e) {
  var t, r, n = e.className, o = e.theme, a = e.minSize, i = o.palette, s = o.effects;
  return {
    root: [
      "ms-ColorPicker-colorRect",
      {
        position: "relative",
        marginBottom: 8,
        border: "1px solid ".concat(i.neutralLighter),
        borderRadius: s.roundedCorner2,
        minWidth: a,
        minHeight: a,
        outline: "none",
        selectors: (t = {}, t[ne] = w({}, At()), t[".".concat(Ft, " &:focus")] = (r = {
          outline: "1px solid ".concat(i.neutralSecondary)
        }, r["".concat(ne)] = {
          outline: "2px solid CanvasText"
        }, r), t)
      },
      n
    ],
    light: [
      "ms-ColorPicker-light",
      {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        // Intentionally DO NOT flip the color picker in RTL: its orientation is not very meaningful,
        // and getting all the math and styles flipped correctly is tricky
        background: "linear-gradient(to right, white 0%, transparent 100%) /*@noflip*/"
      }
    ],
    dark: [
      "ms-ColorPicker-dark",
      {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        background: "linear-gradient(to bottom, transparent 0, #000 100%)"
      }
    ],
    thumb: [
      "ms-ColorPicker-thumb",
      {
        position: "absolute",
        width: 20,
        height: 20,
        background: "white",
        border: "1px solid ".concat(i.neutralSecondaryAlt),
        borderRadius: "50%",
        boxShadow: s.elevation8,
        transform: "translate(-50%, -50%)",
        selectors: {
          ":before": {
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            border: "2px solid ".concat(i.white),
            borderRadius: "50%",
            boxSizing: "border-box",
            content: '""'
          }
        }
      }
    ],
    description: fl
  };
}, Fp = qe(sn, jp, void 0, { scope: "ColorRectangle" }), Hp = Ue(), $p = (
  /** @class */
  function(e) {
    dt(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n._disposables = [], n._root = h.createRef(), n._onKeyDown = function(o) {
        var a = n.value, i = n._maxValue, s = o.shiftKey ? 10 : 1;
        switch (o.which) {
          case me.left: {
            a -= s;
            break;
          }
          case me.right: {
            a += s;
            break;
          }
          case me.home: {
            a = 0;
            break;
          }
          case me.end: {
            a = i;
            break;
          }
          default:
            return;
        }
        n._updateValue(o, ze(a, i));
      }, n._onMouseDown = function(o) {
        var a = ce(n);
        a && n._disposables.push(lt(a, "mousemove", n._onMouseMove, !0), lt(a, "mouseup", n._disposeListeners, !0)), n._onMouseMove(o);
      }, n._onMouseMove = function(o) {
        if (n._root.current) {
          var a = n._maxValue, i = n._root.current.getBoundingClientRect(), s = (o.clientX - i.left) / i.width, l = ze(Math.round(s * a), a);
          n._updateValue(o, l);
        }
      }, n._onTouchStart = function(o) {
        n._root.current && o.stopPropagation();
      }, n._onTouchMove = function(o) {
        if (n._root.current) {
          var a = o.touches[o.touches.length - 1];
          if (a.clientX !== void 0) {
            var i = n._maxValue, s = n._root.current.getBoundingClientRect(), l = (a.clientX - s.left) / s.width, c = ze(Math.round(l * i), i);
            n._updateValue(o, c);
          }
          o.preventDefault(), o.stopPropagation();
        }
      }, n._disposeListeners = function() {
        n._disposables.forEach(function(o) {
          return o();
        }), n._disposables = [];
      }, Ir(n), da("ColorSlider", r, {
        thumbColor: "styles.sliderThumb",
        overlayStyle: "overlayColor",
        isAlpha: "type",
        maxValue: "type",
        minValue: "type"
      }), n._type !== "hue" && !(r.overlayColor || r.overlayStyle) && ot(`ColorSlider: 'overlayColor' is required when 'type' is "alpha" or "transparency"`), n.state = {
        currentValue: r.value || 0
      }, n;
    }
    return Object.defineProperty(t.prototype, "value", {
      get: function() {
        return this.state.currentValue;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentDidUpdate = function(r, n) {
      r !== this.props && this.props.value !== void 0 && this.setState({ currentValue: this.props.value });
    }, t.prototype.componentDidMount = function() {
      this._root.current && (this._root.current.addEventListener("touchstart", this._onTouchStart, { capture: !0, passive: !1 }), this._root.current.addEventListener("touchmove", this._onTouchMove, { capture: !0, passive: !1 }));
    }, t.prototype.componentWillUnmount = function() {
      this._root.current && (this._root.current.removeEventListener("touchstart", this._onTouchStart), this._root.current.removeEventListener("touchmove", this._onTouchMove)), this._disposeListeners();
    }, t.prototype.render = function() {
      var r = this._type, n = this._maxValue, o = this.props, a = o.overlayStyle, i = o.overlayColor, s = o.theme, l = o.className, c = o.styles, u = o.ariaLabel, d = u === void 0 ? r : u, f = this.value, p = Hp(c, {
        theme: s,
        className: l,
        type: r
      }), g = 100 * f / n;
      return h.createElement(
        "div",
        { ref: this._root, className: p.root, tabIndex: 0, onKeyDown: this._onKeyDown, onMouseDown: this._onMouseDown, role: "slider", "aria-valuenow": f, "aria-valuetext": String(f), "aria-valuemin": 0, "aria-valuemax": n, "aria-label": d, "data-is-focusable": !0 },
        !!(i || a) && h.createElement("div", {
          className: p.sliderOverlay,
          // this isn't included in getStyles because it may change frequently
          style: i ? {
            background: r === "transparency" ? "linear-gradient(to right, #".concat(i, ", transparent)") : "linear-gradient(to right, transparent, #".concat(i, ")")
          } : a
        }),
        h.createElement("div", { className: p.sliderThumb, style: { left: g + "%" } })
      );
    }, Object.defineProperty(t.prototype, "_type", {
      get: function() {
        var r = this.props, n = r.isAlpha, o = r.type, a = o === void 0 ? n ? "alpha" : "hue" : o;
        return a;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "_maxValue", {
      get: function() {
        return this._type === "hue" ? cp : je;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._updateValue = function(r, n) {
      if (n !== this.value) {
        var o = this.props.onChange;
        o && o(r, n), r.defaultPrevented || (this.setState({
          currentValue: n
        }), r.preventDefault());
      }
    }, t.defaultProps = {
      value: 0
    }, t;
  }(h.Component)
), Vp = {
  background: "linear-gradient(".concat([
    "to left",
    "red 0",
    "#f09 10%",
    "#cd00ff 20%",
    "#3200ff 30%",
    "#06f 40%",
    "#00fffd 50%",
    "#0f6 60%",
    "#35ff00 70%",
    "#cdff00 80%",
    "#f90 90%",
    "red 100%"
  ].join(","), ")")
}, zp = {
  backgroundImage: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAJUlEQVQYV2N89erVfwY0ICYmxoguxjgUFKI7GsTH5m4M3w1ChQC1/Ca8i2n1WgAAAABJRU5ErkJggg==)"
}, Wp = function(e) {
  var t, r, n = e.theme, o = e.className, a = e.type, i = a === void 0 ? "hue" : a, s = e.isAlpha, l = s === void 0 ? i !== "hue" : s, c = n.palette, u = n.effects;
  return {
    root: [
      "ms-ColorPicker-slider",
      {
        position: "relative",
        height: 20,
        marginBottom: 8,
        border: "1px solid ".concat(c.neutralLight),
        borderRadius: u.roundedCorner2,
        boxSizing: "border-box",
        outline: "none",
        forcedColorAdjust: "none",
        selectors: (t = {}, t[".".concat(Ft, " &:focus")] = (r = {
          outline: "1px solid ".concat(c.neutralSecondary)
        }, r["".concat(ne)] = {
          outline: "2px solid CanvasText"
        }, r), t)
      },
      l ? zp : Vp,
      o
    ],
    sliderOverlay: [
      "ms-ColorPicker-sliderOverlay",
      {
        content: "",
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }
    ],
    sliderThumb: [
      "ms-ColorPicker-thumb",
      "is-slider",
      {
        position: "absolute",
        width: 20,
        height: 20,
        background: "white",
        border: "1px solid ".concat(c.neutralSecondaryAlt),
        borderRadius: "50%",
        boxShadow: u.elevation8,
        transform: "translate(-50%, -50%)",
        top: "50%",
        forcedColorAdjust: "auto"
      }
    ]
  };
}, $i = qe($p, Wp, void 0, { scope: "ColorSlider" }), Up = Ue(), qp = ["hex", "r", "g", "b", "a", "t"], Gp = {
  hex: "hexError",
  r: "redError",
  g: "greenError",
  b: "blueError",
  a: "alphaError",
  t: "transparencyError"
}, Yp = (
  /** @class */
  function(e) {
    dt(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      n._onSVChanged = function(c, u) {
        n._updateColor(c, u);
      }, n._onHChanged = function(c, u) {
        n._updateColor(c, wp(n.state.color, u));
      }, n._onATChanged = function(c, u) {
        var d = n.props.alphaType === "transparency" ? mo : ji;
        n._updateColor(c, d(n.state.color, Math.round(u)));
      }, n._onBlur = function(c) {
        var u, d = n.state, f = d.color, p = d.editingColor;
        if (p) {
          var g = p.value, b = p.component, x = b === "hex", m = b === "a", y = b === "t", C = x ? Sn : up;
          if (g.length >= C && (x || !isNaN(Number(g)))) {
            var E = void 0;
            if (x)
              E = an("#" + kp(g));
            else if (m || y) {
              var k = m ? ji : mo;
              E = k(f, ze(Number(g), je));
            } else
              E = Wo(Sp(w(w({}, f), (u = {}, u[b] = Number(g), u))));
            n._updateColor(c, E);
          } else
            n.setState({ editingColor: void 0 });
        }
      }, Ir(n);
      var o = r.strings;
      da("ColorPicker", r, {
        hexLabel: "strings.hex",
        redLabel: "strings.red",
        greenLabel: "strings.green",
        blueLabel: "strings.blue",
        alphaLabel: "strings.alpha",
        alphaSliderHidden: "alphaType"
      }), o.hue && ot("ColorPicker property 'strings.hue' was used but has been deprecated. Use 'strings.hueAriaLabel' instead."), n.state = {
        color: Vi(r) || an("#ffffff")
      }, n._textChangeHandlers = {};
      for (var a = 0, i = qp; a < i.length; a++) {
        var s = i[a];
        n._textChangeHandlers[s] = n._onTextChange.bind(n, s);
      }
      var l = t.defaultProps.strings;
      return n._textLabels = {
        /* eslint-disable deprecation/deprecation */
        r: r.redLabel || o.red || l.red,
        g: r.greenLabel || o.green || l.green,
        b: r.blueLabel || o.blue || l.blue,
        a: r.alphaLabel || o.alpha || l.alpha,
        hex: r.hexLabel || o.hex || l.hex,
        t: o.transparency || l.transparency
        /* eslint-enable deprecation/deprecation */
      }, n._strings = w(w(w({}, l), {
        // these aria labels default to the visible labels
        alphaAriaLabel: n._textLabels.a,
        transparencyAriaLabel: n._textLabels.t
      }), o), n;
    }
    return Object.defineProperty(t.prototype, "color", {
      get: function() {
        return this.state.color;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentDidUpdate = function(r, n) {
      if (r !== this.props) {
        var o = Vi(this.props);
        o && this._updateColor(void 0, o);
      }
    }, t.prototype.render = function() {
      var r = this, n = this.props, o = this._strings, a = this._textLabels, i = n.theme, s = n.className, l = n.styles, c = n.alphaType, u = n.alphaSliderHidden, d = u === void 0 ? c === "none" : u, f = n.tooltipProps, p = this.state.color, g = c === "transparency", b = ["hex", "r", "g", "b", g ? "t" : "a"], x = g ? p.t : p.a, m = g ? a.t : a.a, y = Up(l, {
        theme: i,
        className: s,
        alphaType: c
      }), C = [a.r, p.r, a.g, p.g, a.b, p.b];
      !d && typeof x == "number" && C.push(m, "".concat(x, "%"));
      var E = o.rootAriaLabelFormat.replace("{0}", C.join(" "));
      return h.createElement(
        "div",
        { className: y.root, role: "group", "aria-label": E },
        h.createElement(
          "div",
          { className: y.panel },
          h.createElement(Fp, { color: p, onChange: this._onSVChanged, ariaLabel: o.svAriaLabel, ariaDescription: o.svAriaDescription, ariaValueFormat: o.svAriaValueFormat, className: y.colorRectangle }),
          h.createElement(
            "div",
            { className: y.flexContainer },
            h.createElement(
              "div",
              { className: y.flexSlider },
              h.createElement($i, {
                className: "is-hue",
                type: "hue",
                // eslint-disable-next-line deprecation/deprecation
                ariaLabel: o.hue || o.hueAriaLabel,
                value: p.h,
                onChange: this._onHChanged
              }),
              !d && h.createElement($i, { className: "is-alpha", type: c, ariaLabel: g ? o.transparencyAriaLabel : o.alphaAriaLabel, overlayColor: p.hex, value: x, onChange: this._onATChanged })
            ),
            n.showPreview && h.createElement(
              "div",
              { className: y.flexPreviewBox },
              h.createElement("div", { className: y.colorSquare + " is-preview", style: {
                backgroundColor: p.str
              } })
            )
          ),
          h.createElement(
            "table",
            { className: y.table, role: "group", cellPadding: "0", cellSpacing: "0" },
            h.createElement(
              "thead",
              null,
              h.createElement(
                "tr",
                { className: y.tableHeader },
                h.createElement("td", { className: y.tableHexCell }, a.hex),
                h.createElement("td", null, a.r),
                h.createElement("td", null, a.g),
                h.createElement("td", null, a.b),
                !d && h.createElement("td", { className: y.tableAlphaCell }, m)
              )
            ),
            h.createElement(
              "tbody",
              null,
              h.createElement("tr", null, b.map(function(k) {
                if ((k === "a" || k === "t") && d)
                  return null;
                var S = r._getTooltipValue(k);
                return h.createElement(
                  "td",
                  { key: k },
                  h.createElement(
                    qv,
                    w({ content: S, directionalHint: Ee.bottomCenter, role: "alert" }, f),
                    h.createElement(Bp, { className: y.input, onChange: r._textChangeHandlers[k], onBlur: r._onBlur, value: r._getDisplayValue(k), spellCheck: !1, ariaLabel: a[k], autoComplete: "off", invalid: !!S })
                  )
                );
              }))
            )
          )
        )
      );
    }, t.prototype._getDisplayValue = function(r) {
      var n = this.state, o = n.color, a = n.editingColor;
      return a && a.component === r ? a.value : r === "hex" ? o[r] || "" : typeof o[r] == "number" && !isNaN(o[r]) ? String(o[r]) : "";
    }, t.prototype._getTooltipValue = function(r) {
      var n = this.state.editingColor;
      if (!(!n || n.component !== r)) {
        var o = n.value;
        if (!(r === "hex" && o.length >= Sn && o.length <= Cr)) {
          var a = Gp[r];
          return this._strings[a];
        }
      }
    }, t.prototype._onTextChange = function(r, n, o) {
      var a, i = this.state.color, s = r === "hex", l = r === "a", c = r === "t";
      o = (o || "").substr(0, s ? Cr : dp);
      var u = s ? fp : hp;
      if (u.test(o)) {
        var d;
        if (o === "" ? d = !1 : s ? d = o.length === Cr : l || c ? d = Number(o) <= je : d = Number(o) <= gt, !d)
          this.setState({ editingColor: { component: r, value: o } });
        else if (String(i[r]) === o)
          this.state.editingColor && this.setState({ editingColor: void 0 });
        else {
          var f = s ? an("#" + o) : c ? mo(i, Number(o)) : Wo(w(w({}, i), (a = {}, a[r] = Number(o), a)));
          this._updateColor(n, f);
        }
      }
    }, t.prototype._updateColor = function(r, n) {
      if (n) {
        var o = this.state, a = o.color, i = o.editingColor, s = n.h !== a.h || n.str !== a.str;
        if (s || i) {
          if (r && this.props.onChange && (this.props.onChange(r, n), r.defaultPrevented))
            return;
          this.setState({ color: n, editingColor: void 0 });
        }
      }
    }, t.defaultProps = {
      alphaType: "alpha",
      strings: {
        rootAriaLabelFormat: "Color picker, {0} selected.",
        hex: "Hex",
        red: "Red",
        green: "Green",
        blue: "Blue",
        alpha: "Alpha",
        transparency: "Transparency",
        hueAriaLabel: "Hue",
        svAriaLabel: sn.defaultProps.ariaLabel,
        svAriaValueFormat: sn.defaultProps.ariaValueFormat,
        svAriaDescription: sn.defaultProps.ariaDescription,
        hexError: "Hex values must be between 3 and 6 characters long",
        alphaError: "Alpha must be between 0 and 100",
        transparencyError: "Transparency must be between 0 and 100",
        redError: "Red must be between 0 and 255",
        greenError: "Green must be between 0 and 255",
        blueError: "Blue must be between 0 and 255"
      }
    }, t;
  }(h.Component)
);
function Vi(e) {
  var t = e.color;
  return typeof t == "string" ? an(t) : t;
}
var Kp = function(e) {
  var t = e.className, r = e.theme, n = e.alphaType;
  return {
    root: [
      "ms-ColorPicker",
      r.fonts.medium,
      {
        position: "relative",
        maxWidth: 300
      },
      t
    ],
    panel: [
      "ms-ColorPicker-panel",
      {
        padding: "16px"
      }
    ],
    table: [
      "ms-ColorPicker-table",
      {
        tableLayout: "fixed",
        width: "100%",
        selectors: {
          "tbody td:last-of-type .ms-ColorPicker-input": {
            paddingRight: 0
          }
        }
      }
    ],
    tableHeader: [
      r.fonts.small,
      {
        selectors: {
          td: {
            paddingBottom: 4
          }
        }
      }
    ],
    tableHexCell: {
      width: "25%"
    },
    // Account for "Transparency" being a longer word
    tableAlphaCell: n === "transparency" && {
      width: "22%"
    },
    colorSquare: [
      "ms-ColorPicker-colorSquare",
      {
        width: 48,
        height: 48,
        margin: "0 0 0 8px",
        border: "1px solid #c8c6c4",
        forcedColorAdjust: "none"
      }
    ],
    flexContainer: {
      display: "flex"
    },
    flexSlider: {
      flexGrow: "1"
    },
    flexPreviewBox: {
      flexGrow: "0"
    },
    input: [
      "ms-ColorPicker-input",
      {
        width: "100%",
        border: "none",
        boxSizing: "border-box",
        height: 30,
        selectors: {
          "&.ms-TextField": {
            paddingRight: 4
          },
          "& .ms-TextField-field": {
            minWidth: "auto",
            padding: 5,
            textOverflow: "clip"
          }
        }
      }
    ]
  };
}, Xp = qe(Yp, Kp, void 0, { scope: "ColorPicker" }), Qp = Ue(), Uo = "Toggle", Dl = h.forwardRef(function(e, t) {
  var r = e.as, n = r === void 0 ? "div" : r, o = e.ariaLabel, a = e.checked, i = e.className, s = e.defaultChecked, l = s === void 0 ? !1 : s, c = e.disabled, u = e.inlineLabel, d = e.label, f = e.offAriaLabel, p = e.offText, g = e.onAriaLabel, b = e.onChange, x = e.onChanged, m = e.onClick, y = e.onText, C = e.role, E = e.styles, k = e.theme, S = Vh(a, l, h.useCallback(function(Q, ye) {
    b == null || b(Q, ye), x == null || x(ye);
  }, [b, x])), _ = S[0], P = S[1], D = Qp(E, {
    theme: k,
    className: i,
    disabled: c,
    checked: _,
    inlineLabel: u,
    onOffMissing: !y && !p
  }), z = _ ? g : f, q = _l(Uo, e.id), I = "".concat(q, "-label"), R = "".concat(q, "-stateText"), L = _ ? y : p, M = Je(e, Zs, [
    "defaultChecked"
  ]), $ = void 0;
  !o && !z && (d && ($ = I), L && !$ && ($ = R));
  var G = h.useRef(null);
  Zd(G), Jp(e, _, G), process.env.NODE_ENV !== "production" && xl({
    name: Uo,
    props: e,
    deprecations: {
      offAriaLabel: void 0,
      onAriaLabel: "ariaLabel",
      onChanged: "onChange"
    },
    mutuallyExclusive: { checked: "defaultChecked" }
  });
  var be = function(Q) {
    c || (P(!_, Q), m && m(Q));
  }, Y = {
    root: {
      className: D.root,
      hidden: M.hidden
    },
    label: {
      children: d,
      className: D.label,
      htmlFor: q,
      id: I
    },
    container: {
      className: D.container
    },
    pill: w(w({}, M), { "aria-disabled": c, "aria-checked": _, "aria-label": o || z, "aria-labelledby": $, className: D.pill, "data-is-focusable": !0, "data-ktp-target": !0, disabled: c, id: q, onClick: be, ref: G, role: C || "switch", type: "button" }),
    thumb: {
      className: D.thumb
    },
    stateText: {
      children: L,
      className: D.text,
      htmlFor: q,
      id: R
    }
  };
  return h.createElement(
    n,
    w({ ref: t }, Y.root),
    d && h.createElement(cr, w({}, Y.label)),
    h.createElement(
      "div",
      w({}, Y.container),
      h.createElement(
        "button",
        w({}, Y.pill),
        h.createElement("span", w({}, Y.thumb))
      ),
      (_ && y || p) && h.createElement(cr, w({}, Y.stateText))
    )
  );
});
Dl.displayName = Uo + "Base";
var Jp = function(e, t, r) {
  h.useImperativeHandle(e.componentRef, function() {
    return {
      get checked() {
        return !!t;
      },
      focus: function() {
        r.current && r.current.focus();
      }
    };
  }, [t, r]);
}, Zp = 40, zi = 20, yo = 12, eg = function(e) {
  var t, r, n, o, a, i, s, l = e.theme, c = e.className, u = e.disabled, d = e.checked, f = e.inlineLabel, p = e.onOffMissing, g = l.semanticColors, b = l.palette, x = g.bodyBackground, m = g.inputBackgroundChecked, y = g.inputBackgroundCheckedHovered, C = b.neutralDark, E = g.disabledBodySubtext, k = g.smallInputBorder, S = g.inputForegroundChecked, _ = g.disabledBodySubtext, P = g.disabledBackground, D = g.smallInputBorder, z = g.inputBorderHovered, q = g.disabledBodySubtext, I = g.disabledText;
  return {
    root: [
      "ms-Toggle",
      d && "is-checked",
      !u && "is-enabled",
      u && "is-disabled",
      l.fonts.medium,
      {
        marginBottom: "8px"
      },
      f && {
        display: "flex",
        alignItems: "center"
      },
      c
    ],
    label: [
      "ms-Toggle-label",
      { display: "inline-block" },
      u && {
        color: I,
        selectors: (t = {}, t[ne] = {
          color: "GrayText"
        }, t)
      },
      f && !p && {
        marginRight: 16
      },
      p && f && {
        order: 1,
        marginLeft: 16
      },
      f && { wordBreak: "break-word" }
    ],
    container: [
      "ms-Toggle-innerContainer",
      {
        display: "flex",
        position: "relative"
      }
    ],
    pill: [
      "ms-Toggle-background",
      dl(l, { inset: -3 }),
      {
        fontSize: "20px",
        boxSizing: "border-box",
        width: Zp,
        height: zi,
        borderRadius: zi / 2,
        transition: "all 0.1s ease",
        border: "1px solid ".concat(D),
        background: x,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        padding: "0 3px",
        overflow: "visible"
      },
      !u && [
        !d && {
          selectors: {
            ":hover": [
              {
                borderColor: z
              }
            ],
            ":hover .ms-Toggle-thumb": [
              {
                backgroundColor: C,
                selectors: (r = {}, r[ne] = {
                  borderColor: "Highlight"
                }, r)
              }
            ]
          }
        },
        d && [
          {
            background: m,
            borderColor: "transparent",
            justifyContent: "flex-end"
          },
          {
            selectors: (n = {
              ":hover": [
                {
                  backgroundColor: y,
                  borderColor: "transparent",
                  selectors: (o = {}, o[ne] = {
                    backgroundColor: "Highlight"
                  }, o)
                }
              ]
            }, n[ne] = w({ backgroundColor: "Highlight" }, At()), n)
          }
        ]
      ],
      u && [
        {
          cursor: "default"
        },
        !d && [
          {
            borderColor: q
          }
        ],
        d && [
          {
            backgroundColor: E,
            borderColor: "transparent",
            justifyContent: "flex-end"
          }
        ]
      ],
      !u && {
        selectors: {
          "&:hover": {
            selectors: (a = {}, a[ne] = {
              borderColor: "Highlight"
            }, a)
          }
        }
      }
    ],
    thumb: [
      "ms-Toggle-thumb",
      {
        display: "block",
        width: yo,
        height: yo,
        borderRadius: "50%",
        transition: "all 0.1s ease",
        backgroundColor: k,
        /* Border is added to handle high contrast mode for Firefox */
        borderColor: "transparent",
        borderWidth: yo / 2,
        borderStyle: "solid",
        boxSizing: "border-box"
      },
      !u && d && [
        {
          backgroundColor: S,
          selectors: (i = {}, i[ne] = {
            backgroundColor: "Window",
            borderColor: "Window"
          }, i)
        }
      ],
      u && [
        !d && [
          {
            backgroundColor: _
          }
        ],
        d && [
          {
            backgroundColor: P
          }
        ]
      ]
    ],
    text: [
      "ms-Toggle-stateText",
      {
        selectors: {
          // Workaround: make rules more specific than Label rules.
          "&&": {
            padding: "0",
            margin: "0 8px",
            userSelect: "none",
            fontWeight: le.regular
          }
        }
      },
      u && {
        selectors: {
          "&&": {
            color: I,
            selectors: (s = {}, s[ne] = {
              color: "GrayText"
            }, s)
          }
        }
      }
    ]
  };
}, tg = qe(Dl, eg, void 0, {
  scope: "Toggle"
});
const rg = V.div`
  display: flex;
  width: 100%;
`, ng = V.div`
  display: flex;
  align-items: center;
`, og = V(ya)`
  padding: 0;
  border: 2px solid #f7f7f7;
  border-radius: 12px;

  .ms-ColorPicker-panel {
    padding: 14px 14px 20px;
  }

  .ms-TextField-fieldGroup {
    border-color: #E5E8E8;
    border-radius: 8px;
  }

  tr {
    font-weight: 600;
  }

  .mode-edit & {
    box-shadow: 0 1px 1px rgba(0,0,0,0.025), 
              0 2px 2px rgba(0,0,0,0.025), 
              0 4px 4px rgba(0,0,0,0.025), 
              0 8px 8px rgba(0,0,0,0.025);
  }
`, ag = V.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`, ig = V(cr)`
  font-size: 9px;
`, sg = V.div`
  position: relative;
  width: 24px;
  height: 24px;
  margin-left: 6px;
  background: conic-gradient(
    from 90deg,
    violet,
    indigo,
    blue,
    green,
    yellow,
    orange,
    red,
    violet
  );
  display: inline-block;
  border-radius: 50%;
  cursor: pointer;
`, lg = V.div`
  position: absolute;
  inset: 2px;
  border-radius: 50%;
  border: 2px solid white;
  background-color: white;

  &:before {
    position: absolute;
    content: '';
    inset: 0;
    background: ${(e) => e.color};
    border-radius: 50%;
  }
`, cg = V.label`
  color: #3D3A3B;
  font-size: 14px;
  font-weight: 600;
`, E0 = ({ label: e, color: t, onColorChanged: r }) => {
  const [n, o] = ke.useState(!1), [a, i] = ke.useState(t), s = _l("callout-button"), l = (c, u) => {
    var f;
    const d = (f = u.str) != null ? f : "";
    r && (i(d), r(d));
  };
  return ke.useEffect(() => {
    const c = (u) => {
      const d = u.target, f = document.querySelector(".ms-Callout");
      f && !f.contains(d) && o(!1);
    };
    document.addEventListener("mousedown", c);
  }, []), /* @__PURE__ */ B.jsxs(rg, { children: [
    /* @__PURE__ */ B.jsx(ng, { children: /* @__PURE__ */ B.jsx(cg, { children: e }) }),
    /* @__PURE__ */ B.jsxs(ag, { children: [
      /* @__PURE__ */ B.jsx(ig, { children: a }),
      /* @__PURE__ */ B.jsx(sg, { id: s, onClick: () => o(!n), children: /* @__PURE__ */ B.jsx(lg, { color: a }) })
    ] }),
    n ? /* @__PURE__ */ B.jsx(og, { directionalHintFixed: !0, directionalHint: 6, target: `#${s}`, children: /* @__PURE__ */ B.jsx(
      Xp,
      {
        color: a,
        onChange: l,
        alphaType: "alpha"
      }
    ) }) : null
  ] });
};
function ug(e) {
  if (!Array.isArray(e))
    return [e];
  if (process.env.NODE_ENV !== "production" && e.length > 2)
    throw new Error("CSS Bucket contains an entry with greater than 2 items, please report this to https://github.com/microsoft/griffel/issues");
  return e;
}
const _o = typeof window == "undefined" ? global : window, xo = "@griffel/";
function Ll(e, t) {
  return _o[Symbol.for(xo + e)] || (_o[Symbol.for(xo + e)] = t), _o[Symbol.for(xo + e)];
}
const dg = /* @__PURE__ */ Ll("DEBUG_RESET_CLASSES", {}), Pr = /* @__PURE__ */ Ll("DEFINITION_LOOKUP_TABLE", {}), ln = "data-make-styles-bucket", fg = "r", Er = 7, ut = "___", Bl = "_", Ml = process.env.NODE_ENV === "production" ? ut.length + Er : ut.length + Er + Bl.length + Er, hg = 0, Wi = 1;
function vg(e, t, r) {
  const n = [];
  if (r[ln] = t, e)
    for (const a in r)
      e.setAttribute(a, r[a]);
  function o(a) {
    return e != null && e.sheet ? e.sheet.insertRule(a, e.sheet.cssRules.length) : n.push(a);
  }
  return {
    elementAttributes: r,
    insertRule: o,
    element: e,
    bucketName: t,
    cssRules() {
      return e != null && e.sheet ? Array.from(e.sheet.cssRules).map((a) => a.cssText) : n;
    }
  };
}
const pg = [
  // reset styles
  "r",
  // catch-all
  "d",
  // link
  "l",
  // visited
  "v",
  // focus-within
  "w",
  // focus
  "f",
  // focus-visible
  "i",
  // hover
  "h",
  // active
  "a",
  // at rules for reset styles
  "s",
  // keyframes
  "k",
  // at-rules
  "t",
  // @media rules
  "m",
  // @container rules
  "c"
], Ui = /* @__PURE__ */ pg.reduce((e, t, r) => (e[t] = r, e), {});
function gg(e, t, r, n, o = {}) {
  const a = e === "m", i = a ? e + o.m : e;
  if (!n.stylesheets[i]) {
    const s = t && t.createElement("style"), l = vg(s, e, Object.assign({}, n.styleElementAttributes, a && {
      media: o.m
    }));
    n.stylesheets[i] = l, t && s && t.head.insertBefore(s, mg(t, r, e, n, o));
  }
  return n.stylesheets[i];
}
function mg(e, t, r, n, o) {
  const a = Ui[r];
  let i = (u) => a - Ui[u.getAttribute(ln)], s = e.head.querySelectorAll(`[${ln}]`);
  if (r === "m" && o) {
    const u = e.head.querySelectorAll(`[${ln}="${r}"]`);
    u.length && (s = u, i = (d) => n.compareMediaQueries(o.m, d.media));
  }
  const l = s.length;
  let c = l - 1;
  for (; c >= 0; ) {
    const u = s.item(c);
    if (i(u) > 0)
      return u.nextSibling;
    c--;
  }
  return l > 0 ? s.item(0) : t ? t.nextSibling : null;
}
const bg = /* @__PURE__ */ ["-moz-placeholder", "-moz-focus-inner", "-moz-focusring", "-ms-input-placeholder", "-moz-read-write", "-moz-read-only"].join("|"), yg = /* @__PURE__ */ new RegExp(`:(${bg})`);
function qi(e, t) {
  try {
    e.insertRule(t);
  } catch (r) {
    process.env.NODE_ENV !== "production" && !yg.test(t) && console.error(`There was a problem inserting the following rule: "${t}"`, r);
  }
}
const kn = /* @__PURE__ */ (() => {
  try {
    var e;
    return !!(typeof window != "undefined" && ((e = window.sessionStorage) != null && e.getItem("__GRIFFEL_DEVTOOLS__")));
  } catch (t) {
    return !1;
  }
})();
function Co(e) {
  for (var t = 0, r, n = 0, o = e.length; o >= 4; ++n, o -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
function Eo(e) {
  const t = e.length;
  if (t === Er)
    return e;
  for (let r = t; r < Er; r++)
    e += "0";
  return e;
}
function jl(e, t, r = []) {
  return process.env.NODE_ENV === "production" ? ut + Eo(Co(e + t)) : ut + Eo(Co(e + t)) + Bl + Eo(Co(r.join("")));
}
function Fl(e, t) {
  let r = "";
  for (const n in e) {
    const o = e[n];
    if (o) {
      const a = Array.isArray(o);
      t === "rtl" ? r += (a ? o[1] : o) + " " : r += (a ? o[0] : o) + " ";
    }
  }
  return r.slice(0, -1);
}
function Gi(e, t) {
  const r = {};
  for (const n in e) {
    const o = Fl(e[n], t);
    if (o === "") {
      r[n] = "";
      continue;
    }
    const a = jl(o, t), i = a + " " + o;
    Pr[a] = [e[n], t], r[n] = i;
  }
  return r;
}
const Tn = {};
function Yi() {
  let e = null, t = "", r = "";
  const n = new Array(arguments.length);
  let o = "";
  for (let u = 0; u < arguments.length; u++) {
    const d = arguments[u];
    if (typeof d == "string" && d !== "") {
      const f = d.indexOf(ut);
      if (f === -1)
        process.env.NODE_ENV !== "production" && d.split(" ").forEach((p) => {
          p.startsWith(fg) && dg[p] && (o ? console.error(`mergeClasses(): a passed string contains multiple classes produced by makeResetStyles (${d} & ${t}, this will lead to non-deterministic behavior. Learn more:https://griffel.js.org/react/api/make-reset-styles#limitations
Source string: ${d}`) : o = p);
        }), t += d + " ";
      else {
        const p = d.substr(f, Ml);
        f > 0 && (t += d.slice(0, f)), r += p, n[u] = p;
      }
      process.env.NODE_ENV !== "production" && d.indexOf(ut, f + 1) !== -1 && console.error(`mergeClasses(): a passed string contains multiple identifiers of atomic classes (classes that start with "${ut}"), it's possible that passed classes were concatenated in a wrong way. Source string: ${d}`);
    }
  }
  if (r === "")
    return t.slice(0, -1);
  const a = Tn[r];
  if (a !== void 0)
    return t + a;
  const i = [];
  for (let u = 0; u < arguments.length; u++) {
    const d = n[u];
    if (d) {
      const f = Pr[d];
      f ? (i.push(f[hg]), process.env.NODE_ENV !== "production" && e !== null && e !== f[Wi] && console.error(`mergeClasses(): a passed string contains an identifier (${d}) that has different direction (dir="${f[1] ? "rtl" : "ltr"}") setting than other classes. This is not supported. Source string: ${arguments[u]}`), e = f[Wi]) : process.env.NODE_ENV !== "production" && console.error(`mergeClasses(): a passed string contains an identifier (${d}) that does not match any entry in cache. Source string: ${arguments[u]}`);
    }
  }
  const s = Object.assign.apply(
    Object,
    // .assign() mutates the first object, we can't mutate mappings as it will produce invalid results later
    [{}].concat(i)
  );
  let l = Fl(s, e);
  const c = jl(l, e, n);
  return l = c + " " + l, Tn[r] = l, Pr[c] = [s, e], t + l;
}
const Ki = {}, Xi = /* @__PURE__ */ new Set(), wr = {
  getChildrenSequences: (e) => {
    const t = Object.keys(Tn).find((r) => Tn[r].startsWith(e));
    return t ? t.split(ut).filter((r) => r.length).map((r) => ut + r) : [];
  },
  addCSSRule: (e) => {
    Xi.add(e);
  },
  addSequenceDetails: (e, t) => {
    Object.entries(e).forEach(([r, n]) => {
      Ki[n.substring(0, Ml)] = {
        slotName: r,
        sourceURL: t
      };
    });
  },
  getCSSRules: () => Array.from(Xi),
  getSequenceDetails: (e) => Ki[e]
};
function Qi(e, t) {
  return Array.isArray(e) ? t === "rtl" ? e[1] : e[0] : e;
}
function _g(e, t, r, n) {
  const o = e[0], a = e[1];
  return Object.entries(o).map(([i, s]) => {
    const l = Qi(s, a);
    let c;
    if (r && t) {
      const u = r.find(({
        className: d
      }) => d === l);
      !u && t[0][i] ? c = Qi(t[0][i], t[1]) : u && t[0][i] ? c = (n ? n.filter(({
        debugClassNames: f
      }) => f.filter(({
        className: p
      }) => p === l).length > 0).length > 0 : !1) ? u.className : u.overriddenBy : (!u && !t[0][i] || u && !t[0][i]) && (c = void 0);
    }
    return {
      className: l,
      overriddenBy: c
    };
  });
}
function Hl(e, t) {
  const r = Pr[e];
  if (r === void 0)
    return;
  const n = t ? Pr[t.sequenceHash] : void 0, o = _g(r, n, t == null ? void 0 : t.debugClassNames, t == null ? void 0 : t.children), a = {
    sequenceHash: e,
    direction: r[1],
    children: [],
    debugClassNames: o
  };
  return wr.getChildrenSequences(a.sequenceHash).reverse().forEach((s) => {
    const l = Hl(s, a);
    l && a.children.push(l);
  }), a.children.length || (a.rules = {}, a.debugClassNames.forEach(({
    className: s
  }) => {
    const l = wr.getSequenceDetails(e);
    l && (a.slot = l.slotName, a.sourceURL = l.sourceURL);
    const c = wr.getCSSRules().find((u) => u.includes(s));
    a.rules[s] = c;
  })), a;
}
function xg(e) {
  const t = e.defaultView;
  if (!t || t.__GRIFFEL_DEVTOOLS__)
    return;
  const r = {
    getInfo: (n) => {
      const o = Array.from(n.classList).find((a) => a.startsWith(ut));
      if (o !== void 0)
        return Hl(o);
    }
  };
  Object.defineProperty(t, "__GRIFFEL_DEVTOOLS__", {
    configurable: !1,
    enumerable: !1,
    get() {
      return r;
    }
  });
}
let Cg = 0;
const Eg = (e, t) => e < t ? -1 : e > t ? 1 : 0;
function wg(e = typeof document == "undefined" ? void 0 : document, t = {}) {
  const {
    unstable_filterCSSRule: r,
    insertionPoint: n,
    styleElementAttributes: o,
    compareMediaQueries: a = Eg
  } = t, i = {
    insertionCache: {},
    stylesheets: {},
    styleElementAttributes: Object.freeze(o),
    compareMediaQueries: a,
    id: `d${Cg++}`,
    insertCSSRules(s) {
      for (const l in s) {
        const c = s[l];
        for (let u = 0, d = c.length; u < d; u++) {
          const [f, p] = ug(c[u]), g = gg(l, e, n || null, i, p);
          i.insertionCache[f] || (i.insertionCache[f] = l, process.env.NODE_ENV !== "production" && kn && wr.addCSSRule(f), r ? r(f) && qi(g, f) : qi(g, f));
        }
      }
    }
  };
  return e && process.env.NODE_ENV !== "production" && kn && xg(e), i;
}
const Sg = () => {
  const e = {};
  return function(r, n) {
    e[r.id] === void 0 && (r.insertCSSRules(n), e[r.id] = !0);
  };
}, _a = "<unknown>";
function kg(e) {
  return Pg(e) || Ag(e) || Lg(e);
}
const Tg = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/|[a-z]:\\|\\\\).*?)?\)?\s*$/i, Rg = /^\s*at ()((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/|[a-z]:\\|\\\\).*?)\s*$/i, Ng = /\((\S*)\)/;
function Pg(e) {
  const t = Tg.exec(e) || Rg.exec(e);
  if (!t)
    return null;
  let r = t[2];
  const n = r && r.indexOf("native") === 0, o = r && r.indexOf("eval") === 0, a = Ng.exec(r);
  return o && a != null && (r = a[1]), {
    loc: n ? null : t[2],
    name: t[1] || _a
  };
}
const Ig = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?|[^@]*bundle)\s*$/i, Og = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function Ag(e) {
  const t = Ig.exec(e);
  if (!t)
    return null;
  let r = t[3];
  const n = r && r.indexOf(" > eval") > -1, o = Og.exec(r);
  return n && o != null && (r = o[1]), {
    loc: t[3],
    name: t[1] || _a
  };
}
const Dg = /^\s*(?:([^@]*)(?:\((.*?)\))?@)?(\S.*?)\s*$/i;
function Lg(e) {
  const t = Dg.exec(e);
  return t ? {
    loc: t[3],
    name: t[1] || _a
  } : null;
}
function Bg() {
  const e = String(new Error().stack).split(`
`), t = Mg(e);
  if (t === void 0)
    return;
  const r = kg(t);
  return r == null ? void 0 : r.loc;
}
function Mg(e) {
  for (let t = e.length - 1; t >= 0; --t)
    if (e[t].includes("at getSourceURLfromError"))
      return e[t + 3];
}
function jg(e, t, r = Sg) {
  const n = r();
  let o = null, a = null, i;
  process.env.NODE_ENV !== "production" && kn && (i = Bg());
  function s(l) {
    const {
      dir: c,
      renderer: u
    } = l, d = c === "ltr";
    d ? o === null && (o = Gi(e, c)) : a === null && (a = Gi(e, c)), n(u, t);
    const f = d ? o : a;
    return process.env.NODE_ENV !== "production" && kn && wr.addSequenceDetails(f, i), f;
  }
  return s;
}
function Fg() {
  return typeof window != "undefined" && !!(window.document && window.document.createElement);
}
const Ji = (
  // @ts-expect-error Hack to make sure that `useInsertionEffect` will not cause bundling issues in older React versions
  // eslint-disable-next-line no-useless-concat
  h.useInsertionEffect ? h.useInsertionEffect : void 0
), Hg = () => {
  const e = {};
  return function(r, n) {
    if (Ji && Fg()) {
      Ji(() => {
        r.insertCSSRules(n);
      }, [r, n]);
      return;
    }
    e[r.id] === void 0 && (r.insertCSSRules(n), e[r.id] = !0);
  };
}, $g = /* @__PURE__ */ h.createContext(/* @__PURE__ */ wg());
function Vg() {
  return h.useContext($g);
}
const zg = /* @__PURE__ */ h.createContext("ltr");
function Wg() {
  return h.useContext(zg);
}
function xa(e, t) {
  const r = jg(e, t, Hg);
  return function() {
    const o = Wg(), a = Vg();
    return r({
      dir: o,
      renderer: a
    });
  };
}
const qo = Symbol.for("fui.slotRenderFunction"), $t = Symbol.for("fui.slotElementType");
function Go(e, t) {
  const { defaultProps: r, elementType: n } = t, o = $l(e), a = Mr(kt(kt({}, r), o), {
    [$t]: n
  });
  return o && typeof o.children == "function" && (a[qo] = o.children, a.children = r == null ? void 0 : r.children), a;
}
function $l(e) {
  return typeof e == "string" || typeof e == "number" || Array.isArray(e) || // eslint-disable-next-line @typescript-eslint/no-explicit-any
  h.isValidElement(e) ? {
    children: e
  } : (e && typeof e != "object" && process.env.NODE_ENV !== "production" && console.error(`@fluentui/react-utilities [slot.${$l.name}]:
A slot got an invalid value "${e}" (${typeof e}).
A valid value for a slot is a slot shorthand or slot properties object.
Slot shorthands can be strings, numbers, arrays or JSX elements`), e);
}
function Yo(e) {
  return !!(e != null && e.hasOwnProperty($t));
}
function Ko(e) {
  if (process.env.NODE_ENV !== "production") {
    const t = e;
    for (const r of Object.keys(t.components)) {
      const n = t[r];
      if (n !== void 0)
        if (!Yo(n))
          t[r] = Go(n, {
            elementType: t.components[r]
          }), console.warn(`@fluentui/react-utilities [${Ko.name}]:
"state.${r}" is not a slot!
Be sure to create slots properly by using "slot.always" or "slot.optional".`);
        else {
          const { [$t]: o } = n;
          o !== t.components[r] && (n[$t] = t.components[r], console.warn(`@fluentui/react-utilities [${Ko.name}]:
"state.${r}" element type differs from "state.components.${r}",
${o} !== ${t.components[r]}.
Be sure to create slots properly by using "slot.always" or "slot.optional" with the correct elementType.`));
        }
    }
  }
}
const ie = (...e) => {
  const t = {};
  for (const r of e) {
    const n = Array.isArray(r) ? r : Object.keys(r);
    for (const o of n)
      t[o] = 1;
  }
  return t;
}, Ug = ie([
  "onAuxClick",
  "onAnimationEnd",
  "onAnimationStart",
  "onCopy",
  "onCut",
  "onPaste",
  "onCompositionEnd",
  "onCompositionStart",
  "onCompositionUpdate",
  "onFocus",
  "onFocusCapture",
  "onBlur",
  "onBlurCapture",
  "onChange",
  "onInput",
  "onSubmit",
  "onLoad",
  "onError",
  "onKeyDown",
  "onKeyDownCapture",
  "onKeyPress",
  "onKeyUp",
  "onAbort",
  "onCanPlay",
  "onCanPlayThrough",
  "onDurationChange",
  "onEmptied",
  "onEncrypted",
  "onEnded",
  "onLoadedData",
  "onLoadedMetadata",
  "onLoadStart",
  "onPause",
  "onPlay",
  "onPlaying",
  "onProgress",
  "onRateChange",
  "onSeeked",
  "onSeeking",
  "onStalled",
  "onSuspend",
  "onTimeUpdate",
  "onVolumeChange",
  "onWaiting",
  "onClick",
  "onClickCapture",
  "onContextMenu",
  "onDoubleClick",
  "onDrag",
  "onDragEnd",
  "onDragEnter",
  "onDragExit",
  "onDragLeave",
  "onDragOver",
  "onDragStart",
  "onDrop",
  "onMouseDown",
  "onMouseDownCapture",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onMouseUpCapture",
  "onSelect",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onScroll",
  "onWheel",
  "onPointerCancel",
  "onPointerDown",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerMove",
  "onPointerOut",
  "onPointerOver",
  "onPointerUp",
  "onGotPointerCapture",
  "onLostPointerCapture"
]), qg = ie([
  "accessKey",
  "children",
  "className",
  "contentEditable",
  "dir",
  "draggable",
  "hidden",
  "htmlFor",
  "id",
  "lang",
  "ref",
  "role",
  "style",
  "tabIndex",
  "title",
  "translate",
  "spellCheck",
  "name"
]), Gg = ie([
  "itemID",
  "itemProp",
  "itemRef",
  "itemScope",
  "itemType"
]), ge = ie(qg, Ug, Gg), Yg = ie(ge, [
  "form"
]), Vl = ie(ge, [
  "height",
  "loop",
  "muted",
  "preload",
  "src",
  "width"
]), Kg = ie(Vl, [
  "poster"
]), Xg = ie(ge, [
  "start"
]), Qg = ie(ge, [
  "value"
]), Jg = ie(ge, [
  "download",
  "href",
  "hrefLang",
  "media",
  "rel",
  "target",
  "type"
]), Zg = ie(ge, [
  "dateTime"
]), qn = ie(ge, [
  "autoFocus",
  "disabled",
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "type",
  "value"
]), em = ie(qn, [
  "accept",
  "alt",
  "autoCapitalize",
  "autoComplete",
  "checked",
  "dirname",
  "form",
  "height",
  "inputMode",
  "list",
  "max",
  "maxLength",
  "min",
  "multiple",
  "pattern",
  "placeholder",
  "readOnly",
  "required",
  "src",
  "step",
  "size",
  "type",
  "value",
  "width"
]), tm = ie(qn, [
  "autoCapitalize",
  "cols",
  "dirname",
  "form",
  "maxLength",
  "placeholder",
  "readOnly",
  "required",
  "rows",
  "wrap"
]), rm = ie(qn, [
  "form",
  "multiple",
  "required"
]), nm = ie(ge, [
  "selected",
  "value"
]), om = ie(ge, [
  "cellPadding",
  "cellSpacing"
]), am = ge, im = ie(ge, [
  "colSpan",
  "rowSpan",
  "scope"
]), sm = ie(ge, [
  "colSpan",
  "headers",
  "rowSpan",
  "scope"
]), lm = ie(ge, [
  "span"
]), cm = ie(ge, [
  "span"
]), um = ie(ge, [
  "disabled",
  "form"
]), dm = ie(ge, [
  "acceptCharset",
  "action",
  "encType",
  "encType",
  "method",
  "noValidate",
  "target"
]), fm = ie(ge, [
  "allow",
  "allowFullScreen",
  "allowPaymentRequest",
  "allowTransparency",
  "csp",
  "height",
  "importance",
  "referrerPolicy",
  "sandbox",
  "src",
  "srcDoc",
  "width"
]), hm = ie(ge, [
  "alt",
  "crossOrigin",
  "height",
  "src",
  "srcSet",
  "useMap",
  "width"
]), vm = ie(ge, [
  "open",
  "onCancel",
  "onClose"
]);
function pm(e, t, r) {
  const n = Array.isArray(t), o = {}, a = Object.keys(e);
  for (const i of a)
    (!n && t[i] || n && t.indexOf(i) >= 0 || i.indexOf("data-") === 0 || i.indexOf("aria-") === 0) && (!r || (r == null ? void 0 : r.indexOf(i)) === -1) && (o[i] = e[i]);
  return o;
}
const gm = {
  label: Yg,
  audio: Vl,
  video: Kg,
  ol: Xg,
  li: Qg,
  a: Jg,
  button: qn,
  input: em,
  textarea: tm,
  select: rm,
  option: nm,
  table: om,
  tr: am,
  th: im,
  td: sm,
  colGroup: lm,
  col: cm,
  fieldset: um,
  form: dm,
  iframe: fm,
  img: hm,
  time: Zg,
  dialog: vm
};
function mm(e, t, r) {
  const n = e && gm[e] || ge;
  return n.as = 1, pm(t, n, r);
}
const bm = (e, t, r) => {
  var n;
  return mm((n = t.as) !== null && n !== void 0 ? n : e, t, r);
}, ym = {
  current: 0
}, _m = /* @__PURE__ */ h.createContext(void 0);
function xm() {
  var e;
  return (e = h.useContext(_m)) !== null && e !== void 0 ? e : ym;
}
const zl = h.createContext(void 0);
zl.Provider;
function Cm() {
  return h.useContext(zl) || "";
}
function Em(e = "fui-", t) {
  const r = xm(), n = Cm(), o = h.useId;
  if (o) {
    const a = o(), i = h.useMemo(() => a.replace(/:/g, ""), [
      a
    ]);
    return t || `${n}${e}${i}`;
  }
  return h.useMemo(() => t || `${n}${e}${++r.current}`, [
    n,
    e,
    t,
    r
  ]);
}
const Wl = h.createContext(void 0), wm = () => {
};
Wl.Provider;
const Sm = (e) => {
  var t, r;
  return (r = (t = h.useContext(Wl)) === null || t === void 0 ? void 0 : t[e]) !== null && r !== void 0 ? r : wm;
};
function km(e, t) {
  return Mr(kt({}, t), {
    [$t]: e
  });
}
var Xo = { exports: {} }, Z = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zi;
function Tm() {
  if (Zi)
    return Z;
  Zi = 1;
  var e = 60103, t = 60106, r = 60107, n = 60108, o = 60114, a = 60109, i = 60110, s = 60112, l = 60113, c = 60120, u = 60115, d = 60116, f = 60121, p = 60122, g = 60117, b = 60129, x = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var m = Symbol.for;
    e = m("react.element"), t = m("react.portal"), r = m("react.fragment"), n = m("react.strict_mode"), o = m("react.profiler"), a = m("react.provider"), i = m("react.context"), s = m("react.forward_ref"), l = m("react.suspense"), c = m("react.suspense_list"), u = m("react.memo"), d = m("react.lazy"), f = m("react.block"), p = m("react.server.block"), g = m("react.fundamental"), b = m("react.debug_trace_mode"), x = m("react.legacy_hidden");
  }
  function y(R) {
    if (typeof R == "object" && R !== null) {
      var L = R.$$typeof;
      switch (L) {
        case e:
          switch (R = R.type, R) {
            case r:
            case o:
            case n:
            case l:
            case c:
              return R;
            default:
              switch (R = R && R.$$typeof, R) {
                case i:
                case s:
                case d:
                case u:
                case a:
                  return R;
                default:
                  return L;
              }
          }
        case t:
          return L;
      }
    }
  }
  var C = a, E = e, k = s, S = r, _ = d, P = u, D = t, z = o, q = n, I = l;
  return Z.ContextConsumer = i, Z.ContextProvider = C, Z.Element = E, Z.ForwardRef = k, Z.Fragment = S, Z.Lazy = _, Z.Memo = P, Z.Portal = D, Z.Profiler = z, Z.StrictMode = q, Z.Suspense = I, Z.isAsyncMode = function() {
    return !1;
  }, Z.isConcurrentMode = function() {
    return !1;
  }, Z.isContextConsumer = function(R) {
    return y(R) === i;
  }, Z.isContextProvider = function(R) {
    return y(R) === a;
  }, Z.isElement = function(R) {
    return typeof R == "object" && R !== null && R.$$typeof === e;
  }, Z.isForwardRef = function(R) {
    return y(R) === s;
  }, Z.isFragment = function(R) {
    return y(R) === r;
  }, Z.isLazy = function(R) {
    return y(R) === d;
  }, Z.isMemo = function(R) {
    return y(R) === u;
  }, Z.isPortal = function(R) {
    return y(R) === t;
  }, Z.isProfiler = function(R) {
    return y(R) === o;
  }, Z.isStrictMode = function(R) {
    return y(R) === n;
  }, Z.isSuspense = function(R) {
    return y(R) === l;
  }, Z.isValidElementType = function(R) {
    return typeof R == "string" || typeof R == "function" || R === r || R === o || R === b || R === n || R === l || R === c || R === x || typeof R == "object" && R !== null && (R.$$typeof === d || R.$$typeof === u || R.$$typeof === a || R.$$typeof === i || R.$$typeof === s || R.$$typeof === g || R.$$typeof === f || R[0] === p);
  }, Z.typeOf = y, Z;
}
var ee = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var es;
function Rm() {
  return es || (es = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, r = 60107, n = 60108, o = 60114, a = 60109, i = 60110, s = 60112, l = 60113, c = 60120, u = 60115, d = 60116, f = 60121, p = 60122, g = 60117, b = 60129, x = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var m = Symbol.for;
      e = m("react.element"), t = m("react.portal"), r = m("react.fragment"), n = m("react.strict_mode"), o = m("react.profiler"), a = m("react.provider"), i = m("react.context"), s = m("react.forward_ref"), l = m("react.suspense"), c = m("react.suspense_list"), u = m("react.memo"), d = m("react.lazy"), f = m("react.block"), p = m("react.server.block"), g = m("react.fundamental"), m("react.scope"), m("react.opaque.id"), b = m("react.debug_trace_mode"), m("react.offscreen"), x = m("react.legacy_hidden");
    }
    var y = !1;
    function C(O) {
      return !!(typeof O == "string" || typeof O == "function" || O === r || O === o || O === b || O === n || O === l || O === c || O === x || y || typeof O == "object" && O !== null && (O.$$typeof === d || O.$$typeof === u || O.$$typeof === a || O.$$typeof === i || O.$$typeof === s || O.$$typeof === g || O.$$typeof === f || O[0] === p));
    }
    function E(O) {
      if (typeof O == "object" && O !== null) {
        var _e = O.$$typeof;
        switch (_e) {
          case e:
            var He = O.type;
            switch (He) {
              case r:
              case o:
              case n:
              case l:
              case c:
                return He;
              default:
                var Vt = He && He.$$typeof;
                switch (Vt) {
                  case i:
                  case s:
                  case d:
                  case u:
                  case a:
                    return Vt;
                  default:
                    return _e;
                }
            }
          case t:
            return _e;
        }
      }
    }
    var k = i, S = a, _ = e, P = s, D = r, z = d, q = u, I = t, R = o, L = n, M = l, $ = !1, G = !1;
    function be(O) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Y(O) {
      return G || (G = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Q(O) {
      return E(O) === i;
    }
    function ye(O) {
      return E(O) === a;
    }
    function fe(O) {
      return typeof O == "object" && O !== null && O.$$typeof === e;
    }
    function et(O) {
      return E(O) === s;
    }
    function oe(O) {
      return E(O) === r;
    }
    function at(O) {
      return E(O) === d;
    }
    function De(O) {
      return E(O) === u;
    }
    function Ge(O) {
      return E(O) === t;
    }
    function Ne(O) {
      return E(O) === o;
    }
    function Pe(O) {
      return E(O) === n;
    }
    function Fe(O) {
      return E(O) === l;
    }
    ee.ContextConsumer = k, ee.ContextProvider = S, ee.Element = _, ee.ForwardRef = P, ee.Fragment = D, ee.Lazy = z, ee.Memo = q, ee.Portal = I, ee.Profiler = R, ee.StrictMode = L, ee.Suspense = M, ee.isAsyncMode = be, ee.isConcurrentMode = Y, ee.isContextConsumer = Q, ee.isContextProvider = ye, ee.isElement = fe, ee.isForwardRef = et, ee.isFragment = oe, ee.isLazy = at, ee.isMemo = De, ee.isPortal = Ge, ee.isProfiler = Ne, ee.isStrictMode = Pe, ee.isSuspense = Fe, ee.isValidElementType = C, ee.typeOf = E;
  }()), ee;
}
process.env.NODE_ENV === "production" ? Xo.exports = Tm() : Xo.exports = Rm();
var Nm = Xo.exports;
function Pm(e) {
  process.env.NODE_ENV === "development" && typeof e == "object" && !Nm.isValidElementType(e) && console.error(`@fluentui/react-jsx-runtime:
Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: ${e}.

If this happened in a slot of Fluent UI component, you might be facing package resolution issues.
Please make sure you don't have multiple versions of "@fluentui/react-utilities" installed in your dependencies or sub-dependencies.
You can check this by searching up for matching entries in a lockfile produced by your package manager (yarn.lock, pnpm-lock.yaml or package-lock.json).`);
}
function Im(e, t) {
  return function(n, o, a, i, s) {
    return Yo(o) ? t(km(n, o), null, a, i, s) : Yo(n) ? t(n, o, a, i, s) : (Pm(n), e(n, o, a, i, s));
  };
}
function Om(e) {
  const s = e, { as: t, [$t]: r, [qo]: n } = s, a = La(s, ["as", Jn($t), Jn(qo)]), i = typeof r == "string" && t != null ? t : r;
  return typeof i != "string" && t && (a.as = t), {
    elementType: i,
    props: a,
    renderFunction: n
  };
}
const Qo = wc, Am = (e, t, r) => {
  const { elementType: n, renderFunction: o, props: a } = Om(e), i = kt(kt({}, a), t);
  return o ? Qo.jsx(h.Fragment, {
    children: o(n, i)
  }, r) : Qo.jsx(n, i, r);
}, ts = Im(Qo.jsx, Am), Dm = (e) => (Ko(e), /* @__PURE__ */ ts(e.root, {
  children: e.root.children !== void 0 && /* @__PURE__ */ ts(e.wrapper, {
    children: e.root.children
  })
})), Lm = (e, t) => {
  const { alignContent: r = "center", appearance: n = "default", inset: o = !1, vertical: a = !1, wrapper: i } = e, s = Em("divider-");
  return {
    // Props passed at the top-level
    alignContent: r,
    appearance: n,
    inset: o,
    vertical: a,
    // Slots definition
    components: {
      root: "div",
      wrapper: "div"
    },
    root: Go(bm("div", Mr(kt({
      role: "separator",
      "aria-orientation": a ? "vertical" : "horizontal",
      "aria-labelledby": e.children ? s : void 0
    }, e), {
      // FIXME:
      // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
      // but since it would be a breaking change to fix it, we are casting ref to it's proper type
      ref: t
    })), {
      elementType: "div"
    }),
    wrapper: Go(i, {
      defaultProps: {
        id: s,
        children: e.children
      },
      elementType: "div"
    })
  };
}, rs = {
  root: "fui-Divider",
  wrapper: "fui-Divider__wrapper"
}, Bm = /* @__PURE__ */ xa({
  base: {
    Bt984gj: "f122n59",
    B7ck84d: "f1ewtqcl",
    mc9l5x: "f22iagw",
    Beiy3e4: "f1063pyq",
    Bh6795r: "fqerorx",
    qhf8xq: "f10pi13n",
    Bahqtrf: "fk6fouc",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "figsok6",
    Bg96gwp: "fwrc4pm",
    fsow6f: "f17mccla",
    Bcvre1j: "fyl8oag",
    Br0sdwz: "f16vkdww",
    Bn78ew0: "fhsnbul",
    li1rpt: "f1gw3sf2",
    ap17g6: "f1ly5f7u",
    B771hl4: "f1s3tz6t"
  },
  childless: {
    susq4k: "f1kyqvp9",
    Bicfajf: ["fzynn9s", "f1z0ukd1"],
    jwcpgy: ["fekrn8e", "ftdg338"],
    B4rk6o: "fesgyo"
  },
  start: {
    Bsft5z2: "f13zj6fq"
  },
  center: {
    Ftih45: "f1wl9k8s",
    Bsft5z2: "f13zj6fq"
  },
  end: {
    Ftih45: "f1wl9k8s"
  },
  brand: {
    sj55zd: "f16muhyy",
    Bq4z7u6: "fcbuu2a",
    Bk5zm6e: ["f1wdw2dr", "f1ttio3w"],
    Bqjgrrk: "f1582fpk",
    Bm6vgfq: ["f1ttio3w", "f1wdw2dr"],
    B0n5ga8: "f1ahrvm8",
    s924m2: ["f1cd3wbc", "f17hbk9y"],
    B1q35kw: "fvrapl0",
    Gp14am: ["f17hbk9y", "f1cd3wbc"]
  },
  default: {
    sj55zd: "fkfq4zb",
    Bq4z7u6: "f1vccso1",
    Bk5zm6e: ["f1geml7w", "fjml6kk"],
    Bqjgrrk: "f1r7kh1m",
    Bm6vgfq: ["fjml6kk", "f1geml7w"],
    B0n5ga8: "f16j7guv",
    s924m2: ["fx01ahm", "fj1a37q"],
    B1q35kw: "fl8d8yv",
    Gp14am: ["fj1a37q", "fx01ahm"]
  },
  subtle: {
    sj55zd: "f11d4kpn",
    Bq4z7u6: "f5g06un",
    Bk5zm6e: ["f13sxdku", "f1n015lb"],
    Bqjgrrk: "f1x6bl8t",
    Bm6vgfq: ["f1n015lb", "f13sxdku"],
    B0n5ga8: "fvod1wy",
    s924m2: ["fwslg65", "flk0e17"],
    B1q35kw: "f103fvts",
    Gp14am: ["flk0e17", "fwslg65"]
  },
  strong: {
    sj55zd: "f19n0e5",
    Bq4z7u6: "f10tv6oz",
    Bk5zm6e: ["f16xp3sf", "f1seuxxq"],
    Bqjgrrk: "fwrmqbx",
    Bm6vgfq: ["f1seuxxq", "f16xp3sf"],
    B0n5ga8: "ft83z1f",
    s924m2: ["f1g4150c", "f192dr6e"],
    B1q35kw: "f1qnawh6",
    Gp14am: ["f192dr6e", "f1g4150c"]
  }
}, {
  d: [".f122n59{align-items:center;}", ".f1ewtqcl{box-sizing:border-box;}", ".f22iagw{display:flex;}", ".f1063pyq{flex-direction:row;}", ".fqerorx{flex-grow:1;}", ".f10pi13n{position:relative;}", ".fk6fouc{font-family:var(--fontFamilyBase);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}", ".f17mccla{text-align:center;}", ".fyl8oag::before{box-sizing:border-box;}", ".f16vkdww::before{display:flex;}", ".fhsnbul::before{flex-grow:1;}", ".f1gw3sf2::after{box-sizing:border-box;}", ".f1ly5f7u::after{display:flex;}", ".f1s3tz6t::after{flex-grow:1;}", ".f1kyqvp9::before{margin-bottom:0;}", ".fzynn9s::before{margin-right:0;}", ".f1z0ukd1::before{margin-left:0;}", ".fekrn8e::after{margin-left:0;}", ".ftdg338::after{margin-right:0;}", ".fesgyo::after{margin-top:0;}", '.f13zj6fq::after{content:"";}', '.f1wl9k8s::before{content:"";}', ".f16muhyy{color:var(--colorBrandForeground1);}", ".fcbuu2a::before{border-top-color:var(--colorBrandStroke1);}", ".f1wdw2dr::before{border-right-color:var(--colorBrandStroke1);}", ".f1ttio3w::before{border-left-color:var(--colorBrandStroke1);}", ".f1582fpk::before{border-bottom-color:var(--colorBrandStroke1);}", ".f1ahrvm8::after{border-top-color:var(--colorBrandStroke1);}", ".f1cd3wbc::after{border-right-color:var(--colorBrandStroke1);}", ".f17hbk9y::after{border-left-color:var(--colorBrandStroke1);}", ".fvrapl0::after{border-bottom-color:var(--colorBrandStroke1);}", ".fkfq4zb{color:var(--colorNeutralForeground2);}", ".f1vccso1::before{border-top-color:var(--colorNeutralStroke2);}", ".f1geml7w::before{border-right-color:var(--colorNeutralStroke2);}", ".fjml6kk::before{border-left-color:var(--colorNeutralStroke2);}", ".f1r7kh1m::before{border-bottom-color:var(--colorNeutralStroke2);}", ".f16j7guv::after{border-top-color:var(--colorNeutralStroke2);}", ".fx01ahm::after{border-right-color:var(--colorNeutralStroke2);}", ".fj1a37q::after{border-left-color:var(--colorNeutralStroke2);}", ".fl8d8yv::after{border-bottom-color:var(--colorNeutralStroke2);}", ".f11d4kpn{color:var(--colorNeutralForeground3);}", ".f5g06un::before{border-top-color:var(--colorNeutralStroke3);}", ".f13sxdku::before{border-right-color:var(--colorNeutralStroke3);}", ".f1n015lb::before{border-left-color:var(--colorNeutralStroke3);}", ".f1x6bl8t::before{border-bottom-color:var(--colorNeutralStroke3);}", ".fvod1wy::after{border-top-color:var(--colorNeutralStroke3);}", ".fwslg65::after{border-right-color:var(--colorNeutralStroke3);}", ".flk0e17::after{border-left-color:var(--colorNeutralStroke3);}", ".f103fvts::after{border-bottom-color:var(--colorNeutralStroke3);}", ".f19n0e5{color:var(--colorNeutralForeground1);}", ".f10tv6oz::before{border-top-color:var(--colorNeutralStroke1);}", ".f16xp3sf::before{border-right-color:var(--colorNeutralStroke1);}", ".f1seuxxq::before{border-left-color:var(--colorNeutralStroke1);}", ".fwrmqbx::before{border-bottom-color:var(--colorNeutralStroke1);}", ".ft83z1f::after{border-top-color:var(--colorNeutralStroke1);}", ".f1g4150c::after{border-right-color:var(--colorNeutralStroke1);}", ".f192dr6e::after{border-left-color:var(--colorNeutralStroke1);}", ".f1qnawh6::after{border-bottom-color:var(--colorNeutralStroke1);}"]
}), Mm = /* @__PURE__ */ xa({
  base: {
    a9b677: "fly5x3f",
    Bdkvgpv: "f163fonl",
    B0qfbqy: "f51yk4v",
    pbipgd: "f13rof3u",
    Bm2nyyq: "f8rth92",
    xrcqlc: "f6czdpx",
    i5u598: "f1iyka9k"
  },
  inset: {
    uwmqm3: ["fjlbh76", "f11qrl6u"],
    z189sj: ["f11qrl6u", "fjlbh76"]
  },
  start: {
    Ftih45: "f1wl9k8s",
    Bicfajf: ["f1ojjlep", "fk1kexq"],
    Bxwl2t9: "f1he2m4d",
    jwcpgy: ["f12w1bnb", "f1558wlj"]
  },
  center: {
    Bicfajf: ["f1ojjlep", "fk1kexq"],
    jwcpgy: ["f12w1bnb", "f1558wlj"]
  },
  end: {
    Bicfajf: ["f1ojjlep", "fk1kexq"],
    Bsft5z2: "f13zj6fq",
    jwcpgy: ["f12w1bnb", "f1558wlj"],
    Iy66sp: "f1ayce8x"
  }
}, {
  d: [".fly5x3f{width:100%;}", ".f163fonl::before{border-top-style:solid;}", ".f51yk4v::before{border-top-width:var(--strokeWidthThin);}", ".f13rof3u::before{min-width:8px;}", ".f8rth92::after{border-top-style:solid;}", ".f6czdpx::after{border-top-width:var(--strokeWidthThin);}", ".f1iyka9k::after{min-width:8px;}", ".fjlbh76{padding-left:12px;}", ".f11qrl6u{padding-right:12px;}", '.f1wl9k8s::before{content:"";}', ".f1ojjlep::before{margin-right:12px;}", ".fk1kexq::before{margin-left:12px;}", ".f1he2m4d::before{max-width:8px;}", ".f12w1bnb::after{margin-left:12px;}", ".f1558wlj::after{margin-right:12px;}", '.f13zj6fq::after{content:"";}', ".f1ayce8x::after{max-width:8px;}"]
}), jm = /* @__PURE__ */ xa({
  base: {
    Beiy3e4: "f1vx9l62",
    sshi5w: "f16gbxbe",
    m598lv: ["f1yq6w5o", "f1jpmc5p"],
    B4f6apu: ["f9sc749", "f1x8pvcy"],
    zkzzav: "fhkwbjy",
    Barhvk9: ["flthirb", "ftkbnf5"],
    Ihftqj: ["f13hvwk3", "f1en4csx"],
    Bde111x: "f19onpk6"
  },
  inset: {
    B6of3ja: "f1xdg43u",
    jrapky: "f1jlhsmd"
  },
  withChildren: {
    sshi5w: "f1tjaq3g"
  },
  start: {
    Ftih45: "f1wl9k8s",
    susq4k: "fg2pwug",
    Bbdr6tz: "fkjtzyi",
    B4rk6o: "f8vk40g"
  },
  center: {
    susq4k: "fg2pwug",
    B4rk6o: "f8vk40g"
  },
  end: {
    susq4k: "fg2pwug",
    Bsft5z2: "f13zj6fq",
    B4rk6o: "f8vk40g",
    gn64ia: "fqg5mu5"
  }
}, {
  d: [".f1vx9l62{flex-direction:column;}", ".f16gbxbe{min-height:20px;}", ".f1yq6w5o::before{border-right-style:solid;}", ".f1jpmc5p::before{border-left-style:solid;}", ".f9sc749::before{border-right-width:var(--strokeWidthThin);}", ".f1x8pvcy::before{border-left-width:var(--strokeWidthThin);}", ".fhkwbjy::before{min-height:8px;}", ".flthirb::after{border-right-style:solid;}", ".ftkbnf5::after{border-left-style:solid;}", ".f13hvwk3::after{border-right-width:var(--strokeWidthThin);}", ".f1en4csx::after{border-left-width:var(--strokeWidthThin);}", ".f19onpk6::after{min-height:8px;}", ".f1xdg43u{margin-top:12px;}", ".f1jlhsmd{margin-bottom:12px;}", ".f1tjaq3g{min-height:84px;}", '.f1wl9k8s::before{content:"";}', ".fg2pwug::before{margin-bottom:12px;}", ".fkjtzyi::before{max-height:8px;}", ".f8vk40g::after{margin-top:12px;}", '.f13zj6fq::after{content:"";}', ".fqg5mu5::after{max-height:8px;}"]
}), Fm = (e) => {
  const t = Bm(), r = Mm(), n = jm(), {
    alignContent: o,
    appearance: a,
    inset: i,
    vertical: s
  } = e;
  return e.root.className = Yi(
    rs.root,
    // Base styles
    t.base,
    t[o],
    a && t[a],
    // Horizontal styles
    !s && r.base,
    !s && i && r.inset,
    !s && r[o],
    // Vertical styles
    s && n.base,
    s && i && n.inset,
    s && n[o],
    s && e.root.children !== void 0 && n.withChildren,
    // Childless styles
    e.root.children === void 0 && t.childless,
    // User provided class name
    e.root.className
  ), e.wrapper && (e.wrapper.className = Yi(rs.wrapper, e.wrapper.className)), e;
}, Ul = /* @__PURE__ */ h.forwardRef((e, t) => {
  const r = Lm(e, t);
  return Fm(r), Sm("useDividerStyles_unstable")(r), Dm(r);
});
Ul.displayName = "Divider";
const Hm = V(Ul)`
  margin: 8px 0;
  padding-inline: 0;
  color: lightgrey !important;
  opacity: 0.3;
`, w0 = () => /* @__PURE__ */ B.jsx(Hm, { inset: !0 }), $m = V.div`
  display: flex;
  flex-direction: column; 
  align-items: center; 
  width: 100%;
`, Vm = V.div`
  display: flex;
  align-items: center; 
  justify-content: center; 
  width: 100%;
  margin-bottom: 10px; 
`, zm = V(cr)`
  color: #3D3A3B;
  font-size: 14px;
  font-weight: 600;
`, Wm = V.div`
  display: flex;
  margin-top: 14px;
  margin-left: auto;
  width: 210px;
  position: relative;
  right: -14px;
`, Um = V.div`
  position: relative;
  flex: 1 1 100%;
  padding-block: 10px 0;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  color: #707070;
  position: relative;

  &::before,
  &::after {
    position: absolute;
    content: '';
    bottom: 100%;
    height: 2px;
    background: #D9D9D9;
    width: 50%;
    transform: translateY(50%);
    z-index: 0;
  }

  &::before {
    left: 0;
  }

  &::after {
    right: 0;
  }

  &:first-child::before,
  &:last-child::after {
    display: none;
  }
`, qm = V.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`, Gm = V.span`
  font-size: 12px;
`, Ym = V.div`
  position: absolute;
  bottom: 100%;
  transform: translateY(50%);
  inset-inline: 0;
  width: ${({ active: e }) => e ? "18px" : "14px"};
  height: ${({ active: e }) => e ? "18px" : "14px"};
  border-radius: 50%;
  background: ${({ active: e }) => e ? "#ffffff" : "#D9D9D9"};
  box-shadow: ${({ active: e }) => e ? "0 1px 4px rgba(0,0,0,.5)" : "none"};
  margin: 0 auto;
  z-index: 1;
`, S0 = ({ steps: e = [], onChangeRadius: t, selectedIndex: r }) => {
  const [n, o] = Jo(r), a = (i) => {
    o(i), t && e[i] && t(e[i].value);
  };
  return /* @__PURE__ */ B.jsx($m, { children: /* @__PURE__ */ B.jsxs(Vm, { children: [
    /* @__PURE__ */ B.jsx(zm, { children: "Radius" }),
    /* @__PURE__ */ B.jsx(Wm, { children: e.map((i, s) => /* @__PURE__ */ B.jsxs(Um, { onClick: () => a(s), "data-step": s, children: [
      /* @__PURE__ */ B.jsx(Ym, { active: n === s }),
      /* @__PURE__ */ B.jsx(qm, { children: /* @__PURE__ */ B.jsx(Gm, { children: i.label }) })
    ] }, s)) })
  ] }) });
}, Km = V.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0px 8px 0px;
  align-items: center;
  width: 283px;
  height: 73px;
  top: 51px;
  left: 12px;
  background-color: #f8f8f8;
  border-radius: 8px;
`, Xm = V.select`
  width: 270px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid grey;
  padding: 8px 12px 8px 12px;
`, k0 = ({ options: e, onSelect: t }) => {
  const r = (n) => {
    const o = n.target.value;
    t(o);
  };
  return /* @__PURE__ */ B.jsx(B.Fragment, { children: /* @__PURE__ */ B.jsxs(Km, { children: [
    /* @__PURE__ */ B.jsx(As, { text: "Presets" }),
    /* @__PURE__ */ B.jsxs(Xm, { onChange: r, children: [
      /* @__PURE__ */ B.jsx("option", { value: "", children: "Select a preset" }),
      e.map((n, o) => /* @__PURE__ */ B.jsx("option", { value: n, children: n }, o))
    ] })
  ] }) });
};
var ql = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, ns = ke.createContext && /* @__PURE__ */ ke.createContext(ql), Qm = ["attr", "size", "title"];
function Jm(e, t) {
  if (e == null)
    return {};
  var r = Zm(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Zm(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), o, a;
  for (a = 0; a < n.length; a++)
    o = n[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function Rn() {
  return Rn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Rn.apply(this, arguments);
}
function os(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Nn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? os(Object(r), !0).forEach(function(n) {
      e0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : os(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function e0(e, t, r) {
  return t = t0(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function t0(e) {
  var t = r0(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function r0(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Gl(e) {
  return e && e.map((t, r) => /* @__PURE__ */ ke.createElement(t.tag, Nn({
    key: r
  }, t.attr), Gl(t.child)));
}
function n0(e) {
  return (t) => /* @__PURE__ */ ke.createElement(o0, Rn({
    attr: Nn({}, e.attr)
  }, t), Gl(e.child));
}
function o0(e) {
  var t = (r) => {
    var {
      attr: n,
      size: o,
      title: a
    } = e, i = Jm(e, Qm), s = o || r.size || "1em", l;
    return r.className && (l = r.className), e.className && (l = (l ? l + " " : "") + e.className), /* @__PURE__ */ ke.createElement("svg", Rn({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, r.attr, n, i, {
      className: l,
      style: Nn(Nn({
        color: e.color || r.color
      }, r.style), e.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), a && /* @__PURE__ */ ke.createElement("title", null, a), e.children);
  };
  return ns !== void 0 ? /* @__PURE__ */ ke.createElement(ns.Consumer, null, (r) => t(r)) : t(ql);
}
function Yl(e) {
  return n0({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z" }, child: [] }] })(e);
}
const a0 = V.div`
  width: 70px;
  height: 60px;
  background-color: #f0e9e9;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px;
  border: 2px solid transparent;
  box-shadow: 0px 1px 2px rgba(3, 7, 18, 0.04), 0px 2px 8px rgba(3, 7, 18, 0.08);

  &:hover {
    transform: scale(1.025);
  }

  ${(e) => e.isSelected && aa`
      border: 2px solid #512da8;
    `}
    
`, i0 = V.div`
  font-size: 14px;
`, s0 = V.div`
  display: flex;
  gap: 5px;
  justify-content: center;
  margin-block: 5px;
`, as = V.div`
  width: 1009%;
  height: 40px;
  background-color: ${(e) => e.color};
  border-radius: 4px;
`, l0 = V.div`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  background: #512da8;
  border: 2px solid white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  color: white;
`, c0 = ({
  onClick: e,
  isSelected: t
}) => /* @__PURE__ */ B.jsxs(a0, { onClick: e, isSelected: t, children: [
  /* @__PURE__ */ B.jsx(i0, { children: "Cards" }),
  /* @__PURE__ */ B.jsxs(s0, { children: [
    t && /* @__PURE__ */ B.jsxs(l0, { children: [
      " ",
      /* @__PURE__ */ B.jsx(Yl, {}),
      " "
    ] }),
    /* @__PURE__ */ B.jsx(as, { color: "#a89de0" }),
    /* @__PURE__ */ B.jsx(as, { color: "#a89de0" })
  ] })
] }), u0 = V.div`
  width: 70px;
  height: 60px;
  background-color: #f0e9e9;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px;
  border: 2px solid transparent;
  box-shadow: 0px 1px 2px rgba(3, 7, 18, 0.04), 0px 2px 8px rgba(3, 7, 18, 0.08);

  &:hover {
    transform: scale(1.025);
  }

  ${(e) => e.isSelected && aa`
      border: 2px solid #512da8;
    `}
`, d0 = V.div`
  font-size: 14px;
`, f0 = V.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center; 
  margin-block: 5px; 
`, is = V.div`
  width: 100%;
  height: 18px;
  background-color: ${(e) => e.color};
  border-radius: 4px;
`, h0 = V.div`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  background: #512da8;
  border: 2px solid white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  color: white;
`, v0 = ({
  onClick: e,
  isSelected: t
}) => /* @__PURE__ */ B.jsxs(u0, { onClick: e, isSelected: t, children: [
  /* @__PURE__ */ B.jsx(d0, { children: "List" }),
  /* @__PURE__ */ B.jsxs(f0, { children: [
    t && /* @__PURE__ */ B.jsxs(h0, { children: [
      " ",
      /* @__PURE__ */ B.jsx(Yl, {}),
      " "
    ] }),
    /* @__PURE__ */ B.jsx(is, { color: "#a89de0" }),
    /* @__PURE__ */ B.jsx(is, { color: "#a89de0" })
  ] })
] }), p0 = V.div`
  display: flex;
  flex-direction: column;
`, g0 = V.div`
  display: flex;
  flex-direction: row;
  gap: 14px;
  padding-block: 8px;
  align-items: flex-start;
`, m0 = V.div`
`, T0 = ({
  label: e,
  onItemShapeChanged: t,
  itemShape: r
}) => {
  const [n, o] = Jo(r), a = (i) => {
    o(i), t(i);
  };
  return /* @__PURE__ */ B.jsxs(p0, { children: [
    /* @__PURE__ */ B.jsx(As, { text: "Shape and Color" }),
    /* @__PURE__ */ B.jsx(m0, { children: /* @__PURE__ */ B.jsx(cr, { children: e }) }),
    /* @__PURE__ */ B.jsxs(g0, { children: [
      /* @__PURE__ */ B.jsx(c0, { onClick: () => a("card"), isSelected: n === "card" }),
      /* @__PURE__ */ B.jsx(v0, { onClick: () => a("list"), isSelected: n === "list" })
    ] })
  ] });
}, b0 = V.div`
  display: flex;
  flex-direction: row; 
  align-items: center;

  > * {
    margin: 0;
  }

  button {
    background-color: #CCCCCC;
    border-color: transparent;
    height: 18px;
    width: 32px;

    &[aria-checked="true"] {
      background-color: #512da8;
    }
    
    .ms-Toggle-thumb,
    &:hover .ms-Toggle-thumb {
      background-color: #fff;
      transition: all 0.3s ease-in-out;
      width: 10px;
      height: 10px;
    }
  }
`, y0 = V.label`
  color: #3D3A3B;
  font-size: 14px;
  font-weight: 600;
`, _0 = V(tg)`
  margin-left: auto;
`, R0 = ({ label: e, onToggleChecked: t, toggleChecked: r }) => {
  const [n, o] = Jo(r), a = (i, s) => {
    o(s), t && t(s || !1);
  };
  return /* @__PURE__ */ B.jsxs(b0, { children: [
    /* @__PURE__ */ B.jsx(y0, { children: e }),
    /* @__PURE__ */ B.jsx(
      _0,
      {
        onChange: a,
        checked: n
      }
    )
  ] });
};
export {
  S0 as BorderRadius,
  R0 as CustomPropertyPaneToggle,
  w0 as DividerLine,
  T0 as ItemShape,
  k0 as PresetDropdown,
  E0 as PropertyPaneColorPicker,
  As as Title
};
//# sourceMappingURL=index.es.js.map
